/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthHomeRouteImport } from './routes/_auth/home'
import { Route as AuthInboxRouteImport } from './routes/_auth/inbox'
import { Route as AuthInternalRouteImport } from './routes/_auth/internal'
import { Route as AuthReportingRouteImport } from './routes/_auth/reporting'
import { Route as AuthSetupRouteImport } from './routes/_auth/setup'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as LoginOrgNameRouteImport } from './routes/login/$orgName'
import { Route as AuthAllocationIndexRouteImport } from './routes/_auth/allocation/index'
import { Route as AuthAllocationLayoutRouteImport } from './routes/_auth/allocation/_layout'
import { Route as AuthBudgetsLayoutRouteImport } from './routes/_auth/budgets/_layout'
import { Route as AuthCollectionManagementIndexRouteImport } from './routes/_auth/collection-management/index'
import { Route as AuthDataValidationIndexRouteImport } from './routes/_auth/data-validation/index'
import { Route as AuthDemandPlanningIndexRouteImport } from './routes/_auth/demand-planning/index'
import { Route as AuthDemandLayoutRouteImport } from './routes/_auth/demand/_layout'
import { Route as AuthForecastingIndexRouteImport } from './routes/_auth/forecasting/index'
import { Route as AuthForecastingLayoutRouteImport } from './routes/_auth/forecasting/_layout'
import { Route as AuthIngestionCockpitLayoutRouteImport } from './routes/_auth/ingestion-cockpit/_layout'
import { Route as AuthInsightsIndexRouteImport } from './routes/_auth/insights/index'
import { Route as AuthInsightsAvailabilityRouteImport } from './routes/_auth/insights/availability'
import { Route as AuthInsightsCustomerInsightsRouteImport } from './routes/_auth/insights/customer-insights'
import { Route as AuthInsightsForecastCalendarRouteImport } from './routes/_auth/insights/forecast-calendar'
import { Route as AuthInsightsStudioRouteImport } from './routes/_auth/insights/studio'
import { Route as AuthInternalOthersRouteImport } from './routes/_auth/internal/others'
import { Route as AuthInternalTvRouteImport } from './routes/_auth/internal/tv'
import { Route as AuthMarketStrategyIndexRouteImport } from './routes/_auth/market-strategy/index'
import { Route as AuthProcurementIndexRouteImport } from './routes/_auth/procurement/index'
import { Route as AuthProductManagementIndexRouteImport } from './routes/_auth/product-management/index'
import { Route as AuthProductManagementLayoutRouteImport } from './routes/_auth/product-management/_layout'
import { Route as AuthPrototypeIndexRouteImport } from './routes/_auth/prototype/index'
import { Route as AuthSettingsIndexRouteImport } from './routes/_auth/settings/index'
import { Route as AuthSettingsLayoutRouteImport } from './routes/_auth/settings/_layout'
import { Route as AuthSettingsCompanyRouteImport } from './routes/_auth/settings/company'
import { Route as AuthSettingsPurchaseOrdersRouteImport } from './routes/_auth/settings/purchase-orders'
import { Route as AuthSettingsReturnsRouteImport } from './routes/_auth/settings/returns'
import { Route as AuthSetupSplatRouteImport } from './routes/_auth/setup/$'
import { Route as AuthAllocationLayoutReplenishmentRouteImport } from './routes/_auth/allocation/_layout/replenishment'
import { Route as AuthAllocationLayoutReportsRouteImport } from './routes/_auth/allocation/_layout/reports'
import { Route as AuthAllocationLayoutSettingsRouteImport } from './routes/_auth/allocation/_layout/settings'
import { Route as AuthBudgetsLayoutIndexRouteImport } from './routes/_auth/budgets/_layout/index'
import { Route as AuthBudgetsLayoutFiscalYearRouteRouteImport } from './routes/_auth/budgets/_layout/$fiscalYear/route'
import { Route as AuthBudgetsLayoutTimelineRouteImport } from './routes/_auth/budgets/_layout/timeline'
import { Route as AuthDemandPlanningFashionIndexRouteImport } from './routes/_auth/demand-planning/fashion/index'
import { Route as AuthDemandPlanningFashionLayoutRouteImport } from './routes/_auth/demand-planning/fashion/_layout'
import { Route as AuthDemandPlanningNoosIndexRouteImport } from './routes/_auth/demand-planning/noos/index'
import { Route as AuthDemandPlanningNoosLayoutRouteImport } from './routes/_auth/demand-planning/noos/_layout'
import { Route as AuthDemandLayoutIndexRouteImport } from './routes/_auth/demand/_layout/index'
import { Route as AuthDemandLayoutCalendarRouteImport } from './routes/_auth/demand/_layout/calendar'
import { Route as AuthDemandLayoutPerformanceRouteImport } from './routes/_auth/demand/_layout/performance'
import { Route as AuthDemandLayoutSalesAndDemandRouteImport } from './routes/_auth/demand/_layout/sales-and-demand'
import { Route as AuthIngestionCockpitLayoutIndexRouteImport } from './routes/_auth/ingestion-cockpit/_layout/index'
import { Route as AuthIngestionCockpitLayoutDataChecksRouteImport } from './routes/_auth/ingestion-cockpit/_layout/data-checks'
import { Route as AuthIngestionCockpitLayoutDataQualityRouteImport } from './routes/_auth/ingestion-cockpit/_layout/data-quality'
import { Route as AuthIngestionCockpitLayoutViewsRouteImport } from './routes/_auth/ingestion-cockpit/_layout/views'
import { Route as AuthInsightsInventoryOverviewLayoutRouteImport } from './routes/_auth/insights/inventory-overview/_layout'
import { Route as AuthInsightsStudioIndexRouteImport } from './routes/_auth/insights/studio.index'
import { Route as AuthInsightsStudioReportIdRouteImport } from './routes/_auth/insights/studio.$reportId'
import { Route as AuthInternalCustomerManagementLayoutRouteImport } from './routes/_auth/internal/customer-management/_layout'
import { Route as AuthInternalCustomerSuccessLayoutRouteImport } from './routes/_auth/internal/customer-success/_layout'
import { Route as AuthInternalDesignSystemIndexRouteImport } from './routes/_auth/internal/design-system/index'
import { Route as AuthInternalDesignSystemGraphsRouteImport } from './routes/_auth/internal/design-system/graphs'
import { Route as AuthInternalDevelopmentChartsRouteImport } from './routes/_auth/internal/development/charts'
import { Route as AuthInternalDevelopmentComponentsRouteImport } from './routes/_auth/internal/development/components'
import { Route as AuthInternalDocsLayoutRouteImport } from './routes/_auth/internal/docs/_layout'
import { Route as AuthInternalFeatureFlagsOverviewRouteImport } from './routes/_auth/internal/feature-flags/_overview'
import { Route as AuthInternalForecastsForecastValidationCheckRouteImport } from './routes/_auth/internal/forecasts/forecast-validation-check'
import { Route as AuthInternalForecastsForecastingReportsRouteImport } from './routes/_auth/internal/forecasts/forecasting-reports'
import { Route as AuthInternalStatusIndexRouteImport } from './routes/_auth/internal/status/index'
import { Route as AuthProcurementIncomingOrdersIndexRouteImport } from './routes/_auth/procurement/incoming-orders/index'
import { Route as AuthProcurementIncomingOrdersLayoutRouteImport } from './routes/_auth/procurement/incoming-orders/_layout'
import { Route as AuthProcurementOrderSuggestionsIndexRouteImport } from './routes/_auth/procurement/order-suggestions/index'
import { Route as AuthProcurementOrderSuggestionsLayoutRouteImport } from './routes/_auth/procurement/order-suggestions/_layout'
import { Route as AuthProcurementPurchaseOrdersIndexRouteImport } from './routes/_auth/procurement/purchase-orders/index'
import { Route as AuthProcurementPurchaseOrdersLayoutRouteImport } from './routes/_auth/procurement/purchase-orders/_layout'
import { Route as AuthProcurementPurchaseOrdersCreateRouteImport } from './routes/_auth/procurement/purchase-orders/create'
import { Route as AuthProcurementSupplyPlanIndexRouteImport } from './routes/_auth/procurement/supply-plan/index'
import { Route as AuthProcurementVendorManagementIndexRouteImport } from './routes/_auth/procurement/vendor-management/index'
import { Route as AuthProcurementVendorManagementVendorIdRouteImport } from './routes/_auth/procurement/vendor-management/$vendorId'
import { Route as AuthProcurementVendorManagementLayoutRouteImport } from './routes/_auth/procurement/vendor-management/_layout'
import { Route as AuthProductManagementLayoutActiveRouteImport } from './routes/_auth/product-management/_layout/active'
import { Route as AuthProductManagementLayoutGhostVariantsRouteImport } from './routes/_auth/product-management/_layout/ghost-variants'
import { Route as AuthProductManagementLayoutHiddenRouteImport } from './routes/_auth/product-management/_layout/hidden'
import { Route as AuthProductManagementLayoutInactiveRouteImport } from './routes/_auth/product-management/_layout/inactive'
import { Route as AuthProductManagementLayoutInboxRouteImport } from './routes/_auth/product-management/_layout/inbox'
import { Route as AuthProductManagementLayoutLinkedVariantsRouteImport } from './routes/_auth/product-management/_layout/linked-variants'
import { Route as AuthProductManagementLayoutNeedsAttentionRouteImport } from './routes/_auth/product-management/_layout/needs-attention'
import { Route as AuthProductManagementLayoutPhasedOutRouteImport } from './routes/_auth/product-management/_layout/phased-out'
import { Route as AuthProductManagementLayoutPhasingOutRouteImport } from './routes/_auth/product-management/_layout/phasing-out'
import { Route as AuthProductManagementLayoutSuggestedActivationsRouteImport } from './routes/_auth/product-management/_layout/suggested-activations'
import { Route as AuthProductProductIdLayoutRouteImport } from './routes/_auth/product/$productId/_layout'
import { Route as AuthPrototypeAllocationPlanningSplatRouteImport } from './routes/_auth/prototype/allocation-planning/$'
import { Route as AuthPrototypeSeasonsCollectionsIndexRouteImport } from './routes/_auth/prototype/seasons-collections/index'
import { Route as AuthSettingsLayoutInternalRouteImport } from './routes/_auth/settings/_layout/_internal'
import { Route as AuthSettingsLayoutAiRouteImport } from './routes/_auth/settings/_layout/ai'
import { Route as AuthSettingsLayoutChannelsRouteImport } from './routes/_auth/settings/_layout/channels'
import { Route as AuthSettingsLayoutCustomDataRouteImport } from './routes/_auth/settings/_layout/custom-data'
import { Route as AuthSettingsLayoutDemandRouteImport } from './routes/_auth/settings/_layout/demand'
import { Route as AuthSettingsLayoutErpRouteImport } from './routes/_auth/settings/_layout/erp'
import { Route as AuthSettingsLayoutGeneralRouteImport } from './routes/_auth/settings/_layout/general'
import { Route as AuthSettingsLayoutProcurementRouteImport } from './routes/_auth/settings/_layout/procurement'
import { Route as AuthSettingsLayoutRulesRouteImport } from './routes/_auth/settings/_layout/rules'
import { Route as AuthSettingsLayoutTeamsRouteImport } from './routes/_auth/settings/_layout/teams'
import { Route as AuthSettingsLayoutUsersRouteImport } from './routes/_auth/settings/_layout/users'
import { Route as AuthAllocationLayoutReportsIndexRouteImport } from './routes/_auth/allocation/_layout/reports/index'
import { Route as AuthAllocationLayoutReportsProductsRouteImport } from './routes/_auth/allocation/_layout/reports/products'
import { Route as AuthAllocationLayoutReportsStoresRouteImport } from './routes/_auth/allocation/_layout/reports/stores'
import { Route as AuthAllocationLayoutSettingsIndexRouteImport } from './routes/_auth/allocation/_layout/settings/index'
import { Route as AuthAllocationLayoutSettingsSubTabRouteImport } from './routes/_auth/allocation/_layout/settings/$subTab'
import { Route as AuthBudgetsLayoutFiscalYearLayoutRouteImport } from './routes/_auth/budgets/_layout/$fiscalYear/_layout'
import { Route as AuthBudgetsLayoutYearYearRouteImport } from './routes/_auth/budgets/_layout/year.$year'
import { Route as AuthDemandPlanningFashionCollectionIdLayoutRouteImport } from './routes/_auth/demand-planning/fashion/$collectionId/_layout'
import { Route as AuthDemandPlanningFashionLayoutTasksRouteImport } from './routes/_auth/demand-planning/fashion/_layout/tasks'
import { Route as AuthDemandPlanningFashionLayoutTimelineRouteImport } from './routes/_auth/demand-planning/fashion/_layout/timeline'
import { Route as AuthDemandPlanningNoosCollectionIdLayoutRouteImport } from './routes/_auth/demand-planning/noos/$collectionId/_layout'
import { Route as AuthDemandPlanningNoosLayoutTasksRouteImport } from './routes/_auth/demand-planning/noos/_layout/tasks'
import { Route as AuthDemandPlanningNoosLayoutTimelineRouteImport } from './routes/_auth/demand-planning/noos/_layout/timeline'
import { Route as AuthDemandFashionCollectionIdLayoutRouteImport } from './routes/_auth/demand/fashion/$collectionId/_layout'
import { Route as AuthDemandNoosCollectionIdLayoutRouteImport } from './routes/_auth/demand/noos/$collectionId/_layout'
import { Route as AuthIngestionCockpitLayoutDataQualityIndexRouteImport } from './routes/_auth/ingestion-cockpit/_layout/data-quality/index'
import { Route as AuthIngestionCockpitLayoutDataQualityCheckIdRouteImport } from './routes/_auth/ingestion-cockpit/_layout/data-quality/$checkId'
import { Route as AuthInsightsInventoryOverviewLayoutIndexRouteImport } from './routes/_auth/insights/inventory-overview/_layout/index'
import { Route as AuthInsightsInventoryOverviewLayoutCalendarRouteImport } from './routes/_auth/insights/inventory-overview/_layout/calendar'
import { Route as AuthInternalCustomerManagementLayoutIndexRouteImport } from './routes/_auth/internal/customer-management/_layout/index'
import { Route as AuthInternalCustomerManagementLayoutOrganizationsRouteImport } from './routes/_auth/internal/customer-management/_layout/organizations'
import { Route as AuthInternalCustomerManagementLayoutUsersRouteImport } from './routes/_auth/internal/customer-management/_layout/users'
import { Route as AuthInternalCustomerSuccessLayoutIndexRouteImport } from './routes/_auth/internal/customer-success/_layout/index'
import { Route as AuthInternalCustomerSuccessLayoutHakiUsageRouteImport } from './routes/_auth/internal/customer-success/_layout/haki-usage'
import { Route as AuthInternalCustomerSuccessLayoutImpactRouteImport } from './routes/_auth/internal/customer-success/_layout/impact'
import { Route as AuthInternalCustomerSuccessLayoutUserActivityRouteImport } from './routes/_auth/internal/customer-success/_layout/user-activity'
import { Route as AuthInternalDesignSystemComponentsBadgesRouteImport } from './routes/_auth/internal/design-system/components/badges'
import { Route as AuthInternalDesignSystemComponentsBaselineSourceCardRouteImport } from './routes/_auth/internal/design-system/components/baseline-source-card'
import { Route as AuthInternalDesignSystemComponentsButtonGroupRouteImport } from './routes/_auth/internal/design-system/components/button-group'
import { Route as AuthInternalDesignSystemComponentsButtonsRouteImport } from './routes/_auth/internal/design-system/components/buttons'
import { Route as AuthInternalDesignSystemComponentsCheckboxesRouteImport } from './routes/_auth/internal/design-system/components/checkboxes'
import { Route as AuthInternalDesignSystemComponentsCodeBlockRouteImport } from './routes/_auth/internal/design-system/components/code-block'
import { Route as AuthInternalDesignSystemComponentsCommandBarRouteImport } from './routes/_auth/internal/design-system/components/command-bar'
import { Route as AuthInternalDesignSystemComponentsDatePickerRouteImport } from './routes/_auth/internal/design-system/components/date-picker'
import { Route as AuthInternalDesignSystemComponentsEmptyStateRouteImport } from './routes/_auth/internal/design-system/components/empty-state'
import { Route as AuthInternalDesignSystemComponentsExpandableCardRouteImport } from './routes/_auth/internal/design-system/components/expandable-card'
import { Route as AuthInternalDesignSystemComponentsIconToolbarRouteImport } from './routes/_auth/internal/design-system/components/icon-toolbar'
import { Route as AuthInternalDesignSystemComponentsInlineAlertRouteImport } from './routes/_auth/internal/design-system/components/inline-alert'
import { Route as AuthInternalDesignSystemComponentsLinkButtonRouteImport } from './routes/_auth/internal/design-system/components/link-button'
import { Route as AuthInternalDesignSystemComponentsMatrixRouteImport } from './routes/_auth/internal/design-system/components/matrix'
import { Route as AuthInternalDesignSystemComponentsMessageScrollerRouteImport } from './routes/_auth/internal/design-system/components/message-scroller'
import { Route as AuthInternalDesignSystemComponentsProgressBarRouteImport } from './routes/_auth/internal/design-system/components/progress-bar'
import { Route as AuthInternalDesignSystemComponentsRadiosRouteImport } from './routes/_auth/internal/design-system/components/radios'
import { Route as AuthInternalDesignSystemComponentsSectionCardRouteImport } from './routes/_auth/internal/design-system/components/section-card'
import { Route as AuthInternalDesignSystemComponentsSelectRouteImport } from './routes/_auth/internal/design-system/components/select'
import { Route as AuthInternalDesignSystemComponentsStatTileRouteImport } from './routes/_auth/internal/design-system/components/stat-tile'
import { Route as AuthInternalDesignSystemComponentsSwitchesRouteImport } from './routes/_auth/internal/design-system/components/switches'
import { Route as AuthInternalDesignSystemComponentsTextInputRouteImport } from './routes/_auth/internal/design-system/components/text-input'
import { Route as AuthInternalDesignSystemComponentsTextareaRouteImport } from './routes/_auth/internal/design-system/components/textarea'
import { Route as AuthInternalDesignSystemComponentsToastRouteImport } from './routes/_auth/internal/design-system/components/toast'
import { Route as AuthInternalDesignSystemComponentsTraceRouteImport } from './routes/_auth/internal/design-system/components/trace'
import { Route as AuthInternalDesignSystemComponentsViewPillRouteImport } from './routes/_auth/internal/design-system/components/view-pill'
import { Route as AuthInternalDesignSystemLegacyComponentsSlugRouteImport } from './routes/_auth/internal/design-system/legacy-components/$slug'
import { Route as AuthInternalDesignSystemPagesInspectorRouteImport } from './routes/_auth/internal/design-system/pages/inspector'
import { Route as AuthInternalDesignSystemPagesPagesRouteImport } from './routes/_auth/internal/design-system/pages/pages'
import { Route as AuthInternalDesignSystemStylesColorTokensRouteImport } from './routes/_auth/internal/design-system/styles/color-tokens'
import { Route as AuthInternalDesignSystemStylesTextStylesRouteImport } from './routes/_auth/internal/design-system/styles/text-styles'
import { Route as AuthInternalDocsLayoutIndexRouteImport } from './routes/_auth/internal/docs/_layout/index'
import { Route as AuthInternalDocsLayoutSlugRouteImport } from './routes/_auth/internal/docs/_layout/$slug'
import { Route as AuthInternalFeatureFlagsFlagKeyLayoutRouteImport } from './routes/_auth/internal/feature-flags/$flagKey/_layout'
import { Route as AuthInternalFeatureFlagsOverviewIndexRouteImport } from './routes/_auth/internal/feature-flags/_overview/index'
import { Route as AuthInternalFeatureFlagsOverviewHistoryRouteImport } from './routes/_auth/internal/feature-flags/_overview/history'
import { Route as AuthProcurementIncomingOrdersLayoutCalendarRouteImport } from './routes/_auth/procurement/incoming-orders/_layout/calendar'
import { Route as AuthProcurementIncomingOrdersLayoutListRouteImport } from './routes/_auth/procurement/incoming-orders/_layout/list'
import { Route as AuthProcurementIncomingOrdersLayoutOverviewRouteImport } from './routes/_auth/procurement/incoming-orders/_layout/overview'
import { Route as AuthProcurementOrderSuggestionsLayoutReplenishmentSuggestionsRouteImport } from './routes/_auth/procurement/order-suggestions/_layout/replenishment-suggestions'
import { Route as AuthProcurementPurchaseOrdersLayoutArchivedRouteImport } from './routes/_auth/procurement/purchase-orders/_layout/archived'
import { Route as AuthProcurementPurchaseOrdersLayoutClosedRouteImport } from './routes/_auth/procurement/purchase-orders/_layout/closed'
import { Route as AuthProcurementPurchaseOrdersLayoutDraftRouteImport } from './routes/_auth/procurement/purchase-orders/_layout/draft'
import { Route as AuthProcurementPurchaseOrdersLayoutOpenRouteImport } from './routes/_auth/procurement/purchase-orders/_layout/open'
import { Route as AuthProcurementPurchaseOrdersUpdatePurchaseOrderIdRouteImport } from './routes/_auth/procurement/purchase-orders/update/$purchaseOrderId'
import { Route as AuthProcurementSupplyPlanPurchasePlanIdLayoutRouteImport } from './routes/_auth/procurement/supply-plan/$purchasePlanId/_layout'
import { Route as AuthProcurementVendorManagementLayoutCapacityRouteImport } from './routes/_auth/procurement/vendor-management/_layout/capacity'
import { Route as AuthProcurementVendorManagementLayoutVendorsRouteImport } from './routes/_auth/procurement/vendor-management/_layout/vendors'
import { Route as AuthProductProductIdLayoutIndexRouteImport } from './routes/_auth/product/$productId/_layout/index'
import { Route as AuthProductProductIdLayoutDemandRouteImport } from './routes/_auth/product/$productId/_layout/demand'
import { Route as AuthProductProductIdLayoutFinanceRouteImport } from './routes/_auth/product/$productId/_layout/finance'
import { Route as AuthProductProductIdLayoutForecastRouteImport } from './routes/_auth/product/$productId/_layout/forecast'
import { Route as AuthProductProductIdLayoutForecastAnalysisRouteImport } from './routes/_auth/product/$productId/_layout/forecast-analysis'
import { Route as AuthProductProductIdLayoutInventoryRouteImport } from './routes/_auth/product/$productId/_layout/inventory'
import { Route as AuthProductProductIdLayoutOverviewRouteImport } from './routes/_auth/product/$productId/_layout/overview'
import { Route as AuthProductProductIdLayoutPerformanceRouteImport } from './routes/_auth/product/$productId/_layout/performance'
import { Route as AuthSettingsLayoutInternalAlertsRouteImport } from './routes/_auth/settings/_layout/_internal/alerts'
import { Route as AuthSettingsLayoutInternalDemoRouteImport } from './routes/_auth/settings/_layout/_internal/demo'
import { Route as AuthSettingsLayoutInternalHakioRouteImport } from './routes/_auth/settings/_layout/_internal/hakio'
import { Route as AuthSettingsLayoutInternalMatchConfigurationRouteImport } from './routes/_auth/settings/_layout/_internal/match-configuration'
import { Route as AuthSettingsLayoutInternalNamingRouteImport } from './routes/_auth/settings/_layout/_internal/naming'
import { Route as AuthBudgetsLayoutFiscalYearBudgetIdLayoutRouteImport } from './routes/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout'
import { Route as AuthBudgetsLayoutFiscalYearLayoutIndexRouteImport } from './routes/_auth/budgets/_layout/$fiscalYear/_layout/index'
import { Route as AuthBudgetsLayoutFiscalYearLayoutBreakdownRouteImport } from './routes/_auth/budgets/_layout/$fiscalYear/_layout/breakdown'
import { Route as AuthBudgetsLayoutFiscalYearLayoutCollectionsRouteImport } from './routes/_auth/budgets/_layout/$fiscalYear/_layout/collections'
import { Route as AuthDemandPlanningFashionCollectionIdLayoutIndexRouteImport } from './routes/_auth/demand-planning/fashion/$collectionId/_layout/index'
import { Route as AuthDemandPlanningFashionCollectionIdLayoutAnalysisRouteImport } from './routes/_auth/demand-planning/fashion/$collectionId/_layout/analysis'
import { Route as AuthDemandPlanningFashionCollectionIdLayoutCustomersRouteImport } from './routes/_auth/demand-planning/fashion/$collectionId/_layout/customers'
import { Route as AuthDemandPlanningFashionCollectionIdLayoutDemandRouteImport } from './routes/_auth/demand-planning/fashion/$collectionId/_layout/demand'
import { Route as AuthDemandPlanningFashionCollectionIdLayoutPerformanceRouteImport } from './routes/_auth/demand-planning/fashion/$collectionId/_layout/performance'
import { Route as AuthDemandPlanningFashionCollectionIdLayoutSeasonalityRouteImport } from './routes/_auth/demand-planning/fashion/$collectionId/_layout/seasonality'
import { Route as AuthDemandPlanningFashionCollectionIdLayoutSplitsRouteImport } from './routes/_auth/demand-planning/fashion/$collectionId/_layout/splits'
import { Route as AuthDemandPlanningFashionCollectionIdLayoutTrimRouteImport } from './routes/_auth/demand-planning/fashion/$collectionId/_layout/trim'
import { Route as AuthDemandPlanningNoosCollectionIdLayoutIndexRouteImport } from './routes/_auth/demand-planning/noos/$collectionId/_layout/index'
import { Route as AuthDemandPlanningNoosCollectionIdLayoutForecastUpdatesRouteImport } from './routes/_auth/demand-planning/noos/$collectionId/_layout/forecast-updates'
import { Route as AuthDemandPlanningNoosCollectionIdLayoutNewVariantsRouteImport } from './routes/_auth/demand-planning/noos/$collectionId/_layout/new-variants'
import { Route as AuthDemandFashionCollectionIdLayoutIndexRouteImport } from './routes/_auth/demand/fashion/$collectionId/_layout/index'
import { Route as AuthDemandFashionCollectionIdLayoutBudgetRouteImport } from './routes/_auth/demand/fashion/$collectionId/_layout/budget'
import { Route as AuthDemandFashionCollectionIdLayoutDemandRouteImport } from './routes/_auth/demand/fashion/$collectionId/_layout/demand'
import { Route as AuthDemandFashionCollectionIdLayoutPerformanceRouteImport } from './routes/_auth/demand/fashion/$collectionId/_layout/performance'
import { Route as AuthDemandFashionCollectionIdLayoutVariantsRouteImport } from './routes/_auth/demand/fashion/$collectionId/_layout/variants'
import { Route as AuthDemandNoosCollectionIdLayoutIndexRouteImport } from './routes/_auth/demand/noos/$collectionId/_layout/index'
import { Route as AuthDemandNoosCollectionIdLayoutBudgetRouteImport } from './routes/_auth/demand/noos/$collectionId/_layout/budget'
import { Route as AuthDemandNoosCollectionIdLayoutDemandRouteImport } from './routes/_auth/demand/noos/$collectionId/_layout/demand'
import { Route as AuthDemandNoosCollectionIdLayoutPerformanceRouteImport } from './routes/_auth/demand/noos/$collectionId/_layout/performance'
import { Route as AuthDemandNoosCollectionIdLayoutVariantsRouteImport } from './routes/_auth/demand/noos/$collectionId/_layout/variants'
import { Route as AuthInternalFeatureFlagsFlagKeyLayoutIndexRouteImport } from './routes/_auth/internal/feature-flags/$flagKey/_layout/index'
import { Route as AuthInternalFeatureFlagsFlagKeyLayoutHistoryRouteImport } from './routes/_auth/internal/feature-flags/$flagKey/_layout/history'
import { Route as AuthInternalFeatureFlagsFlagKeyLayoutUsersRouteImport } from './routes/_auth/internal/feature-flags/$flagKey/_layout/users'
import { Route as AuthProcurementSupplyPlanPurchasePlanIdLayoutIndexRouteImport } from './routes/_auth/procurement/supply-plan/$purchasePlanId/_layout/index'
import { Route as AuthProcurementSupplyPlanPurchasePlanIdLayoutCapacityRouteImport } from './routes/_auth/procurement/supply-plan/$purchasePlanId/_layout/capacity'
import { Route as AuthProcurementSupplyPlanPurchasePlanIdLayoutGreigeRouteImport } from './routes/_auth/procurement/supply-plan/$purchasePlanId/_layout/greige'
import { Route as AuthProcurementSupplyPlanPurchasePlanIdLayoutQuantitiesRouteImport } from './routes/_auth/procurement/supply-plan/$purchasePlanId/_layout/quantities'
import { Route as AuthProcurementSupplyPlanCollectionCollectionIdLayoutRouteImport } from './routes/_auth/procurement/supply-plan/collection/$collectionId/_layout'
import { Route as AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRouteImport } from './routes/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout'
import { Route as AuthBudgetsLayoutFiscalYearBudgetIdLayoutIndexRouteImport } from './routes/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/index'
import { Route as AuthBudgetsLayoutFiscalYearBudgetIdLayoutAllocationPlanningRouteImport } from './routes/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/allocation-planning'
import { Route as AuthBudgetsLayoutFiscalYearBudgetIdLayoutMarkdownPlanningRouteImport } from './routes/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/markdown-planning'
import { Route as AuthBudgetsLayoutFiscalYearBudgetIdLayoutSalesPricesRouteImport } from './routes/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/sales-prices'
import { Route as AuthBudgetsLayoutFiscalYearBudgetIdLayoutTargetRouteImport } from './routes/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/target'
import { Route as AuthBudgetsLayoutFiscalYearBudgetIdLayoutTargetReportRouteImport } from './routes/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/target-report'
import { Route as AuthProcurementSupplyPlanCollectionCollectionIdLayoutIndexRouteImport } from './routes/_auth/procurement/supply-plan/collection/$collectionId/_layout/index'
import { Route as AuthProcurementSupplyPlanCollectionCollectionIdLayoutCapacityRouteImport } from './routes/_auth/procurement/supply-plan/collection/$collectionId/_layout/capacity'
import { Route as AuthProcurementSupplyPlanCollectionCollectionIdLayoutGreigeRouteImport } from './routes/_auth/procurement/supply-plan/collection/$collectionId/_layout/greige'
import { Route as AuthProcurementSupplyPlanCollectionCollectionIdLayoutOverviewRouteImport } from './routes/_auth/procurement/supply-plan/collection/$collectionId/_layout/overview'
import { Route as AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutIndexRouteImport } from './routes/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/index'
import { Route as AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutAvailabilityRouteImport } from './routes/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/availability'
import { Route as AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutCapacityPlanningRouteImport } from './routes/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/capacity-planning'
import { Route as AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutGreigeRouteImport } from './routes/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/greige'
import { Route as AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutOverviewRouteImport } from './routes/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/overview'
import { Route as AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutTriggersRouteImport } from './routes/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/triggers'
import { Route as AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutRouteImport } from './routes/_auth/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/_layout'
import { Route as AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutIndexRouteImport } from './routes/_auth/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/_layout/index'
import { Route as AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutCapacityRouteImport } from './routes/_auth/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/_layout/capacity'
import { Route as AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutQuantitiesRouteImport } from './routes/_auth/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/_layout/quantities'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHomeRoute = AuthHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInboxRoute = AuthInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInternalRoute = AuthInternalRouteImport.update({
  id: '/internal',
  path: '/internal',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReportingRoute = AuthReportingRouteImport.update({
  id: '/reporting',
  path: '/reporting',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSetupRoute = AuthSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AuthRoute,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginOrgNameRoute = LoginOrgNameRouteImport.update({
  id: '/login/$orgName',
  path: '/login/$orgName',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAllocationIndexRoute = AuthAllocationIndexRouteImport.update({
  id: '/allocation/',
  path: '/allocation/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAllocationLayoutRoute = AuthAllocationLayoutRouteImport.update({
  id: '/allocation/_layout',
  path: '/allocation',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBudgetsLayoutRoute = AuthBudgetsLayoutRouteImport.update({
  id: '/budgets/_layout',
  path: '/budgets',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCollectionManagementIndexRoute =
  AuthCollectionManagementIndexRouteImport.update({
    id: '/collection-management/',
    path: '/collection-management/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDataValidationIndexRoute = AuthDataValidationIndexRouteImport.update({
  id: '/data-validation/',
  path: '/data-validation/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDemandPlanningIndexRoute = AuthDemandPlanningIndexRouteImport.update({
  id: '/demand-planning/',
  path: '/demand-planning/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDemandLayoutRoute = AuthDemandLayoutRouteImport.update({
  id: '/demand/_layout',
  path: '/demand',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForecastingIndexRoute = AuthForecastingIndexRouteImport.update({
  id: '/forecasting/',
  path: '/forecasting/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForecastingLayoutRoute = AuthForecastingLayoutRouteImport.update({
  id: '/forecasting/_layout',
  path: '/forecasting',
  getParentRoute: () => AuthRoute,
} as any)
const AuthIngestionCockpitLayoutRoute =
  AuthIngestionCockpitLayoutRouteImport.update({
    id: '/ingestion-cockpit/_layout',
    path: '/ingestion-cockpit',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthInsightsIndexRoute = AuthInsightsIndexRouteImport.update({
  id: '/insights/',
  path: '/insights/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInsightsAvailabilityRoute =
  AuthInsightsAvailabilityRouteImport.update({
    id: '/insights/availability',
    path: '/insights/availability',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthInsightsCustomerInsightsRoute =
  AuthInsightsCustomerInsightsRouteImport.update({
    id: '/insights/customer-insights',
    path: '/insights/customer-insights',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthInsightsForecastCalendarRoute =
  AuthInsightsForecastCalendarRouteImport.update({
    id: '/insights/forecast-calendar',
    path: '/insights/forecast-calendar',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthInsightsStudioRoute = AuthInsightsStudioRouteImport.update({
  id: '/insights/studio',
  path: '/insights/studio',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInternalOthersRoute = AuthInternalOthersRouteImport.update({
  id: '/others',
  path: '/others',
  getParentRoute: () => AuthInternalRoute,
} as any)
const AuthInternalTvRoute = AuthInternalTvRouteImport.update({
  id: '/tv',
  path: '/tv',
  getParentRoute: () => AuthInternalRoute,
} as any)
const AuthMarketStrategyIndexRoute = AuthMarketStrategyIndexRouteImport.update({
  id: '/market-strategy/',
  path: '/market-strategy/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProcurementIndexRoute = AuthProcurementIndexRouteImport.update({
  id: '/procurement/',
  path: '/procurement/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProductManagementIndexRoute =
  AuthProductManagementIndexRouteImport.update({
    id: '/product-management/',
    path: '/product-management/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductManagementLayoutRoute =
  AuthProductManagementLayoutRouteImport.update({
    id: '/product-management/_layout',
    path: '/product-management',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPrototypeIndexRoute = AuthPrototypeIndexRouteImport.update({
  id: '/prototype/',
  path: '/prototype/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsIndexRoute = AuthSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsLayoutRoute = AuthSettingsLayoutRouteImport.update({
  id: '/settings/_layout',
  path: '/settings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsCompanyRoute = AuthSettingsCompanyRouteImport.update({
  id: '/settings/company',
  path: '/settings/company',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsPurchaseOrdersRoute =
  AuthSettingsPurchaseOrdersRouteImport.update({
    id: '/settings/purchase-orders',
    path: '/settings/purchase-orders',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsReturnsRoute = AuthSettingsReturnsRouteImport.update({
  id: '/settings/returns',
  path: '/settings/returns',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSetupSplatRoute = AuthSetupSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthSetupRoute,
} as any)
const AuthAllocationLayoutReplenishmentRoute =
  AuthAllocationLayoutReplenishmentRouteImport.update({
    id: '/replenishment',
    path: '/replenishment',
    getParentRoute: () => AuthAllocationLayoutRoute,
  } as any)
const AuthAllocationLayoutReportsRoute =
  AuthAllocationLayoutReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AuthAllocationLayoutRoute,
  } as any)
const AuthAllocationLayoutSettingsRoute =
  AuthAllocationLayoutSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthAllocationLayoutRoute,
  } as any)
const AuthBudgetsLayoutIndexRoute = AuthBudgetsLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthBudgetsLayoutRoute,
} as any)
const AuthBudgetsLayoutFiscalYearRouteRoute =
  AuthBudgetsLayoutFiscalYearRouteRouteImport.update({
    id: '/$fiscalYear',
    path: '/$fiscalYear',
    getParentRoute: () => AuthBudgetsLayoutRoute,
  } as any)
const AuthBudgetsLayoutTimelineRoute =
  AuthBudgetsLayoutTimelineRouteImport.update({
    id: '/timeline',
    path: '/timeline',
    getParentRoute: () => AuthBudgetsLayoutRoute,
  } as any)
const AuthDemandPlanningFashionIndexRoute =
  AuthDemandPlanningFashionIndexRouteImport.update({
    id: '/demand-planning/fashion/',
    path: '/demand-planning/fashion/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDemandPlanningFashionLayoutRoute =
  AuthDemandPlanningFashionLayoutRouteImport.update({
    id: '/demand-planning/fashion/_layout',
    path: '/demand-planning/fashion',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDemandPlanningNoosIndexRoute =
  AuthDemandPlanningNoosIndexRouteImport.update({
    id: '/demand-planning/noos/',
    path: '/demand-planning/noos/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDemandPlanningNoosLayoutRoute =
  AuthDemandPlanningNoosLayoutRouteImport.update({
    id: '/demand-planning/noos/_layout',
    path: '/demand-planning/noos',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDemandLayoutIndexRoute = AuthDemandLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthDemandLayoutRoute,
} as any)
const AuthDemandLayoutCalendarRoute =
  AuthDemandLayoutCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => AuthDemandLayoutRoute,
  } as any)
const AuthDemandLayoutPerformanceRoute =
  AuthDemandLayoutPerformanceRouteImport.update({
    id: '/performance',
    path: '/performance',
    getParentRoute: () => AuthDemandLayoutRoute,
  } as any)
const AuthDemandLayoutSalesAndDemandRoute =
  AuthDemandLayoutSalesAndDemandRouteImport.update({
    id: '/sales-and-demand',
    path: '/sales-and-demand',
    getParentRoute: () => AuthDemandLayoutRoute,
  } as any)
const AuthIngestionCockpitLayoutIndexRoute =
  AuthIngestionCockpitLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthIngestionCockpitLayoutRoute,
  } as any)
const AuthIngestionCockpitLayoutDataChecksRoute =
  AuthIngestionCockpitLayoutDataChecksRouteImport.update({
    id: '/data-checks',
    path: '/data-checks',
    getParentRoute: () => AuthIngestionCockpitLayoutRoute,
  } as any)
const AuthIngestionCockpitLayoutDataQualityRoute =
  AuthIngestionCockpitLayoutDataQualityRouteImport.update({
    id: '/data-quality',
    path: '/data-quality',
    getParentRoute: () => AuthIngestionCockpitLayoutRoute,
  } as any)
const AuthIngestionCockpitLayoutViewsRoute =
  AuthIngestionCockpitLayoutViewsRouteImport.update({
    id: '/views',
    path: '/views',
    getParentRoute: () => AuthIngestionCockpitLayoutRoute,
  } as any)
const AuthInsightsInventoryOverviewLayoutRoute =
  AuthInsightsInventoryOverviewLayoutRouteImport.update({
    id: '/insights/inventory-overview/_layout',
    path: '/insights/inventory-overview',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthInsightsStudioIndexRoute = AuthInsightsStudioIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthInsightsStudioRoute,
} as any)
const AuthInsightsStudioReportIdRoute =
  AuthInsightsStudioReportIdRouteImport.update({
    id: '/$reportId',
    path: '/$reportId',
    getParentRoute: () => AuthInsightsStudioRoute,
  } as any)
const AuthInternalCustomerManagementLayoutRoute =
  AuthInternalCustomerManagementLayoutRouteImport.update({
    id: '/customer-management/_layout',
    path: '/customer-management',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalCustomerSuccessLayoutRoute =
  AuthInternalCustomerSuccessLayoutRouteImport.update({
    id: '/customer-success/_layout',
    path: '/customer-success',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemIndexRoute =
  AuthInternalDesignSystemIndexRouteImport.update({
    id: '/design-system/',
    path: '/design-system/',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemGraphsRoute =
  AuthInternalDesignSystemGraphsRouteImport.update({
    id: '/design-system/graphs',
    path: '/design-system/graphs',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDevelopmentChartsRoute =
  AuthInternalDevelopmentChartsRouteImport.update({
    id: '/development/charts',
    path: '/development/charts',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDevelopmentComponentsRoute =
  AuthInternalDevelopmentComponentsRouteImport.update({
    id: '/development/components',
    path: '/development/components',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDocsLayoutRoute = AuthInternalDocsLayoutRouteImport.update({
  id: '/docs/_layout',
  path: '/docs',
  getParentRoute: () => AuthInternalRoute,
} as any)
const AuthInternalFeatureFlagsOverviewRoute =
  AuthInternalFeatureFlagsOverviewRouteImport.update({
    id: '/feature-flags/_overview',
    path: '/feature-flags',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalForecastsForecastValidationCheckRoute =
  AuthInternalForecastsForecastValidationCheckRouteImport.update({
    id: '/forecasts/forecast-validation-check',
    path: '/forecasts/forecast-validation-check',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalForecastsForecastingReportsRoute =
  AuthInternalForecastsForecastingReportsRouteImport.update({
    id: '/forecasts/forecasting-reports',
    path: '/forecasts/forecasting-reports',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalStatusIndexRoute = AuthInternalStatusIndexRouteImport.update({
  id: '/status/',
  path: '/status/',
  getParentRoute: () => AuthInternalRoute,
} as any)
const AuthProcurementIncomingOrdersIndexRoute =
  AuthProcurementIncomingOrdersIndexRouteImport.update({
    id: '/procurement/incoming-orders/',
    path: '/procurement/incoming-orders/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProcurementIncomingOrdersLayoutRoute =
  AuthProcurementIncomingOrdersLayoutRouteImport.update({
    id: '/procurement/incoming-orders/_layout',
    path: '/procurement/incoming-orders',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProcurementOrderSuggestionsIndexRoute =
  AuthProcurementOrderSuggestionsIndexRouteImport.update({
    id: '/procurement/order-suggestions/',
    path: '/procurement/order-suggestions/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProcurementOrderSuggestionsLayoutRoute =
  AuthProcurementOrderSuggestionsLayoutRouteImport.update({
    id: '/procurement/order-suggestions/_layout',
    path: '/procurement/order-suggestions',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProcurementPurchaseOrdersIndexRoute =
  AuthProcurementPurchaseOrdersIndexRouteImport.update({
    id: '/procurement/purchase-orders/',
    path: '/procurement/purchase-orders/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProcurementPurchaseOrdersLayoutRoute =
  AuthProcurementPurchaseOrdersLayoutRouteImport.update({
    id: '/procurement/purchase-orders/_layout',
    path: '/procurement/purchase-orders',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProcurementPurchaseOrdersCreateRoute =
  AuthProcurementPurchaseOrdersCreateRouteImport.update({
    id: '/procurement/purchase-orders/create',
    path: '/procurement/purchase-orders/create',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProcurementSupplyPlanIndexRoute =
  AuthProcurementSupplyPlanIndexRouteImport.update({
    id: '/procurement/supply-plan/',
    path: '/procurement/supply-plan/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProcurementVendorManagementIndexRoute =
  AuthProcurementVendorManagementIndexRouteImport.update({
    id: '/procurement/vendor-management/',
    path: '/procurement/vendor-management/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProcurementVendorManagementVendorIdRoute =
  AuthProcurementVendorManagementVendorIdRouteImport.update({
    id: '/procurement/vendor-management/$vendorId',
    path: '/procurement/vendor-management/$vendorId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProcurementVendorManagementLayoutRoute =
  AuthProcurementVendorManagementLayoutRouteImport.update({
    id: '/procurement/vendor-management/_layout',
    path: '/procurement/vendor-management',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductManagementLayoutActiveRoute =
  AuthProductManagementLayoutActiveRouteImport.update({
    id: '/active',
    path: '/active',
    getParentRoute: () => AuthProductManagementLayoutRoute,
  } as any)
const AuthProductManagementLayoutGhostVariantsRoute =
  AuthProductManagementLayoutGhostVariantsRouteImport.update({
    id: '/ghost-variants',
    path: '/ghost-variants',
    getParentRoute: () => AuthProductManagementLayoutRoute,
  } as any)
const AuthProductManagementLayoutHiddenRoute =
  AuthProductManagementLayoutHiddenRouteImport.update({
    id: '/hidden',
    path: '/hidden',
    getParentRoute: () => AuthProductManagementLayoutRoute,
  } as any)
const AuthProductManagementLayoutInactiveRoute =
  AuthProductManagementLayoutInactiveRouteImport.update({
    id: '/inactive',
    path: '/inactive',
    getParentRoute: () => AuthProductManagementLayoutRoute,
  } as any)
const AuthProductManagementLayoutInboxRoute =
  AuthProductManagementLayoutInboxRouteImport.update({
    id: '/inbox',
    path: '/inbox',
    getParentRoute: () => AuthProductManagementLayoutRoute,
  } as any)
const AuthProductManagementLayoutLinkedVariantsRoute =
  AuthProductManagementLayoutLinkedVariantsRouteImport.update({
    id: '/linked-variants',
    path: '/linked-variants',
    getParentRoute: () => AuthProductManagementLayoutRoute,
  } as any)
const AuthProductManagementLayoutNeedsAttentionRoute =
  AuthProductManagementLayoutNeedsAttentionRouteImport.update({
    id: '/needs-attention',
    path: '/needs-attention',
    getParentRoute: () => AuthProductManagementLayoutRoute,
  } as any)
const AuthProductManagementLayoutPhasedOutRoute =
  AuthProductManagementLayoutPhasedOutRouteImport.update({
    id: '/phased-out',
    path: '/phased-out',
    getParentRoute: () => AuthProductManagementLayoutRoute,
  } as any)
const AuthProductManagementLayoutPhasingOutRoute =
  AuthProductManagementLayoutPhasingOutRouteImport.update({
    id: '/phasing-out',
    path: '/phasing-out',
    getParentRoute: () => AuthProductManagementLayoutRoute,
  } as any)
const AuthProductManagementLayoutSuggestedActivationsRoute =
  AuthProductManagementLayoutSuggestedActivationsRouteImport.update({
    id: '/suggested-activations',
    path: '/suggested-activations',
    getParentRoute: () => AuthProductManagementLayoutRoute,
  } as any)
const AuthProductProductIdLayoutRoute =
  AuthProductProductIdLayoutRouteImport.update({
    id: '/product/$productId/_layout',
    path: '/product/$productId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPrototypeAllocationPlanningSplatRoute =
  AuthPrototypeAllocationPlanningSplatRouteImport.update({
    id: '/prototype/allocation-planning/$',
    path: '/prototype/allocation-planning/$',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPrototypeSeasonsCollectionsIndexRoute =
  AuthPrototypeSeasonsCollectionsIndexRouteImport.update({
    id: '/prototype/seasons-collections/',
    path: '/prototype/seasons-collections/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsLayoutInternalRoute =
  AuthSettingsLayoutInternalRouteImport.update({
    id: '/_internal',
    getParentRoute: () => AuthSettingsLayoutRoute,
  } as any)
const AuthSettingsLayoutAiRoute = AuthSettingsLayoutAiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => AuthSettingsLayoutRoute,
} as any)
const AuthSettingsLayoutChannelsRoute =
  AuthSettingsLayoutChannelsRouteImport.update({
    id: '/channels',
    path: '/channels',
    getParentRoute: () => AuthSettingsLayoutRoute,
  } as any)
const AuthSettingsLayoutCustomDataRoute =
  AuthSettingsLayoutCustomDataRouteImport.update({
    id: '/custom-data',
    path: '/custom-data',
    getParentRoute: () => AuthSettingsLayoutRoute,
  } as any)
const AuthSettingsLayoutDemandRoute =
  AuthSettingsLayoutDemandRouteImport.update({
    id: '/demand',
    path: '/demand',
    getParentRoute: () => AuthSettingsLayoutRoute,
  } as any)
const AuthSettingsLayoutErpRoute = AuthSettingsLayoutErpRouteImport.update({
  id: '/erp',
  path: '/erp',
  getParentRoute: () => AuthSettingsLayoutRoute,
} as any)
const AuthSettingsLayoutGeneralRoute =
  AuthSettingsLayoutGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AuthSettingsLayoutRoute,
  } as any)
const AuthSettingsLayoutProcurementRoute =
  AuthSettingsLayoutProcurementRouteImport.update({
    id: '/procurement',
    path: '/procurement',
    getParentRoute: () => AuthSettingsLayoutRoute,
  } as any)
const AuthSettingsLayoutRulesRoute = AuthSettingsLayoutRulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => AuthSettingsLayoutRoute,
} as any)
const AuthSettingsLayoutTeamsRoute = AuthSettingsLayoutTeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => AuthSettingsLayoutRoute,
} as any)
const AuthSettingsLayoutUsersRoute = AuthSettingsLayoutUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthSettingsLayoutRoute,
} as any)
const AuthAllocationLayoutReportsIndexRoute =
  AuthAllocationLayoutReportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAllocationLayoutReportsRoute,
  } as any)
const AuthAllocationLayoutReportsProductsRoute =
  AuthAllocationLayoutReportsProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => AuthAllocationLayoutReportsRoute,
  } as any)
const AuthAllocationLayoutReportsStoresRoute =
  AuthAllocationLayoutReportsStoresRouteImport.update({
    id: '/stores',
    path: '/stores',
    getParentRoute: () => AuthAllocationLayoutReportsRoute,
  } as any)
const AuthAllocationLayoutSettingsIndexRoute =
  AuthAllocationLayoutSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAllocationLayoutSettingsRoute,
  } as any)
const AuthAllocationLayoutSettingsSubTabRoute =
  AuthAllocationLayoutSettingsSubTabRouteImport.update({
    id: '/$subTab',
    path: '/$subTab',
    getParentRoute: () => AuthAllocationLayoutSettingsRoute,
  } as any)
const AuthBudgetsLayoutFiscalYearLayoutRoute =
  AuthBudgetsLayoutFiscalYearLayoutRouteImport.update({
    id: '/_layout',
    getParentRoute: () => AuthBudgetsLayoutFiscalYearRouteRoute,
  } as any)
const AuthBudgetsLayoutYearYearRoute =
  AuthBudgetsLayoutYearYearRouteImport.update({
    id: '/year/$year',
    path: '/year/$year',
    getParentRoute: () => AuthBudgetsLayoutRoute,
  } as any)
const AuthDemandPlanningFashionCollectionIdLayoutRoute =
  AuthDemandPlanningFashionCollectionIdLayoutRouteImport.update({
    id: '/demand-planning/fashion/$collectionId/_layout',
    path: '/demand-planning/fashion/$collectionId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDemandPlanningFashionLayoutTasksRoute =
  AuthDemandPlanningFashionLayoutTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => AuthDemandPlanningFashionLayoutRoute,
  } as any)
const AuthDemandPlanningFashionLayoutTimelineRoute =
  AuthDemandPlanningFashionLayoutTimelineRouteImport.update({
    id: '/timeline',
    path: '/timeline',
    getParentRoute: () => AuthDemandPlanningFashionLayoutRoute,
  } as any)
const AuthDemandPlanningNoosCollectionIdLayoutRoute =
  AuthDemandPlanningNoosCollectionIdLayoutRouteImport.update({
    id: '/demand-planning/noos/$collectionId/_layout',
    path: '/demand-planning/noos/$collectionId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDemandPlanningNoosLayoutTasksRoute =
  AuthDemandPlanningNoosLayoutTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => AuthDemandPlanningNoosLayoutRoute,
  } as any)
const AuthDemandPlanningNoosLayoutTimelineRoute =
  AuthDemandPlanningNoosLayoutTimelineRouteImport.update({
    id: '/timeline',
    path: '/timeline',
    getParentRoute: () => AuthDemandPlanningNoosLayoutRoute,
  } as any)
const AuthDemandFashionCollectionIdLayoutRoute =
  AuthDemandFashionCollectionIdLayoutRouteImport.update({
    id: '/demand/fashion/$collectionId/_layout',
    path: '/demand/fashion/$collectionId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDemandNoosCollectionIdLayoutRoute =
  AuthDemandNoosCollectionIdLayoutRouteImport.update({
    id: '/demand/noos/$collectionId/_layout',
    path: '/demand/noos/$collectionId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthIngestionCockpitLayoutDataQualityIndexRoute =
  AuthIngestionCockpitLayoutDataQualityIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthIngestionCockpitLayoutDataQualityRoute,
  } as any)
const AuthIngestionCockpitLayoutDataQualityCheckIdRoute =
  AuthIngestionCockpitLayoutDataQualityCheckIdRouteImport.update({
    id: '/$checkId',
    path: '/$checkId',
    getParentRoute: () => AuthIngestionCockpitLayoutDataQualityRoute,
  } as any)
const AuthInsightsInventoryOverviewLayoutIndexRoute =
  AuthInsightsInventoryOverviewLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthInsightsInventoryOverviewLayoutRoute,
  } as any)
const AuthInsightsInventoryOverviewLayoutCalendarRoute =
  AuthInsightsInventoryOverviewLayoutCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => AuthInsightsInventoryOverviewLayoutRoute,
  } as any)
const AuthInternalCustomerManagementLayoutIndexRoute =
  AuthInternalCustomerManagementLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthInternalCustomerManagementLayoutRoute,
  } as any)
const AuthInternalCustomerManagementLayoutOrganizationsRoute =
  AuthInternalCustomerManagementLayoutOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AuthInternalCustomerManagementLayoutRoute,
  } as any)
const AuthInternalCustomerManagementLayoutUsersRoute =
  AuthInternalCustomerManagementLayoutUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthInternalCustomerManagementLayoutRoute,
  } as any)
const AuthInternalCustomerSuccessLayoutIndexRoute =
  AuthInternalCustomerSuccessLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthInternalCustomerSuccessLayoutRoute,
  } as any)
const AuthInternalCustomerSuccessLayoutHakiUsageRoute =
  AuthInternalCustomerSuccessLayoutHakiUsageRouteImport.update({
    id: '/haki-usage',
    path: '/haki-usage',
    getParentRoute: () => AuthInternalCustomerSuccessLayoutRoute,
  } as any)
const AuthInternalCustomerSuccessLayoutImpactRoute =
  AuthInternalCustomerSuccessLayoutImpactRouteImport.update({
    id: '/impact',
    path: '/impact',
    getParentRoute: () => AuthInternalCustomerSuccessLayoutRoute,
  } as any)
const AuthInternalCustomerSuccessLayoutUserActivityRoute =
  AuthInternalCustomerSuccessLayoutUserActivityRouteImport.update({
    id: '/user-activity',
    path: '/user-activity',
    getParentRoute: () => AuthInternalCustomerSuccessLayoutRoute,
  } as any)
const AuthInternalDesignSystemComponentsBadgesRoute =
  AuthInternalDesignSystemComponentsBadgesRouteImport.update({
    id: '/design-system/components/badges',
    path: '/design-system/components/badges',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsBaselineSourceCardRoute =
  AuthInternalDesignSystemComponentsBaselineSourceCardRouteImport.update({
    id: '/design-system/components/baseline-source-card',
    path: '/design-system/components/baseline-source-card',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsButtonGroupRoute =
  AuthInternalDesignSystemComponentsButtonGroupRouteImport.update({
    id: '/design-system/components/button-group',
    path: '/design-system/components/button-group',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsButtonsRoute =
  AuthInternalDesignSystemComponentsButtonsRouteImport.update({
    id: '/design-system/components/buttons',
    path: '/design-system/components/buttons',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsCheckboxesRoute =
  AuthInternalDesignSystemComponentsCheckboxesRouteImport.update({
    id: '/design-system/components/checkboxes',
    path: '/design-system/components/checkboxes',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsCodeBlockRoute =
  AuthInternalDesignSystemComponentsCodeBlockRouteImport.update({
    id: '/design-system/components/code-block',
    path: '/design-system/components/code-block',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsCommandBarRoute =
  AuthInternalDesignSystemComponentsCommandBarRouteImport.update({
    id: '/design-system/components/command-bar',
    path: '/design-system/components/command-bar',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsDatePickerRoute =
  AuthInternalDesignSystemComponentsDatePickerRouteImport.update({
    id: '/design-system/components/date-picker',
    path: '/design-system/components/date-picker',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsEmptyStateRoute =
  AuthInternalDesignSystemComponentsEmptyStateRouteImport.update({
    id: '/design-system/components/empty-state',
    path: '/design-system/components/empty-state',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsExpandableCardRoute =
  AuthInternalDesignSystemComponentsExpandableCardRouteImport.update({
    id: '/design-system/components/expandable-card',
    path: '/design-system/components/expandable-card',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsIconToolbarRoute =
  AuthInternalDesignSystemComponentsIconToolbarRouteImport.update({
    id: '/design-system/components/icon-toolbar',
    path: '/design-system/components/icon-toolbar',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsInlineAlertRoute =
  AuthInternalDesignSystemComponentsInlineAlertRouteImport.update({
    id: '/design-system/components/inline-alert',
    path: '/design-system/components/inline-alert',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsLinkButtonRoute =
  AuthInternalDesignSystemComponentsLinkButtonRouteImport.update({
    id: '/design-system/components/link-button',
    path: '/design-system/components/link-button',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsMatrixRoute =
  AuthInternalDesignSystemComponentsMatrixRouteImport.update({
    id: '/design-system/components/matrix',
    path: '/design-system/components/matrix',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsMessageScrollerRoute =
  AuthInternalDesignSystemComponentsMessageScrollerRouteImport.update({
    id: '/design-system/components/message-scroller',
    path: '/design-system/components/message-scroller',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsProgressBarRoute =
  AuthInternalDesignSystemComponentsProgressBarRouteImport.update({
    id: '/design-system/components/progress-bar',
    path: '/design-system/components/progress-bar',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsRadiosRoute =
  AuthInternalDesignSystemComponentsRadiosRouteImport.update({
    id: '/design-system/components/radios',
    path: '/design-system/components/radios',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsSectionCardRoute =
  AuthInternalDesignSystemComponentsSectionCardRouteImport.update({
    id: '/design-system/components/section-card',
    path: '/design-system/components/section-card',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsSelectRoute =
  AuthInternalDesignSystemComponentsSelectRouteImport.update({
    id: '/design-system/components/select',
    path: '/design-system/components/select',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsStatTileRoute =
  AuthInternalDesignSystemComponentsStatTileRouteImport.update({
    id: '/design-system/components/stat-tile',
    path: '/design-system/components/stat-tile',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsSwitchesRoute =
  AuthInternalDesignSystemComponentsSwitchesRouteImport.update({
    id: '/design-system/components/switches',
    path: '/design-system/components/switches',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsTextInputRoute =
  AuthInternalDesignSystemComponentsTextInputRouteImport.update({
    id: '/design-system/components/text-input',
    path: '/design-system/components/text-input',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsTextareaRoute =
  AuthInternalDesignSystemComponentsTextareaRouteImport.update({
    id: '/design-system/components/textarea',
    path: '/design-system/components/textarea',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsToastRoute =
  AuthInternalDesignSystemComponentsToastRouteImport.update({
    id: '/design-system/components/toast',
    path: '/design-system/components/toast',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsTraceRoute =
  AuthInternalDesignSystemComponentsTraceRouteImport.update({
    id: '/design-system/components/trace',
    path: '/design-system/components/trace',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemComponentsViewPillRoute =
  AuthInternalDesignSystemComponentsViewPillRouteImport.update({
    id: '/design-system/components/view-pill',
    path: '/design-system/components/view-pill',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemLegacyComponentsSlugRoute =
  AuthInternalDesignSystemLegacyComponentsSlugRouteImport.update({
    id: '/design-system/legacy-components/$slug',
    path: '/design-system/legacy-components/$slug',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemPagesInspectorRoute =
  AuthInternalDesignSystemPagesInspectorRouteImport.update({
    id: '/design-system/pages/inspector',
    path: '/design-system/pages/inspector',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemPagesPagesRoute =
  AuthInternalDesignSystemPagesPagesRouteImport.update({
    id: '/design-system/pages/pages',
    path: '/design-system/pages/pages',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemStylesColorTokensRoute =
  AuthInternalDesignSystemStylesColorTokensRouteImport.update({
    id: '/design-system/styles/color-tokens',
    path: '/design-system/styles/color-tokens',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDesignSystemStylesTextStylesRoute =
  AuthInternalDesignSystemStylesTextStylesRouteImport.update({
    id: '/design-system/styles/text-styles',
    path: '/design-system/styles/text-styles',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalDocsLayoutIndexRoute =
  AuthInternalDocsLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthInternalDocsLayoutRoute,
  } as any)
const AuthInternalDocsLayoutSlugRoute =
  AuthInternalDocsLayoutSlugRouteImport.update({
    id: '/$slug',
    path: '/$slug',
    getParentRoute: () => AuthInternalDocsLayoutRoute,
  } as any)
const AuthInternalFeatureFlagsFlagKeyLayoutRoute =
  AuthInternalFeatureFlagsFlagKeyLayoutRouteImport.update({
    id: '/feature-flags/$flagKey/_layout',
    path: '/feature-flags/$flagKey',
    getParentRoute: () => AuthInternalRoute,
  } as any)
const AuthInternalFeatureFlagsOverviewIndexRoute =
  AuthInternalFeatureFlagsOverviewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthInternalFeatureFlagsOverviewRoute,
  } as any)
const AuthInternalFeatureFlagsOverviewHistoryRoute =
  AuthInternalFeatureFlagsOverviewHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => AuthInternalFeatureFlagsOverviewRoute,
  } as any)
const AuthProcurementIncomingOrdersLayoutCalendarRoute =
  AuthProcurementIncomingOrdersLayoutCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => AuthProcurementIncomingOrdersLayoutRoute,
  } as any)
const AuthProcurementIncomingOrdersLayoutListRoute =
  AuthProcurementIncomingOrdersLayoutListRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => AuthProcurementIncomingOrdersLayoutRoute,
  } as any)
const AuthProcurementIncomingOrdersLayoutOverviewRoute =
  AuthProcurementIncomingOrdersLayoutOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthProcurementIncomingOrdersLayoutRoute,
  } as any)
const AuthProcurementOrderSuggestionsLayoutReplenishmentSuggestionsRoute =
  AuthProcurementOrderSuggestionsLayoutReplenishmentSuggestionsRouteImport.update(
    {
      id: '/replenishment-suggestions',
      path: '/replenishment-suggestions',
      getParentRoute: () => AuthProcurementOrderSuggestionsLayoutRoute,
    } as any,
  )
const AuthProcurementPurchaseOrdersLayoutArchivedRoute =
  AuthProcurementPurchaseOrdersLayoutArchivedRouteImport.update({
    id: '/archived',
    path: '/archived',
    getParentRoute: () => AuthProcurementPurchaseOrdersLayoutRoute,
  } as any)
const AuthProcurementPurchaseOrdersLayoutClosedRoute =
  AuthProcurementPurchaseOrdersLayoutClosedRouteImport.update({
    id: '/closed',
    path: '/closed',
    getParentRoute: () => AuthProcurementPurchaseOrdersLayoutRoute,
  } as any)
const AuthProcurementPurchaseOrdersLayoutDraftRoute =
  AuthProcurementPurchaseOrdersLayoutDraftRouteImport.update({
    id: '/draft',
    path: '/draft',
    getParentRoute: () => AuthProcurementPurchaseOrdersLayoutRoute,
  } as any)
const AuthProcurementPurchaseOrdersLayoutOpenRoute =
  AuthProcurementPurchaseOrdersLayoutOpenRouteImport.update({
    id: '/open',
    path: '/open',
    getParentRoute: () => AuthProcurementPurchaseOrdersLayoutRoute,
  } as any)
const AuthProcurementPurchaseOrdersUpdatePurchaseOrderIdRoute =
  AuthProcurementPurchaseOrdersUpdatePurchaseOrderIdRouteImport.update({
    id: '/procurement/purchase-orders/update/$purchaseOrderId',
    path: '/procurement/purchase-orders/update/$purchaseOrderId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProcurementSupplyPlanPurchasePlanIdLayoutRoute =
  AuthProcurementSupplyPlanPurchasePlanIdLayoutRouteImport.update({
    id: '/procurement/supply-plan/$purchasePlanId/_layout',
    path: '/procurement/supply-plan/$purchasePlanId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProcurementVendorManagementLayoutCapacityRoute =
  AuthProcurementVendorManagementLayoutCapacityRouteImport.update({
    id: '/capacity',
    path: '/capacity',
    getParentRoute: () => AuthProcurementVendorManagementLayoutRoute,
  } as any)
const AuthProcurementVendorManagementLayoutVendorsRoute =
  AuthProcurementVendorManagementLayoutVendorsRouteImport.update({
    id: '/vendors',
    path: '/vendors',
    getParentRoute: () => AuthProcurementVendorManagementLayoutRoute,
  } as any)
const AuthProductProductIdLayoutIndexRoute =
  AuthProductProductIdLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthProductProductIdLayoutRoute,
  } as any)
const AuthProductProductIdLayoutDemandRoute =
  AuthProductProductIdLayoutDemandRouteImport.update({
    id: '/demand',
    path: '/demand',
    getParentRoute: () => AuthProductProductIdLayoutRoute,
  } as any)
const AuthProductProductIdLayoutFinanceRoute =
  AuthProductProductIdLayoutFinanceRouteImport.update({
    id: '/finance',
    path: '/finance',
    getParentRoute: () => AuthProductProductIdLayoutRoute,
  } as any)
const AuthProductProductIdLayoutForecastRoute =
  AuthProductProductIdLayoutForecastRouteImport.update({
    id: '/forecast',
    path: '/forecast',
    getParentRoute: () => AuthProductProductIdLayoutRoute,
  } as any)
const AuthProductProductIdLayoutForecastAnalysisRoute =
  AuthProductProductIdLayoutForecastAnalysisRouteImport.update({
    id: '/forecast-analysis',
    path: '/forecast-analysis',
    getParentRoute: () => AuthProductProductIdLayoutRoute,
  } as any)
const AuthProductProductIdLayoutInventoryRoute =
  AuthProductProductIdLayoutInventoryRouteImport.update({
    id: '/inventory',
    path: '/inventory',
    getParentRoute: () => AuthProductProductIdLayoutRoute,
  } as any)
const AuthProductProductIdLayoutOverviewRoute =
  AuthProductProductIdLayoutOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthProductProductIdLayoutRoute,
  } as any)
const AuthProductProductIdLayoutPerformanceRoute =
  AuthProductProductIdLayoutPerformanceRouteImport.update({
    id: '/performance',
    path: '/performance',
    getParentRoute: () => AuthProductProductIdLayoutRoute,
  } as any)
const AuthSettingsLayoutInternalAlertsRoute =
  AuthSettingsLayoutInternalAlertsRouteImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => AuthSettingsLayoutInternalRoute,
  } as any)
const AuthSettingsLayoutInternalDemoRoute =
  AuthSettingsLayoutInternalDemoRouteImport.update({
    id: '/demo',
    path: '/demo',
    getParentRoute: () => AuthSettingsLayoutInternalRoute,
  } as any)
const AuthSettingsLayoutInternalHakioRoute =
  AuthSettingsLayoutInternalHakioRouteImport.update({
    id: '/hakio',
    path: '/hakio',
    getParentRoute: () => AuthSettingsLayoutInternalRoute,
  } as any)
const AuthSettingsLayoutInternalMatchConfigurationRoute =
  AuthSettingsLayoutInternalMatchConfigurationRouteImport.update({
    id: '/match-configuration',
    path: '/match-configuration',
    getParentRoute: () => AuthSettingsLayoutInternalRoute,
  } as any)
const AuthSettingsLayoutInternalNamingRoute =
  AuthSettingsLayoutInternalNamingRouteImport.update({
    id: '/naming',
    path: '/naming',
    getParentRoute: () => AuthSettingsLayoutInternalRoute,
  } as any)
const AuthBudgetsLayoutFiscalYearBudgetIdLayoutRoute =
  AuthBudgetsLayoutFiscalYearBudgetIdLayoutRouteImport.update({
    id: '/$budgetId/_layout',
    path: '/$budgetId',
    getParentRoute: () => AuthBudgetsLayoutFiscalYearRouteRoute,
  } as any)
const AuthBudgetsLayoutFiscalYearLayoutIndexRoute =
  AuthBudgetsLayoutFiscalYearLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthBudgetsLayoutFiscalYearLayoutRoute,
  } as any)
const AuthBudgetsLayoutFiscalYearLayoutBreakdownRoute =
  AuthBudgetsLayoutFiscalYearLayoutBreakdownRouteImport.update({
    id: '/breakdown',
    path: '/breakdown',
    getParentRoute: () => AuthBudgetsLayoutFiscalYearLayoutRoute,
  } as any)
const AuthBudgetsLayoutFiscalYearLayoutCollectionsRoute =
  AuthBudgetsLayoutFiscalYearLayoutCollectionsRouteImport.update({
    id: '/collections',
    path: '/collections',
    getParentRoute: () => AuthBudgetsLayoutFiscalYearLayoutRoute,
  } as any)
const AuthDemandPlanningFashionCollectionIdLayoutIndexRoute =
  AuthDemandPlanningFashionCollectionIdLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthDemandPlanningFashionCollectionIdLayoutRoute,
  } as any)
const AuthDemandPlanningFashionCollectionIdLayoutAnalysisRoute =
  AuthDemandPlanningFashionCollectionIdLayoutAnalysisRouteImport.update({
    id: '/analysis',
    path: '/analysis',
    getParentRoute: () => AuthDemandPlanningFashionCollectionIdLayoutRoute,
  } as any)
const AuthDemandPlanningFashionCollectionIdLayoutCustomersRoute =
  AuthDemandPlanningFashionCollectionIdLayoutCustomersRouteImport.update({
    id: '/customers',
    path: '/customers',
    getParentRoute: () => AuthDemandPlanningFashionCollectionIdLayoutRoute,
  } as any)
const AuthDemandPlanningFashionCollectionIdLayoutDemandRoute =
  AuthDemandPlanningFashionCollectionIdLayoutDemandRouteImport.update({
    id: '/demand',
    path: '/demand',
    getParentRoute: () => AuthDemandPlanningFashionCollectionIdLayoutRoute,
  } as any)
const AuthDemandPlanningFashionCollectionIdLayoutPerformanceRoute =
  AuthDemandPlanningFashionCollectionIdLayoutPerformanceRouteImport.update({
    id: '/performance',
    path: '/performance',
    getParentRoute: () => AuthDemandPlanningFashionCollectionIdLayoutRoute,
  } as any)
const AuthDemandPlanningFashionCollectionIdLayoutSeasonalityRoute =
  AuthDemandPlanningFashionCollectionIdLayoutSeasonalityRouteImport.update({
    id: '/seasonality',
    path: '/seasonality',
    getParentRoute: () => AuthDemandPlanningFashionCollectionIdLayoutRoute,
  } as any)
const AuthDemandPlanningFashionCollectionIdLayoutSplitsRoute =
  AuthDemandPlanningFashionCollectionIdLayoutSplitsRouteImport.update({
    id: '/splits',
    path: '/splits',
    getParentRoute: () => AuthDemandPlanningFashionCollectionIdLayoutRoute,
  } as any)
const AuthDemandPlanningFashionCollectionIdLayoutTrimRoute =
  AuthDemandPlanningFashionCollectionIdLayoutTrimRouteImport.update({
    id: '/trim',
    path: '/trim',
    getParentRoute: () => AuthDemandPlanningFashionCollectionIdLayoutRoute,
  } as any)
const AuthDemandPlanningNoosCollectionIdLayoutIndexRoute =
  AuthDemandPlanningNoosCollectionIdLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthDemandPlanningNoosCollectionIdLayoutRoute,
  } as any)
const AuthDemandPlanningNoosCollectionIdLayoutForecastUpdatesRoute =
  AuthDemandPlanningNoosCollectionIdLayoutForecastUpdatesRouteImport.update({
    id: '/forecast-updates',
    path: '/forecast-updates',
    getParentRoute: () => AuthDemandPlanningNoosCollectionIdLayoutRoute,
  } as any)
const AuthDemandPlanningNoosCollectionIdLayoutNewVariantsRoute =
  AuthDemandPlanningNoosCollectionIdLayoutNewVariantsRouteImport.update({
    id: '/new-variants',
    path: '/new-variants',
    getParentRoute: () => AuthDemandPlanningNoosCollectionIdLayoutRoute,
  } as any)
const AuthDemandFashionCollectionIdLayoutIndexRoute =
  AuthDemandFashionCollectionIdLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthDemandFashionCollectionIdLayoutRoute,
  } as any)
const AuthDemandFashionCollectionIdLayoutBudgetRoute =
  AuthDemandFashionCollectionIdLayoutBudgetRouteImport.update({
    id: '/budget',
    path: '/budget',
    getParentRoute: () => AuthDemandFashionCollectionIdLayoutRoute,
  } as any)
const AuthDemandFashionCollectionIdLayoutDemandRoute =
  AuthDemandFashionCollectionIdLayoutDemandRouteImport.update({
    id: '/demand',
    path: '/demand',
    getParentRoute: () => AuthDemandFashionCollectionIdLayoutRoute,
  } as any)
const AuthDemandFashionCollectionIdLayoutPerformanceRoute =
  AuthDemandFashionCollectionIdLayoutPerformanceRouteImport.update({
    id: '/performance',
    path: '/performance',
    getParentRoute: () => AuthDemandFashionCollectionIdLayoutRoute,
  } as any)
const AuthDemandFashionCollectionIdLayoutVariantsRoute =
  AuthDemandFashionCollectionIdLayoutVariantsRouteImport.update({
    id: '/variants',
    path: '/variants',
    getParentRoute: () => AuthDemandFashionCollectionIdLayoutRoute,
  } as any)
const AuthDemandNoosCollectionIdLayoutIndexRoute =
  AuthDemandNoosCollectionIdLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthDemandNoosCollectionIdLayoutRoute,
  } as any)
const AuthDemandNoosCollectionIdLayoutBudgetRoute =
  AuthDemandNoosCollectionIdLayoutBudgetRouteImport.update({
    id: '/budget',
    path: '/budget',
    getParentRoute: () => AuthDemandNoosCollectionIdLayoutRoute,
  } as any)
const AuthDemandNoosCollectionIdLayoutDemandRoute =
  AuthDemandNoosCollectionIdLayoutDemandRouteImport.update({
    id: '/demand',
    path: '/demand',
    getParentRoute: () => AuthDemandNoosCollectionIdLayoutRoute,
  } as any)
const AuthDemandNoosCollectionIdLayoutPerformanceRoute =
  AuthDemandNoosCollectionIdLayoutPerformanceRouteImport.update({
    id: '/performance',
    path: '/performance',
    getParentRoute: () => AuthDemandNoosCollectionIdLayoutRoute,
  } as any)
const AuthDemandNoosCollectionIdLayoutVariantsRoute =
  AuthDemandNoosCollectionIdLayoutVariantsRouteImport.update({
    id: '/variants',
    path: '/variants',
    getParentRoute: () => AuthDemandNoosCollectionIdLayoutRoute,
  } as any)
const AuthInternalFeatureFlagsFlagKeyLayoutIndexRoute =
  AuthInternalFeatureFlagsFlagKeyLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthInternalFeatureFlagsFlagKeyLayoutRoute,
  } as any)
const AuthInternalFeatureFlagsFlagKeyLayoutHistoryRoute =
  AuthInternalFeatureFlagsFlagKeyLayoutHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => AuthInternalFeatureFlagsFlagKeyLayoutRoute,
  } as any)
const AuthInternalFeatureFlagsFlagKeyLayoutUsersRoute =
  AuthInternalFeatureFlagsFlagKeyLayoutUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => AuthInternalFeatureFlagsFlagKeyLayoutRoute,
  } as any)
const AuthProcurementSupplyPlanPurchasePlanIdLayoutIndexRoute =
  AuthProcurementSupplyPlanPurchasePlanIdLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthProcurementSupplyPlanPurchasePlanIdLayoutRoute,
  } as any)
const AuthProcurementSupplyPlanPurchasePlanIdLayoutCapacityRoute =
  AuthProcurementSupplyPlanPurchasePlanIdLayoutCapacityRouteImport.update({
    id: '/capacity',
    path: '/capacity',
    getParentRoute: () => AuthProcurementSupplyPlanPurchasePlanIdLayoutRoute,
  } as any)
const AuthProcurementSupplyPlanPurchasePlanIdLayoutGreigeRoute =
  AuthProcurementSupplyPlanPurchasePlanIdLayoutGreigeRouteImport.update({
    id: '/greige',
    path: '/greige',
    getParentRoute: () => AuthProcurementSupplyPlanPurchasePlanIdLayoutRoute,
  } as any)
const AuthProcurementSupplyPlanPurchasePlanIdLayoutQuantitiesRoute =
  AuthProcurementSupplyPlanPurchasePlanIdLayoutQuantitiesRouteImport.update({
    id: '/quantities',
    path: '/quantities',
    getParentRoute: () => AuthProcurementSupplyPlanPurchasePlanIdLayoutRoute,
  } as any)
const AuthProcurementSupplyPlanCollectionCollectionIdLayoutRoute =
  AuthProcurementSupplyPlanCollectionCollectionIdLayoutRouteImport.update({
    id: '/procurement/supply-plan/collection/$collectionId/_layout',
    path: '/procurement/supply-plan/collection/$collectionId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRoute =
  AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRouteImport.update({
    id: '/procurement/supply-plan/noos/$supplyPlanId/_layout',
    path: '/procurement/supply-plan/noos/$supplyPlanId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthBudgetsLayoutFiscalYearBudgetIdLayoutIndexRoute =
  AuthBudgetsLayoutFiscalYearBudgetIdLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthBudgetsLayoutFiscalYearBudgetIdLayoutRoute,
  } as any)
const AuthBudgetsLayoutFiscalYearBudgetIdLayoutAllocationPlanningRoute =
  AuthBudgetsLayoutFiscalYearBudgetIdLayoutAllocationPlanningRouteImport.update(
    {
      id: '/allocation-planning',
      path: '/allocation-planning',
      getParentRoute: () => AuthBudgetsLayoutFiscalYearBudgetIdLayoutRoute,
    } as any,
  )
const AuthBudgetsLayoutFiscalYearBudgetIdLayoutMarkdownPlanningRoute =
  AuthBudgetsLayoutFiscalYearBudgetIdLayoutMarkdownPlanningRouteImport.update({
    id: '/markdown-planning',
    path: '/markdown-planning',
    getParentRoute: () => AuthBudgetsLayoutFiscalYearBudgetIdLayoutRoute,
  } as any)
const AuthBudgetsLayoutFiscalYearBudgetIdLayoutSalesPricesRoute =
  AuthBudgetsLayoutFiscalYearBudgetIdLayoutSalesPricesRouteImport.update({
    id: '/sales-prices',
    path: '/sales-prices',
    getParentRoute: () => AuthBudgetsLayoutFiscalYearBudgetIdLayoutRoute,
  } as any)
const AuthBudgetsLayoutFiscalYearBudgetIdLayoutTargetRoute =
  AuthBudgetsLayoutFiscalYearBudgetIdLayoutTargetRouteImport.update({
    id: '/target',
    path: '/target',
    getParentRoute: () => AuthBudgetsLayoutFiscalYearBudgetIdLayoutRoute,
  } as any)
const AuthBudgetsLayoutFiscalYearBudgetIdLayoutTargetReportRoute =
  AuthBudgetsLayoutFiscalYearBudgetIdLayoutTargetReportRouteImport.update({
    id: '/target-report',
    path: '/target-report',
    getParentRoute: () => AuthBudgetsLayoutFiscalYearBudgetIdLayoutRoute,
  } as any)
const AuthProcurementSupplyPlanCollectionCollectionIdLayoutIndexRoute =
  AuthProcurementSupplyPlanCollectionCollectionIdLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthProcurementSupplyPlanCollectionCollectionIdLayoutRoute,
  } as any)
const AuthProcurementSupplyPlanCollectionCollectionIdLayoutCapacityRoute =
  AuthProcurementSupplyPlanCollectionCollectionIdLayoutCapacityRouteImport.update(
    {
      id: '/capacity',
      path: '/capacity',
      getParentRoute: () =>
        AuthProcurementSupplyPlanCollectionCollectionIdLayoutRoute,
    } as any,
  )
const AuthProcurementSupplyPlanCollectionCollectionIdLayoutGreigeRoute =
  AuthProcurementSupplyPlanCollectionCollectionIdLayoutGreigeRouteImport.update(
    {
      id: '/greige',
      path: '/greige',
      getParentRoute: () =>
        AuthProcurementSupplyPlanCollectionCollectionIdLayoutRoute,
    } as any,
  )
const AuthProcurementSupplyPlanCollectionCollectionIdLayoutOverviewRoute =
  AuthProcurementSupplyPlanCollectionCollectionIdLayoutOverviewRouteImport.update(
    {
      id: '/overview',
      path: '/overview',
      getParentRoute: () =>
        AuthProcurementSupplyPlanCollectionCollectionIdLayoutRoute,
    } as any,
  )
const AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutIndexRoute =
  AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRoute,
  } as any)
const AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutAvailabilityRoute =
  AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutAvailabilityRouteImport.update(
    {
      id: '/availability',
      path: '/availability',
      getParentRoute: () =>
        AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRoute,
    } as any,
  )
const AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutCapacityPlanningRoute =
  AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutCapacityPlanningRouteImport.update(
    {
      id: '/capacity-planning',
      path: '/capacity-planning',
      getParentRoute: () =>
        AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRoute,
    } as any,
  )
const AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutGreigeRoute =
  AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutGreigeRouteImport.update({
    id: '/greige',
    path: '/greige',
    getParentRoute: () => AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRoute,
  } as any)
const AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutOverviewRoute =
  AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRoute,
  } as any)
const AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutTriggersRoute =
  AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutTriggersRouteImport.update({
    id: '/triggers',
    path: '/triggers',
    getParentRoute: () => AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRoute,
  } as any)
const AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutRoute =
  AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutRouteImport.update({
    id: '/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/_layout',
    path: '/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutIndexRoute =
  AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutRoute,
    } as any,
  )
const AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutCapacityRoute =
  AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutCapacityRouteImport.update(
    {
      id: '/capacity',
      path: '/capacity',
      getParentRoute: () =>
        AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutRoute,
    } as any,
  )
const AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutQuantitiesRoute =
  AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutQuantitiesRouteImport.update(
    {
      id: '/quantities',
      path: '/quantities',
      getParentRoute: () =>
        AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/logout': typeof LogoutRoute
  '/home': typeof AuthHomeRoute
  '/inbox': typeof AuthInboxRoute
  '/internal': typeof AuthInternalRouteWithChildren
  '/reporting': typeof AuthReportingRoute
  '/setup': typeof AuthSetupRouteWithChildren
  '/login/$orgName': typeof LoginOrgNameRoute
  '/login/': typeof LoginIndexRoute
  '/allocation': typeof AuthAllocationLayoutRouteWithChildren
  '/budgets': typeof AuthBudgetsLayoutRouteWithChildren
  '/demand': typeof AuthDemandLayoutRouteWithChildren
  '/forecasting': typeof AuthForecastingLayoutRoute
  '/ingestion-cockpit': typeof AuthIngestionCockpitLayoutRouteWithChildren
  '/insights/availability': typeof AuthInsightsAvailabilityRoute
  '/insights/customer-insights': typeof AuthInsightsCustomerInsightsRoute
  '/insights/forecast-calendar': typeof AuthInsightsForecastCalendarRoute
  '/insights/studio': typeof AuthInsightsStudioRouteWithChildren
  '/internal/others': typeof AuthInternalOthersRoute
  '/internal/tv': typeof AuthInternalTvRoute
  '/product-management': typeof AuthProductManagementLayoutRouteWithChildren
  '/settings': typeof AuthSettingsLayoutInternalRouteWithChildren
  '/settings/company': typeof AuthSettingsCompanyRoute
  '/settings/purchase-orders': typeof AuthSettingsPurchaseOrdersRoute
  '/settings/returns': typeof AuthSettingsReturnsRoute
  '/setup/$': typeof AuthSetupSplatRoute
  '/allocation/': typeof AuthAllocationIndexRoute
  '/collection-management/': typeof AuthCollectionManagementIndexRoute
  '/data-validation/': typeof AuthDataValidationIndexRoute
  '/demand-planning/': typeof AuthDemandPlanningIndexRoute
  '/forecasting/': typeof AuthForecastingIndexRoute
  '/insights/': typeof AuthInsightsIndexRoute
  '/market-strategy/': typeof AuthMarketStrategyIndexRoute
  '/procurement/': typeof AuthProcurementIndexRoute
  '/product-management/': typeof AuthProductManagementIndexRoute
  '/prototype/': typeof AuthPrototypeIndexRoute
  '/settings/': typeof AuthSettingsIndexRoute
  '/budgets/$fiscalYear': typeof AuthBudgetsLayoutFiscalYearRouteRouteWithChildren
  '/allocation/replenishment': typeof AuthAllocationLayoutReplenishmentRoute
  '/allocation/reports': typeof AuthAllocationLayoutReportsRouteWithChildren
  '/allocation/settings': typeof AuthAllocationLayoutSettingsRouteWithChildren
  '/budgets/timeline': typeof AuthBudgetsLayoutTimelineRoute
  '/demand-planning/fashion': typeof AuthDemandPlanningFashionLayoutRouteWithChildren
  '/demand-planning/noos': typeof AuthDemandPlanningNoosLayoutRouteWithChildren
  '/demand/calendar': typeof AuthDemandLayoutCalendarRoute
  '/demand/performance': typeof AuthDemandLayoutPerformanceRoute
  '/demand/sales-and-demand': typeof AuthDemandLayoutSalesAndDemandRoute
  '/ingestion-cockpit/data-checks': typeof AuthIngestionCockpitLayoutDataChecksRoute
  '/ingestion-cockpit/data-quality': typeof AuthIngestionCockpitLayoutDataQualityRouteWithChildren
  '/ingestion-cockpit/views': typeof AuthIngestionCockpitLayoutViewsRoute
  '/insights/inventory-overview': typeof AuthInsightsInventoryOverviewLayoutRouteWithChildren
  '/insights/studio/$reportId': typeof AuthInsightsStudioReportIdRoute
  '/internal/customer-management': typeof AuthInternalCustomerManagementLayoutRouteWithChildren
  '/internal/customer-success': typeof AuthInternalCustomerSuccessLayoutRouteWithChildren
  '/internal/design-system/graphs': typeof AuthInternalDesignSystemGraphsRoute
  '/internal/development/charts': typeof AuthInternalDevelopmentChartsRoute
  '/internal/development/components': typeof AuthInternalDevelopmentComponentsRoute
  '/internal/docs': typeof AuthInternalDocsLayoutRouteWithChildren
  '/internal/feature-flags': typeof AuthInternalFeatureFlagsOverviewRouteWithChildren
  '/internal/forecasts/forecast-validation-check': typeof AuthInternalForecastsForecastValidationCheckRoute
  '/internal/forecasts/forecasting-reports': typeof AuthInternalForecastsForecastingReportsRoute
  '/procurement/incoming-orders': typeof AuthProcurementIncomingOrdersLayoutRouteWithChildren
  '/procurement/order-suggestions': typeof AuthProcurementOrderSuggestionsLayoutRouteWithChildren
  '/procurement/purchase-orders': typeof AuthProcurementPurchaseOrdersLayoutRouteWithChildren
  '/procurement/purchase-orders/create': typeof AuthProcurementPurchaseOrdersCreateRoute
  '/procurement/vendor-management/$vendorId': typeof AuthProcurementVendorManagementVendorIdRoute
  '/procurement/vendor-management': typeof AuthProcurementVendorManagementLayoutRouteWithChildren
  '/product-management/active': typeof AuthProductManagementLayoutActiveRoute
  '/product-management/ghost-variants': typeof AuthProductManagementLayoutGhostVariantsRoute
  '/product-management/hidden': typeof AuthProductManagementLayoutHiddenRoute
  '/product-management/inactive': typeof AuthProductManagementLayoutInactiveRoute
  '/product-management/inbox': typeof AuthProductManagementLayoutInboxRoute
  '/product-management/linked-variants': typeof AuthProductManagementLayoutLinkedVariantsRoute
  '/product-management/needs-attention': typeof AuthProductManagementLayoutNeedsAttentionRoute
  '/product-management/phased-out': typeof AuthProductManagementLayoutPhasedOutRoute
  '/product-management/phasing-out': typeof AuthProductManagementLayoutPhasingOutRoute
  '/product-management/suggested-activations': typeof AuthProductManagementLayoutSuggestedActivationsRoute
  '/product/$productId': typeof AuthProductProductIdLayoutRouteWithChildren
  '/prototype/allocation-planning/$': typeof AuthPrototypeAllocationPlanningSplatRoute
  '/settings/ai': typeof AuthSettingsLayoutAiRoute
  '/settings/channels': typeof AuthSettingsLayoutChannelsRoute
  '/settings/custom-data': typeof AuthSettingsLayoutCustomDataRoute
  '/settings/demand': typeof AuthSettingsLayoutDemandRoute
  '/settings/erp': typeof AuthSettingsLayoutErpRoute
  '/settings/general': typeof AuthSettingsLayoutGeneralRoute
  '/settings/procurement': typeof AuthSettingsLayoutProcurementRoute
  '/settings/rules': typeof AuthSettingsLayoutRulesRoute
  '/settings/teams': typeof AuthSettingsLayoutTeamsRoute
  '/settings/users': typeof AuthSettingsLayoutUsersRoute
  '/budgets/': typeof AuthBudgetsLayoutIndexRoute
  '/demand-planning/fashion/': typeof AuthDemandPlanningFashionIndexRoute
  '/demand-planning/noos/': typeof AuthDemandPlanningNoosIndexRoute
  '/demand/': typeof AuthDemandLayoutIndexRoute
  '/ingestion-cockpit/': typeof AuthIngestionCockpitLayoutIndexRoute
  '/insights/studio/': typeof AuthInsightsStudioIndexRoute
  '/internal/design-system/': typeof AuthInternalDesignSystemIndexRoute
  '/internal/status/': typeof AuthInternalStatusIndexRoute
  '/procurement/incoming-orders/': typeof AuthProcurementIncomingOrdersIndexRoute
  '/procurement/order-suggestions/': typeof AuthProcurementOrderSuggestionsIndexRoute
  '/procurement/purchase-orders/': typeof AuthProcurementPurchaseOrdersIndexRoute
  '/procurement/supply-plan/': typeof AuthProcurementSupplyPlanIndexRoute
  '/procurement/vendor-management/': typeof AuthProcurementVendorManagementIndexRoute
  '/prototype/seasons-collections/': typeof AuthPrototypeSeasonsCollectionsIndexRoute
  '/allocation/reports/products': typeof AuthAllocationLayoutReportsProductsRoute
  '/allocation/reports/stores': typeof AuthAllocationLayoutReportsStoresRoute
  '/allocation/settings/$subTab': typeof AuthAllocationLayoutSettingsSubTabRoute
  '/budgets/year/$year': typeof AuthBudgetsLayoutYearYearRoute
  '/demand-planning/fashion/$collectionId': typeof AuthDemandPlanningFashionCollectionIdLayoutRouteWithChildren
  '/demand-planning/fashion/tasks': typeof AuthDemandPlanningFashionLayoutTasksRoute
  '/demand-planning/fashion/timeline': typeof AuthDemandPlanningFashionLayoutTimelineRoute
  '/demand-planning/noos/$collectionId': typeof AuthDemandPlanningNoosCollectionIdLayoutRouteWithChildren
  '/demand-planning/noos/tasks': typeof AuthDemandPlanningNoosLayoutTasksRoute
  '/demand-planning/noos/timeline': typeof AuthDemandPlanningNoosLayoutTimelineRoute
  '/demand/fashion/$collectionId': typeof AuthDemandFashionCollectionIdLayoutRouteWithChildren
  '/demand/noos/$collectionId': typeof AuthDemandNoosCollectionIdLayoutRouteWithChildren
  '/ingestion-cockpit/data-quality/$checkId': typeof AuthIngestionCockpitLayoutDataQualityCheckIdRoute
  '/insights/inventory-overview/calendar': typeof AuthInsightsInventoryOverviewLayoutCalendarRoute
  '/internal/customer-management/organizations': typeof AuthInternalCustomerManagementLayoutOrganizationsRoute
  '/internal/customer-management/users': typeof AuthInternalCustomerManagementLayoutUsersRoute
  '/internal/customer-success/haki-usage': typeof AuthInternalCustomerSuccessLayoutHakiUsageRoute
  '/internal/customer-success/impact': typeof AuthInternalCustomerSuccessLayoutImpactRoute
  '/internal/customer-success/user-activity': typeof AuthInternalCustomerSuccessLayoutUserActivityRoute
  '/internal/design-system/components/badges': typeof AuthInternalDesignSystemComponentsBadgesRoute
  '/internal/design-system/components/baseline-source-card': typeof AuthInternalDesignSystemComponentsBaselineSourceCardRoute
  '/internal/design-system/components/button-group': typeof AuthInternalDesignSystemComponentsButtonGroupRoute
  '/internal/design-system/components/buttons': typeof AuthInternalDesignSystemComponentsButtonsRoute
  '/internal/design-system/components/checkboxes': typeof AuthInternalDesignSystemComponentsCheckboxesRoute
  '/internal/design-system/components/code-block': typeof AuthInternalDesignSystemComponentsCodeBlockRoute
  '/internal/design-system/components/command-bar': typeof AuthInternalDesignSystemComponentsCommandBarRoute
  '/internal/design-system/components/date-picker': typeof AuthInternalDesignSystemComponentsDatePickerRoute
  '/internal/design-system/components/empty-state': typeof AuthInternalDesignSystemComponentsEmptyStateRoute
  '/internal/design-system/components/expandable-card': typeof AuthInternalDesignSystemComponentsExpandableCardRoute
  '/internal/design-system/components/icon-toolbar': typeof AuthInternalDesignSystemComponentsIconToolbarRoute
  '/internal/design-system/components/inline-alert': typeof AuthInternalDesignSystemComponentsInlineAlertRoute
  '/internal/design-system/components/link-button': typeof AuthInternalDesignSystemComponentsLinkButtonRoute
  '/internal/design-system/components/matrix': typeof AuthInternalDesignSystemComponentsMatrixRoute
  '/internal/design-system/components/message-scroller': typeof AuthInternalDesignSystemComponentsMessageScrollerRoute
  '/internal/design-system/components/progress-bar': typeof AuthInternalDesignSystemComponentsProgressBarRoute
  '/internal/design-system/components/radios': typeof AuthInternalDesignSystemComponentsRadiosRoute
  '/internal/design-system/components/section-card': typeof AuthInternalDesignSystemComponentsSectionCardRoute
  '/internal/design-system/components/select': typeof AuthInternalDesignSystemComponentsSelectRoute
  '/internal/design-system/components/stat-tile': typeof AuthInternalDesignSystemComponentsStatTileRoute
  '/internal/design-system/components/switches': typeof AuthInternalDesignSystemComponentsSwitchesRoute
  '/internal/design-system/components/text-input': typeof AuthInternalDesignSystemComponentsTextInputRoute
  '/internal/design-system/components/textarea': typeof AuthInternalDesignSystemComponentsTextareaRoute
  '/internal/design-system/components/toast': typeof AuthInternalDesignSystemComponentsToastRoute
  '/internal/design-system/components/trace': typeof AuthInternalDesignSystemComponentsTraceRoute
  '/internal/design-system/components/view-pill': typeof AuthInternalDesignSystemComponentsViewPillRoute
  '/internal/design-system/legacy-components/$slug': typeof AuthInternalDesignSystemLegacyComponentsSlugRoute
  '/internal/design-system/pages/inspector': typeof AuthInternalDesignSystemPagesInspectorRoute
  '/internal/design-system/pages/pages': typeof AuthInternalDesignSystemPagesPagesRoute
  '/internal/design-system/styles/color-tokens': typeof AuthInternalDesignSystemStylesColorTokensRoute
  '/internal/design-system/styles/text-styles': typeof AuthInternalDesignSystemStylesTextStylesRoute
  '/internal/docs/$slug': typeof AuthInternalDocsLayoutSlugRoute
  '/internal/feature-flags/$flagKey': typeof AuthInternalFeatureFlagsFlagKeyLayoutRouteWithChildren
  '/internal/feature-flags/history': typeof AuthInternalFeatureFlagsOverviewHistoryRoute
  '/procurement/incoming-orders/calendar': typeof AuthProcurementIncomingOrdersLayoutCalendarRoute
  '/procurement/incoming-orders/list': typeof AuthProcurementIncomingOrdersLayoutListRoute
  '/procurement/incoming-orders/overview': typeof AuthProcurementIncomingOrdersLayoutOverviewRoute
  '/procurement/order-suggestions/replenishment-suggestions': typeof AuthProcurementOrderSuggestionsLayoutReplenishmentSuggestionsRoute
  '/procurement/purchase-orders/archived': typeof AuthProcurementPurchaseOrdersLayoutArchivedRoute
  '/procurement/purchase-orders/closed': typeof AuthProcurementPurchaseOrdersLayoutClosedRoute
  '/procurement/purchase-orders/draft': typeof AuthProcurementPurchaseOrdersLayoutDraftRoute
  '/procurement/purchase-orders/open': typeof AuthProcurementPurchaseOrdersLayoutOpenRoute
  '/procurement/purchase-orders/update/$purchaseOrderId': typeof AuthProcurementPurchaseOrdersUpdatePurchaseOrderIdRoute
  '/procurement/supply-plan/$purchasePlanId': typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutRouteWithChildren
  '/procurement/vendor-management/capacity': typeof AuthProcurementVendorManagementLayoutCapacityRoute
  '/procurement/vendor-management/vendors': typeof AuthProcurementVendorManagementLayoutVendorsRoute
  '/product/$productId/demand': typeof AuthProductProductIdLayoutDemandRoute
  '/product/$productId/finance': typeof AuthProductProductIdLayoutFinanceRoute
  '/product/$productId/forecast': typeof AuthProductProductIdLayoutForecastRoute
  '/product/$productId/forecast-analysis': typeof AuthProductProductIdLayoutForecastAnalysisRoute
  '/product/$productId/inventory': typeof AuthProductProductIdLayoutInventoryRoute
  '/product/$productId/overview': typeof AuthProductProductIdLayoutOverviewRoute
  '/product/$productId/performance': typeof AuthProductProductIdLayoutPerformanceRoute
  '/settings/alerts': typeof AuthSettingsLayoutInternalAlertsRoute
  '/settings/demo': typeof AuthSettingsLayoutInternalDemoRoute
  '/settings/hakio': typeof AuthSettingsLayoutInternalHakioRoute
  '/settings/match-configuration': typeof AuthSettingsLayoutInternalMatchConfigurationRoute
  '/settings/naming': typeof AuthSettingsLayoutInternalNamingRoute
  '/allocation/reports/': typeof AuthAllocationLayoutReportsIndexRoute
  '/allocation/settings/': typeof AuthAllocationLayoutSettingsIndexRoute
  '/ingestion-cockpit/data-quality/': typeof AuthIngestionCockpitLayoutDataQualityIndexRoute
  '/insights/inventory-overview/': typeof AuthInsightsInventoryOverviewLayoutIndexRoute
  '/internal/customer-management/': typeof AuthInternalCustomerManagementLayoutIndexRoute
  '/internal/customer-success/': typeof AuthInternalCustomerSuccessLayoutIndexRoute
  '/internal/docs/': typeof AuthInternalDocsLayoutIndexRoute
  '/internal/feature-flags/': typeof AuthInternalFeatureFlagsOverviewIndexRoute
  '/product/$productId/': typeof AuthProductProductIdLayoutIndexRoute
  '/budgets/$fiscalYear/$budgetId': typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutRouteWithChildren
  '/budgets/$fiscalYear/breakdown': typeof AuthBudgetsLayoutFiscalYearLayoutBreakdownRoute
  '/budgets/$fiscalYear/collections': typeof AuthBudgetsLayoutFiscalYearLayoutCollectionsRoute
  '/demand-planning/fashion/$collectionId/analysis': typeof AuthDemandPlanningFashionCollectionIdLayoutAnalysisRoute
  '/demand-planning/fashion/$collectionId/customers': typeof AuthDemandPlanningFashionCollectionIdLayoutCustomersRoute
  '/demand-planning/fashion/$collectionId/demand': typeof AuthDemandPlanningFashionCollectionIdLayoutDemandRoute
  '/demand-planning/fashion/$collectionId/performance': typeof AuthDemandPlanningFashionCollectionIdLayoutPerformanceRoute
  '/demand-planning/fashion/$collectionId/seasonality': typeof AuthDemandPlanningFashionCollectionIdLayoutSeasonalityRoute
  '/demand-planning/fashion/$collectionId/splits': typeof AuthDemandPlanningFashionCollectionIdLayoutSplitsRoute
  '/demand-planning/fashion/$collectionId/trim': typeof AuthDemandPlanningFashionCollectionIdLayoutTrimRoute
  '/demand-planning/noos/$collectionId/forecast-updates': typeof AuthDemandPlanningNoosCollectionIdLayoutForecastUpdatesRoute
  '/demand-planning/noos/$collectionId/new-variants': typeof AuthDemandPlanningNoosCollectionIdLayoutNewVariantsRoute
  '/demand/fashion/$collectionId/budget': typeof AuthDemandFashionCollectionIdLayoutBudgetRoute
  '/demand/fashion/$collectionId/demand': typeof AuthDemandFashionCollectionIdLayoutDemandRoute
  '/demand/fashion/$collectionId/performance': typeof AuthDemandFashionCollectionIdLayoutPerformanceRoute
  '/demand/fashion/$collectionId/variants': typeof AuthDemandFashionCollectionIdLayoutVariantsRoute
  '/demand/noos/$collectionId/budget': typeof AuthDemandNoosCollectionIdLayoutBudgetRoute
  '/demand/noos/$collectionId/demand': typeof AuthDemandNoosCollectionIdLayoutDemandRoute
  '/demand/noos/$collectionId/performance': typeof AuthDemandNoosCollectionIdLayoutPerformanceRoute
  '/demand/noos/$collectionId/variants': typeof AuthDemandNoosCollectionIdLayoutVariantsRoute
  '/internal/feature-flags/$flagKey/history': typeof AuthInternalFeatureFlagsFlagKeyLayoutHistoryRoute
  '/internal/feature-flags/$flagKey/users': typeof AuthInternalFeatureFlagsFlagKeyLayoutUsersRoute
  '/procurement/supply-plan/$purchasePlanId/capacity': typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutCapacityRoute
  '/procurement/supply-plan/$purchasePlanId/greige': typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutGreigeRoute
  '/procurement/supply-plan/$purchasePlanId/quantities': typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutQuantitiesRoute
  '/procurement/supply-plan/collection/$collectionId': typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutRouteWithChildren
  '/procurement/supply-plan/noos/$supplyPlanId': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRouteWithChildren
  '/budgets/$fiscalYear/': typeof AuthBudgetsLayoutFiscalYearLayoutIndexRoute
  '/demand-planning/fashion/$collectionId/': typeof AuthDemandPlanningFashionCollectionIdLayoutIndexRoute
  '/demand-planning/noos/$collectionId/': typeof AuthDemandPlanningNoosCollectionIdLayoutIndexRoute
  '/demand/fashion/$collectionId/': typeof AuthDemandFashionCollectionIdLayoutIndexRoute
  '/demand/noos/$collectionId/': typeof AuthDemandNoosCollectionIdLayoutIndexRoute
  '/internal/feature-flags/$flagKey/': typeof AuthInternalFeatureFlagsFlagKeyLayoutIndexRoute
  '/procurement/supply-plan/$purchasePlanId/': typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutIndexRoute
  '/budgets/$fiscalYear/$budgetId/allocation-planning': typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutAllocationPlanningRoute
  '/budgets/$fiscalYear/$budgetId/markdown-planning': typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutMarkdownPlanningRoute
  '/budgets/$fiscalYear/$budgetId/sales-prices': typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutSalesPricesRoute
  '/budgets/$fiscalYear/$budgetId/target': typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutTargetRoute
  '/budgets/$fiscalYear/$budgetId/target-report': typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutTargetReportRoute
  '/procurement/supply-plan/collection/$collectionId/capacity': typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutCapacityRoute
  '/procurement/supply-plan/collection/$collectionId/greige': typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutGreigeRoute
  '/procurement/supply-plan/collection/$collectionId/overview': typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutOverviewRoute
  '/procurement/supply-plan/noos/$supplyPlanId/availability': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutAvailabilityRoute
  '/procurement/supply-plan/noos/$supplyPlanId/capacity-planning': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutCapacityPlanningRoute
  '/procurement/supply-plan/noos/$supplyPlanId/greige': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutGreigeRoute
  '/procurement/supply-plan/noos/$supplyPlanId/overview': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutOverviewRoute
  '/procurement/supply-plan/noos/$supplyPlanId/triggers': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutTriggersRoute
  '/budgets/$fiscalYear/$budgetId/': typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutIndexRoute
  '/procurement/supply-plan/collection/$collectionId/': typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutIndexRoute
  '/procurement/supply-plan/noos/$supplyPlanId/': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutIndexRoute
  '/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutRouteWithChildren
  '/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/capacity': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutCapacityRoute
  '/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/quantities': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutQuantitiesRoute
  '/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutIndexRoute
}
export interface FileRoutesByTo {
  '/logout': typeof LogoutRoute
  '/home': typeof AuthHomeRoute
  '/inbox': typeof AuthInboxRoute
  '/internal': typeof AuthInternalRouteWithChildren
  '/reporting': typeof AuthReportingRoute
  '/setup': typeof AuthSetupRouteWithChildren
  '/login/$orgName': typeof LoginOrgNameRoute
  '/': typeof AuthIndexRoute
  '/login': typeof LoginIndexRoute
  '/allocation': typeof AuthAllocationIndexRoute
  '/forecasting': typeof AuthForecastingIndexRoute
  '/insights/availability': typeof AuthInsightsAvailabilityRoute
  '/insights/customer-insights': typeof AuthInsightsCustomerInsightsRoute
  '/insights/forecast-calendar': typeof AuthInsightsForecastCalendarRoute
  '/internal/others': typeof AuthInternalOthersRoute
  '/internal/tv': typeof AuthInternalTvRoute
  '/product-management': typeof AuthProductManagementIndexRoute
  '/settings': typeof AuthSettingsIndexRoute
  '/settings/company': typeof AuthSettingsCompanyRoute
  '/settings/purchase-orders': typeof AuthSettingsPurchaseOrdersRoute
  '/settings/returns': typeof AuthSettingsReturnsRoute
  '/setup/$': typeof AuthSetupSplatRoute
  '/collection-management': typeof AuthCollectionManagementIndexRoute
  '/data-validation': typeof AuthDataValidationIndexRoute
  '/demand-planning': typeof AuthDemandPlanningIndexRoute
  '/insights': typeof AuthInsightsIndexRoute
  '/market-strategy': typeof AuthMarketStrategyIndexRoute
  '/procurement': typeof AuthProcurementIndexRoute
  '/prototype': typeof AuthPrototypeIndexRoute
  '/budgets/$fiscalYear': typeof AuthBudgetsLayoutFiscalYearLayoutIndexRoute
  '/allocation/replenishment': typeof AuthAllocationLayoutReplenishmentRoute
  '/budgets/timeline': typeof AuthBudgetsLayoutTimelineRoute
  '/demand-planning/fashion': typeof AuthDemandPlanningFashionIndexRoute
  '/demand-planning/noos': typeof AuthDemandPlanningNoosIndexRoute
  '/demand/calendar': typeof AuthDemandLayoutCalendarRoute
  '/demand/performance': typeof AuthDemandLayoutPerformanceRoute
  '/demand/sales-and-demand': typeof AuthDemandLayoutSalesAndDemandRoute
  '/ingestion-cockpit/data-checks': typeof AuthIngestionCockpitLayoutDataChecksRoute
  '/ingestion-cockpit/views': typeof AuthIngestionCockpitLayoutViewsRoute
  '/insights/studio/$reportId': typeof AuthInsightsStudioReportIdRoute
  '/internal/design-system/graphs': typeof AuthInternalDesignSystemGraphsRoute
  '/internal/development/charts': typeof AuthInternalDevelopmentChartsRoute
  '/internal/development/components': typeof AuthInternalDevelopmentComponentsRoute
  '/internal/forecasts/forecast-validation-check': typeof AuthInternalForecastsForecastValidationCheckRoute
  '/internal/forecasts/forecasting-reports': typeof AuthInternalForecastsForecastingReportsRoute
  '/procurement/incoming-orders': typeof AuthProcurementIncomingOrdersIndexRoute
  '/procurement/order-suggestions': typeof AuthProcurementOrderSuggestionsIndexRoute
  '/procurement/purchase-orders': typeof AuthProcurementPurchaseOrdersIndexRoute
  '/procurement/purchase-orders/create': typeof AuthProcurementPurchaseOrdersCreateRoute
  '/procurement/vendor-management/$vendorId': typeof AuthProcurementVendorManagementVendorIdRoute
  '/procurement/vendor-management': typeof AuthProcurementVendorManagementIndexRoute
  '/product-management/active': typeof AuthProductManagementLayoutActiveRoute
  '/product-management/ghost-variants': typeof AuthProductManagementLayoutGhostVariantsRoute
  '/product-management/hidden': typeof AuthProductManagementLayoutHiddenRoute
  '/product-management/inactive': typeof AuthProductManagementLayoutInactiveRoute
  '/product-management/inbox': typeof AuthProductManagementLayoutInboxRoute
  '/product-management/linked-variants': typeof AuthProductManagementLayoutLinkedVariantsRoute
  '/product-management/needs-attention': typeof AuthProductManagementLayoutNeedsAttentionRoute
  '/product-management/phased-out': typeof AuthProductManagementLayoutPhasedOutRoute
  '/product-management/phasing-out': typeof AuthProductManagementLayoutPhasingOutRoute
  '/product-management/suggested-activations': typeof AuthProductManagementLayoutSuggestedActivationsRoute
  '/prototype/allocation-planning/$': typeof AuthPrototypeAllocationPlanningSplatRoute
  '/settings/ai': typeof AuthSettingsLayoutAiRoute
  '/settings/channels': typeof AuthSettingsLayoutChannelsRoute
  '/settings/custom-data': typeof AuthSettingsLayoutCustomDataRoute
  '/settings/demand': typeof AuthSettingsLayoutDemandRoute
  '/settings/erp': typeof AuthSettingsLayoutErpRoute
  '/settings/general': typeof AuthSettingsLayoutGeneralRoute
  '/settings/procurement': typeof AuthSettingsLayoutProcurementRoute
  '/settings/rules': typeof AuthSettingsLayoutRulesRoute
  '/settings/teams': typeof AuthSettingsLayoutTeamsRoute
  '/settings/users': typeof AuthSettingsLayoutUsersRoute
  '/budgets': typeof AuthBudgetsLayoutIndexRoute
  '/demand': typeof AuthDemandLayoutIndexRoute
  '/ingestion-cockpit': typeof AuthIngestionCockpitLayoutIndexRoute
  '/insights/studio': typeof AuthInsightsStudioIndexRoute
  '/internal/design-system': typeof AuthInternalDesignSystemIndexRoute
  '/internal/status': typeof AuthInternalStatusIndexRoute
  '/procurement/supply-plan': typeof AuthProcurementSupplyPlanIndexRoute
  '/prototype/seasons-collections': typeof AuthPrototypeSeasonsCollectionsIndexRoute
  '/allocation/reports/products': typeof AuthAllocationLayoutReportsProductsRoute
  '/allocation/reports/stores': typeof AuthAllocationLayoutReportsStoresRoute
  '/allocation/settings/$subTab': typeof AuthAllocationLayoutSettingsSubTabRoute
  '/budgets/year/$year': typeof AuthBudgetsLayoutYearYearRoute
  '/demand-planning/fashion/tasks': typeof AuthDemandPlanningFashionLayoutTasksRoute
  '/demand-planning/fashion/timeline': typeof AuthDemandPlanningFashionLayoutTimelineRoute
  '/demand-planning/noos/tasks': typeof AuthDemandPlanningNoosLayoutTasksRoute
  '/demand-planning/noos/timeline': typeof AuthDemandPlanningNoosLayoutTimelineRoute
  '/ingestion-cockpit/data-quality/$checkId': typeof AuthIngestionCockpitLayoutDataQualityCheckIdRoute
  '/insights/inventory-overview/calendar': typeof AuthInsightsInventoryOverviewLayoutCalendarRoute
  '/internal/customer-management/organizations': typeof AuthInternalCustomerManagementLayoutOrganizationsRoute
  '/internal/customer-management/users': typeof AuthInternalCustomerManagementLayoutUsersRoute
  '/internal/customer-success/haki-usage': typeof AuthInternalCustomerSuccessLayoutHakiUsageRoute
  '/internal/customer-success/impact': typeof AuthInternalCustomerSuccessLayoutImpactRoute
  '/internal/customer-success/user-activity': typeof AuthInternalCustomerSuccessLayoutUserActivityRoute
  '/internal/design-system/components/badges': typeof AuthInternalDesignSystemComponentsBadgesRoute
  '/internal/design-system/components/baseline-source-card': typeof AuthInternalDesignSystemComponentsBaselineSourceCardRoute
  '/internal/design-system/components/button-group': typeof AuthInternalDesignSystemComponentsButtonGroupRoute
  '/internal/design-system/components/buttons': typeof AuthInternalDesignSystemComponentsButtonsRoute
  '/internal/design-system/components/checkboxes': typeof AuthInternalDesignSystemComponentsCheckboxesRoute
  '/internal/design-system/components/code-block': typeof AuthInternalDesignSystemComponentsCodeBlockRoute
  '/internal/design-system/components/command-bar': typeof AuthInternalDesignSystemComponentsCommandBarRoute
  '/internal/design-system/components/date-picker': typeof AuthInternalDesignSystemComponentsDatePickerRoute
  '/internal/design-system/components/empty-state': typeof AuthInternalDesignSystemComponentsEmptyStateRoute
  '/internal/design-system/components/expandable-card': typeof AuthInternalDesignSystemComponentsExpandableCardRoute
  '/internal/design-system/components/icon-toolbar': typeof AuthInternalDesignSystemComponentsIconToolbarRoute
  '/internal/design-system/components/inline-alert': typeof AuthInternalDesignSystemComponentsInlineAlertRoute
  '/internal/design-system/components/link-button': typeof AuthInternalDesignSystemComponentsLinkButtonRoute
  '/internal/design-system/components/matrix': typeof AuthInternalDesignSystemComponentsMatrixRoute
  '/internal/design-system/components/message-scroller': typeof AuthInternalDesignSystemComponentsMessageScrollerRoute
  '/internal/design-system/components/progress-bar': typeof AuthInternalDesignSystemComponentsProgressBarRoute
  '/internal/design-system/components/radios': typeof AuthInternalDesignSystemComponentsRadiosRoute
  '/internal/design-system/components/section-card': typeof AuthInternalDesignSystemComponentsSectionCardRoute
  '/internal/design-system/components/select': typeof AuthInternalDesignSystemComponentsSelectRoute
  '/internal/design-system/components/stat-tile': typeof AuthInternalDesignSystemComponentsStatTileRoute
  '/internal/design-system/components/switches': typeof AuthInternalDesignSystemComponentsSwitchesRoute
  '/internal/design-system/components/text-input': typeof AuthInternalDesignSystemComponentsTextInputRoute
  '/internal/design-system/components/textarea': typeof AuthInternalDesignSystemComponentsTextareaRoute
  '/internal/design-system/components/toast': typeof AuthInternalDesignSystemComponentsToastRoute
  '/internal/design-system/components/trace': typeof AuthInternalDesignSystemComponentsTraceRoute
  '/internal/design-system/components/view-pill': typeof AuthInternalDesignSystemComponentsViewPillRoute
  '/internal/design-system/legacy-components/$slug': typeof AuthInternalDesignSystemLegacyComponentsSlugRoute
  '/internal/design-system/pages/inspector': typeof AuthInternalDesignSystemPagesInspectorRoute
  '/internal/design-system/pages/pages': typeof AuthInternalDesignSystemPagesPagesRoute
  '/internal/design-system/styles/color-tokens': typeof AuthInternalDesignSystemStylesColorTokensRoute
  '/internal/design-system/styles/text-styles': typeof AuthInternalDesignSystemStylesTextStylesRoute
  '/internal/docs/$slug': typeof AuthInternalDocsLayoutSlugRoute
  '/internal/feature-flags/history': typeof AuthInternalFeatureFlagsOverviewHistoryRoute
  '/procurement/incoming-orders/calendar': typeof AuthProcurementIncomingOrdersLayoutCalendarRoute
  '/procurement/incoming-orders/list': typeof AuthProcurementIncomingOrdersLayoutListRoute
  '/procurement/incoming-orders/overview': typeof AuthProcurementIncomingOrdersLayoutOverviewRoute
  '/procurement/order-suggestions/replenishment-suggestions': typeof AuthProcurementOrderSuggestionsLayoutReplenishmentSuggestionsRoute
  '/procurement/purchase-orders/archived': typeof AuthProcurementPurchaseOrdersLayoutArchivedRoute
  '/procurement/purchase-orders/closed': typeof AuthProcurementPurchaseOrdersLayoutClosedRoute
  '/procurement/purchase-orders/draft': typeof AuthProcurementPurchaseOrdersLayoutDraftRoute
  '/procurement/purchase-orders/open': typeof AuthProcurementPurchaseOrdersLayoutOpenRoute
  '/procurement/purchase-orders/update/$purchaseOrderId': typeof AuthProcurementPurchaseOrdersUpdatePurchaseOrderIdRoute
  '/procurement/vendor-management/capacity': typeof AuthProcurementVendorManagementLayoutCapacityRoute
  '/procurement/vendor-management/vendors': typeof AuthProcurementVendorManagementLayoutVendorsRoute
  '/product/$productId/demand': typeof AuthProductProductIdLayoutDemandRoute
  '/product/$productId/finance': typeof AuthProductProductIdLayoutFinanceRoute
  '/product/$productId/forecast': typeof AuthProductProductIdLayoutForecastRoute
  '/product/$productId/forecast-analysis': typeof AuthProductProductIdLayoutForecastAnalysisRoute
  '/product/$productId/inventory': typeof AuthProductProductIdLayoutInventoryRoute
  '/product/$productId/overview': typeof AuthProductProductIdLayoutOverviewRoute
  '/product/$productId/performance': typeof AuthProductProductIdLayoutPerformanceRoute
  '/settings/alerts': typeof AuthSettingsLayoutInternalAlertsRoute
  '/settings/demo': typeof AuthSettingsLayoutInternalDemoRoute
  '/settings/hakio': typeof AuthSettingsLayoutInternalHakioRoute
  '/settings/match-configuration': typeof AuthSettingsLayoutInternalMatchConfigurationRoute
  '/settings/naming': typeof AuthSettingsLayoutInternalNamingRoute
  '/allocation/reports': typeof AuthAllocationLayoutReportsIndexRoute
  '/allocation/settings': typeof AuthAllocationLayoutSettingsIndexRoute
  '/ingestion-cockpit/data-quality': typeof AuthIngestionCockpitLayoutDataQualityIndexRoute
  '/insights/inventory-overview': typeof AuthInsightsInventoryOverviewLayoutIndexRoute
  '/internal/customer-management': typeof AuthInternalCustomerManagementLayoutIndexRoute
  '/internal/customer-success': typeof AuthInternalCustomerSuccessLayoutIndexRoute
  '/internal/docs': typeof AuthInternalDocsLayoutIndexRoute
  '/internal/feature-flags': typeof AuthInternalFeatureFlagsOverviewIndexRoute
  '/product/$productId': typeof AuthProductProductIdLayoutIndexRoute
  '/budgets/$fiscalYear/breakdown': typeof AuthBudgetsLayoutFiscalYearLayoutBreakdownRoute
  '/budgets/$fiscalYear/collections': typeof AuthBudgetsLayoutFiscalYearLayoutCollectionsRoute
  '/demand-planning/fashion/$collectionId/analysis': typeof AuthDemandPlanningFashionCollectionIdLayoutAnalysisRoute
  '/demand-planning/fashion/$collectionId/customers': typeof AuthDemandPlanningFashionCollectionIdLayoutCustomersRoute
  '/demand-planning/fashion/$collectionId/demand': typeof AuthDemandPlanningFashionCollectionIdLayoutDemandRoute
  '/demand-planning/fashion/$collectionId/performance': typeof AuthDemandPlanningFashionCollectionIdLayoutPerformanceRoute
  '/demand-planning/fashion/$collectionId/seasonality': typeof AuthDemandPlanningFashionCollectionIdLayoutSeasonalityRoute
  '/demand-planning/fashion/$collectionId/splits': typeof AuthDemandPlanningFashionCollectionIdLayoutSplitsRoute
  '/demand-planning/fashion/$collectionId/trim': typeof AuthDemandPlanningFashionCollectionIdLayoutTrimRoute
  '/demand-planning/noos/$collectionId/forecast-updates': typeof AuthDemandPlanningNoosCollectionIdLayoutForecastUpdatesRoute
  '/demand-planning/noos/$collectionId/new-variants': typeof AuthDemandPlanningNoosCollectionIdLayoutNewVariantsRoute
  '/demand/fashion/$collectionId/budget': typeof AuthDemandFashionCollectionIdLayoutBudgetRoute
  '/demand/fashion/$collectionId/demand': typeof AuthDemandFashionCollectionIdLayoutDemandRoute
  '/demand/fashion/$collectionId/performance': typeof AuthDemandFashionCollectionIdLayoutPerformanceRoute
  '/demand/fashion/$collectionId/variants': typeof AuthDemandFashionCollectionIdLayoutVariantsRoute
  '/demand/noos/$collectionId/budget': typeof AuthDemandNoosCollectionIdLayoutBudgetRoute
  '/demand/noos/$collectionId/demand': typeof AuthDemandNoosCollectionIdLayoutDemandRoute
  '/demand/noos/$collectionId/performance': typeof AuthDemandNoosCollectionIdLayoutPerformanceRoute
  '/demand/noos/$collectionId/variants': typeof AuthDemandNoosCollectionIdLayoutVariantsRoute
  '/internal/feature-flags/$flagKey/history': typeof AuthInternalFeatureFlagsFlagKeyLayoutHistoryRoute
  '/internal/feature-flags/$flagKey/users': typeof AuthInternalFeatureFlagsFlagKeyLayoutUsersRoute
  '/procurement/supply-plan/$purchasePlanId/capacity': typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutCapacityRoute
  '/procurement/supply-plan/$purchasePlanId/greige': typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutGreigeRoute
  '/procurement/supply-plan/$purchasePlanId/quantities': typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutQuantitiesRoute
  '/demand-planning/fashion/$collectionId': typeof AuthDemandPlanningFashionCollectionIdLayoutIndexRoute
  '/demand-planning/noos/$collectionId': typeof AuthDemandPlanningNoosCollectionIdLayoutIndexRoute
  '/demand/fashion/$collectionId': typeof AuthDemandFashionCollectionIdLayoutIndexRoute
  '/demand/noos/$collectionId': typeof AuthDemandNoosCollectionIdLayoutIndexRoute
  '/internal/feature-flags/$flagKey': typeof AuthInternalFeatureFlagsFlagKeyLayoutIndexRoute
  '/procurement/supply-plan/$purchasePlanId': typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutIndexRoute
  '/budgets/$fiscalYear/$budgetId/allocation-planning': typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutAllocationPlanningRoute
  '/budgets/$fiscalYear/$budgetId/markdown-planning': typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutMarkdownPlanningRoute
  '/budgets/$fiscalYear/$budgetId/sales-prices': typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutSalesPricesRoute
  '/budgets/$fiscalYear/$budgetId/target': typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutTargetRoute
  '/budgets/$fiscalYear/$budgetId/target-report': typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutTargetReportRoute
  '/procurement/supply-plan/collection/$collectionId/capacity': typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutCapacityRoute
  '/procurement/supply-plan/collection/$collectionId/greige': typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutGreigeRoute
  '/procurement/supply-plan/collection/$collectionId/overview': typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutOverviewRoute
  '/procurement/supply-plan/noos/$supplyPlanId/availability': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutAvailabilityRoute
  '/procurement/supply-plan/noos/$supplyPlanId/capacity-planning': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutCapacityPlanningRoute
  '/procurement/supply-plan/noos/$supplyPlanId/greige': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutGreigeRoute
  '/procurement/supply-plan/noos/$supplyPlanId/overview': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutOverviewRoute
  '/procurement/supply-plan/noos/$supplyPlanId/triggers': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutTriggersRoute
  '/budgets/$fiscalYear/$budgetId': typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutIndexRoute
  '/procurement/supply-plan/collection/$collectionId': typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutIndexRoute
  '/procurement/supply-plan/noos/$supplyPlanId': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutIndexRoute
  '/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/capacity': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutCapacityRoute
  '/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/quantities': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutQuantitiesRoute
  '/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/logout': typeof LogoutRoute
  '/_auth/home': typeof AuthHomeRoute
  '/_auth/inbox': typeof AuthInboxRoute
  '/_auth/internal': typeof AuthInternalRouteWithChildren
  '/_auth/reporting': typeof AuthReportingRoute
  '/_auth/setup': typeof AuthSetupRouteWithChildren
  '/login/$orgName': typeof LoginOrgNameRoute
  '/_auth/': typeof AuthIndexRoute
  '/login/': typeof LoginIndexRoute
  '/_auth/allocation/_layout': typeof AuthAllocationLayoutRouteWithChildren
  '/_auth/budgets/_layout': typeof AuthBudgetsLayoutRouteWithChildren
  '/_auth/demand/_layout': typeof AuthDemandLayoutRouteWithChildren
  '/_auth/forecasting/_layout': typeof AuthForecastingLayoutRoute
  '/_auth/ingestion-cockpit/_layout': typeof AuthIngestionCockpitLayoutRouteWithChildren
  '/_auth/insights/availability': typeof AuthInsightsAvailabilityRoute
  '/_auth/insights/customer-insights': typeof AuthInsightsCustomerInsightsRoute
  '/_auth/insights/forecast-calendar': typeof AuthInsightsForecastCalendarRoute
  '/_auth/insights/studio': typeof AuthInsightsStudioRouteWithChildren
  '/_auth/internal/others': typeof AuthInternalOthersRoute
  '/_auth/internal/tv': typeof AuthInternalTvRoute
  '/_auth/product-management/_layout': typeof AuthProductManagementLayoutRouteWithChildren
  '/_auth/settings/_layout': typeof AuthSettingsLayoutRouteWithChildren
  '/_auth/settings/company': typeof AuthSettingsCompanyRoute
  '/_auth/settings/purchase-orders': typeof AuthSettingsPurchaseOrdersRoute
  '/_auth/settings/returns': typeof AuthSettingsReturnsRoute
  '/_auth/setup/$': typeof AuthSetupSplatRoute
  '/_auth/allocation/': typeof AuthAllocationIndexRoute
  '/_auth/collection-management/': typeof AuthCollectionManagementIndexRoute
  '/_auth/data-validation/': typeof AuthDataValidationIndexRoute
  '/_auth/demand-planning/': typeof AuthDemandPlanningIndexRoute
  '/_auth/forecasting/': typeof AuthForecastingIndexRoute
  '/_auth/insights/': typeof AuthInsightsIndexRoute
  '/_auth/market-strategy/': typeof AuthMarketStrategyIndexRoute
  '/_auth/procurement/': typeof AuthProcurementIndexRoute
  '/_auth/product-management/': typeof AuthProductManagementIndexRoute
  '/_auth/prototype/': typeof AuthPrototypeIndexRoute
  '/_auth/settings/': typeof AuthSettingsIndexRoute
  '/_auth/budgets/_layout/$fiscalYear': typeof AuthBudgetsLayoutFiscalYearRouteRouteWithChildren
  '/_auth/allocation/_layout/replenishment': typeof AuthAllocationLayoutReplenishmentRoute
  '/_auth/allocation/_layout/reports': typeof AuthAllocationLayoutReportsRouteWithChildren
  '/_auth/allocation/_layout/settings': typeof AuthAllocationLayoutSettingsRouteWithChildren
  '/_auth/budgets/_layout/timeline': typeof AuthBudgetsLayoutTimelineRoute
  '/_auth/demand-planning/fashion/_layout': typeof AuthDemandPlanningFashionLayoutRouteWithChildren
  '/_auth/demand-planning/noos/_layout': typeof AuthDemandPlanningNoosLayoutRouteWithChildren
  '/_auth/demand/_layout/calendar': typeof AuthDemandLayoutCalendarRoute
  '/_auth/demand/_layout/performance': typeof AuthDemandLayoutPerformanceRoute
  '/_auth/demand/_layout/sales-and-demand': typeof AuthDemandLayoutSalesAndDemandRoute
  '/_auth/ingestion-cockpit/_layout/data-checks': typeof AuthIngestionCockpitLayoutDataChecksRoute
  '/_auth/ingestion-cockpit/_layout/data-quality': typeof AuthIngestionCockpitLayoutDataQualityRouteWithChildren
  '/_auth/ingestion-cockpit/_layout/views': typeof AuthIngestionCockpitLayoutViewsRoute
  '/_auth/insights/inventory-overview/_layout': typeof AuthInsightsInventoryOverviewLayoutRouteWithChildren
  '/_auth/insights/studio/$reportId': typeof AuthInsightsStudioReportIdRoute
  '/_auth/internal/customer-management/_layout': typeof AuthInternalCustomerManagementLayoutRouteWithChildren
  '/_auth/internal/customer-success/_layout': typeof AuthInternalCustomerSuccessLayoutRouteWithChildren
  '/_auth/internal/design-system/graphs': typeof AuthInternalDesignSystemGraphsRoute
  '/_auth/internal/development/charts': typeof AuthInternalDevelopmentChartsRoute
  '/_auth/internal/development/components': typeof AuthInternalDevelopmentComponentsRoute
  '/_auth/internal/docs/_layout': typeof AuthInternalDocsLayoutRouteWithChildren
  '/_auth/internal/feature-flags/_overview': typeof AuthInternalFeatureFlagsOverviewRouteWithChildren
  '/_auth/internal/forecasts/forecast-validation-check': typeof AuthInternalForecastsForecastValidationCheckRoute
  '/_auth/internal/forecasts/forecasting-reports': typeof AuthInternalForecastsForecastingReportsRoute
  '/_auth/procurement/incoming-orders/_layout': typeof AuthProcurementIncomingOrdersLayoutRouteWithChildren
  '/_auth/procurement/order-suggestions/_layout': typeof AuthProcurementOrderSuggestionsLayoutRouteWithChildren
  '/_auth/procurement/purchase-orders/_layout': typeof AuthProcurementPurchaseOrdersLayoutRouteWithChildren
  '/_auth/procurement/purchase-orders/create': typeof AuthProcurementPurchaseOrdersCreateRoute
  '/_auth/procurement/vendor-management/$vendorId': typeof AuthProcurementVendorManagementVendorIdRoute
  '/_auth/procurement/vendor-management/_layout': typeof AuthProcurementVendorManagementLayoutRouteWithChildren
  '/_auth/product-management/_layout/active': typeof AuthProductManagementLayoutActiveRoute
  '/_auth/product-management/_layout/ghost-variants': typeof AuthProductManagementLayoutGhostVariantsRoute
  '/_auth/product-management/_layout/hidden': typeof AuthProductManagementLayoutHiddenRoute
  '/_auth/product-management/_layout/inactive': typeof AuthProductManagementLayoutInactiveRoute
  '/_auth/product-management/_layout/inbox': typeof AuthProductManagementLayoutInboxRoute
  '/_auth/product-management/_layout/linked-variants': typeof AuthProductManagementLayoutLinkedVariantsRoute
  '/_auth/product-management/_layout/needs-attention': typeof AuthProductManagementLayoutNeedsAttentionRoute
  '/_auth/product-management/_layout/phased-out': typeof AuthProductManagementLayoutPhasedOutRoute
  '/_auth/product-management/_layout/phasing-out': typeof AuthProductManagementLayoutPhasingOutRoute
  '/_auth/product-management/_layout/suggested-activations': typeof AuthProductManagementLayoutSuggestedActivationsRoute
  '/_auth/product/$productId/_layout': typeof AuthProductProductIdLayoutRouteWithChildren
  '/_auth/prototype/allocation-planning/$': typeof AuthPrototypeAllocationPlanningSplatRoute
  '/_auth/settings/_layout/_internal': typeof AuthSettingsLayoutInternalRouteWithChildren
  '/_auth/settings/_layout/ai': typeof AuthSettingsLayoutAiRoute
  '/_auth/settings/_layout/channels': typeof AuthSettingsLayoutChannelsRoute
  '/_auth/settings/_layout/custom-data': typeof AuthSettingsLayoutCustomDataRoute
  '/_auth/settings/_layout/demand': typeof AuthSettingsLayoutDemandRoute
  '/_auth/settings/_layout/erp': typeof AuthSettingsLayoutErpRoute
  '/_auth/settings/_layout/general': typeof AuthSettingsLayoutGeneralRoute
  '/_auth/settings/_layout/procurement': typeof AuthSettingsLayoutProcurementRoute
  '/_auth/settings/_layout/rules': typeof AuthSettingsLayoutRulesRoute
  '/_auth/settings/_layout/teams': typeof AuthSettingsLayoutTeamsRoute
  '/_auth/settings/_layout/users': typeof AuthSettingsLayoutUsersRoute
  '/_auth/budgets/_layout/': typeof AuthBudgetsLayoutIndexRoute
  '/_auth/demand-planning/fashion/': typeof AuthDemandPlanningFashionIndexRoute
  '/_auth/demand-planning/noos/': typeof AuthDemandPlanningNoosIndexRoute
  '/_auth/demand/_layout/': typeof AuthDemandLayoutIndexRoute
  '/_auth/ingestion-cockpit/_layout/': typeof AuthIngestionCockpitLayoutIndexRoute
  '/_auth/insights/studio/': typeof AuthInsightsStudioIndexRoute
  '/_auth/internal/design-system/': typeof AuthInternalDesignSystemIndexRoute
  '/_auth/internal/status/': typeof AuthInternalStatusIndexRoute
  '/_auth/procurement/incoming-orders/': typeof AuthProcurementIncomingOrdersIndexRoute
  '/_auth/procurement/order-suggestions/': typeof AuthProcurementOrderSuggestionsIndexRoute
  '/_auth/procurement/purchase-orders/': typeof AuthProcurementPurchaseOrdersIndexRoute
  '/_auth/procurement/supply-plan/': typeof AuthProcurementSupplyPlanIndexRoute
  '/_auth/procurement/vendor-management/': typeof AuthProcurementVendorManagementIndexRoute
  '/_auth/prototype/seasons-collections/': typeof AuthPrototypeSeasonsCollectionsIndexRoute
  '/_auth/allocation/_layout/reports/products': typeof AuthAllocationLayoutReportsProductsRoute
  '/_auth/allocation/_layout/reports/stores': typeof AuthAllocationLayoutReportsStoresRoute
  '/_auth/allocation/_layout/settings/$subTab': typeof AuthAllocationLayoutSettingsSubTabRoute
  '/_auth/budgets/_layout/$fiscalYear/_layout': typeof AuthBudgetsLayoutFiscalYearLayoutRouteWithChildren
  '/_auth/budgets/_layout/year/$year': typeof AuthBudgetsLayoutYearYearRoute
  '/_auth/demand-planning/fashion/$collectionId/_layout': typeof AuthDemandPlanningFashionCollectionIdLayoutRouteWithChildren
  '/_auth/demand-planning/fashion/_layout/tasks': typeof AuthDemandPlanningFashionLayoutTasksRoute
  '/_auth/demand-planning/fashion/_layout/timeline': typeof AuthDemandPlanningFashionLayoutTimelineRoute
  '/_auth/demand-planning/noos/$collectionId/_layout': typeof AuthDemandPlanningNoosCollectionIdLayoutRouteWithChildren
  '/_auth/demand-planning/noos/_layout/tasks': typeof AuthDemandPlanningNoosLayoutTasksRoute
  '/_auth/demand-planning/noos/_layout/timeline': typeof AuthDemandPlanningNoosLayoutTimelineRoute
  '/_auth/demand/fashion/$collectionId/_layout': typeof AuthDemandFashionCollectionIdLayoutRouteWithChildren
  '/_auth/demand/noos/$collectionId/_layout': typeof AuthDemandNoosCollectionIdLayoutRouteWithChildren
  '/_auth/ingestion-cockpit/_layout/data-quality/$checkId': typeof AuthIngestionCockpitLayoutDataQualityCheckIdRoute
  '/_auth/insights/inventory-overview/_layout/calendar': typeof AuthInsightsInventoryOverviewLayoutCalendarRoute
  '/_auth/internal/customer-management/_layout/organizations': typeof AuthInternalCustomerManagementLayoutOrganizationsRoute
  '/_auth/internal/customer-management/_layout/users': typeof AuthInternalCustomerManagementLayoutUsersRoute
  '/_auth/internal/customer-success/_layout/haki-usage': typeof AuthInternalCustomerSuccessLayoutHakiUsageRoute
  '/_auth/internal/customer-success/_layout/impact': typeof AuthInternalCustomerSuccessLayoutImpactRoute
  '/_auth/internal/customer-success/_layout/user-activity': typeof AuthInternalCustomerSuccessLayoutUserActivityRoute
  '/_auth/internal/design-system/components/badges': typeof AuthInternalDesignSystemComponentsBadgesRoute
  '/_auth/internal/design-system/components/baseline-source-card': typeof AuthInternalDesignSystemComponentsBaselineSourceCardRoute
  '/_auth/internal/design-system/components/button-group': typeof AuthInternalDesignSystemComponentsButtonGroupRoute
  '/_auth/internal/design-system/components/buttons': typeof AuthInternalDesignSystemComponentsButtonsRoute
  '/_auth/internal/design-system/components/checkboxes': typeof AuthInternalDesignSystemComponentsCheckboxesRoute
  '/_auth/internal/design-system/components/code-block': typeof AuthInternalDesignSystemComponentsCodeBlockRoute
  '/_auth/internal/design-system/components/command-bar': typeof AuthInternalDesignSystemComponentsCommandBarRoute
  '/_auth/internal/design-system/components/date-picker': typeof AuthInternalDesignSystemComponentsDatePickerRoute
  '/_auth/internal/design-system/components/empty-state': typeof AuthInternalDesignSystemComponentsEmptyStateRoute
  '/_auth/internal/design-system/components/expandable-card': typeof AuthInternalDesignSystemComponentsExpandableCardRoute
  '/_auth/internal/design-system/components/icon-toolbar': typeof AuthInternalDesignSystemComponentsIconToolbarRoute
  '/_auth/internal/design-system/components/inline-alert': typeof AuthInternalDesignSystemComponentsInlineAlertRoute
  '/_auth/internal/design-system/components/link-button': typeof AuthInternalDesignSystemComponentsLinkButtonRoute
  '/_auth/internal/design-system/components/matrix': typeof AuthInternalDesignSystemComponentsMatrixRoute
  '/_auth/internal/design-system/components/message-scroller': typeof AuthInternalDesignSystemComponentsMessageScrollerRoute
  '/_auth/internal/design-system/components/progress-bar': typeof AuthInternalDesignSystemComponentsProgressBarRoute
  '/_auth/internal/design-system/components/radios': typeof AuthInternalDesignSystemComponentsRadiosRoute
  '/_auth/internal/design-system/components/section-card': typeof AuthInternalDesignSystemComponentsSectionCardRoute
  '/_auth/internal/design-system/components/select': typeof AuthInternalDesignSystemComponentsSelectRoute
  '/_auth/internal/design-system/components/stat-tile': typeof AuthInternalDesignSystemComponentsStatTileRoute
  '/_auth/internal/design-system/components/switches': typeof AuthInternalDesignSystemComponentsSwitchesRoute
  '/_auth/internal/design-system/components/text-input': typeof AuthInternalDesignSystemComponentsTextInputRoute
  '/_auth/internal/design-system/components/textarea': typeof AuthInternalDesignSystemComponentsTextareaRoute
  '/_auth/internal/design-system/components/toast': typeof AuthInternalDesignSystemComponentsToastRoute
  '/_auth/internal/design-system/components/trace': typeof AuthInternalDesignSystemComponentsTraceRoute
  '/_auth/internal/design-system/components/view-pill': typeof AuthInternalDesignSystemComponentsViewPillRoute
  '/_auth/internal/design-system/legacy-components/$slug': typeof AuthInternalDesignSystemLegacyComponentsSlugRoute
  '/_auth/internal/design-system/pages/inspector': typeof AuthInternalDesignSystemPagesInspectorRoute
  '/_auth/internal/design-system/pages/pages': typeof AuthInternalDesignSystemPagesPagesRoute
  '/_auth/internal/design-system/styles/color-tokens': typeof AuthInternalDesignSystemStylesColorTokensRoute
  '/_auth/internal/design-system/styles/text-styles': typeof AuthInternalDesignSystemStylesTextStylesRoute
  '/_auth/internal/docs/_layout/$slug': typeof AuthInternalDocsLayoutSlugRoute
  '/_auth/internal/feature-flags/$flagKey/_layout': typeof AuthInternalFeatureFlagsFlagKeyLayoutRouteWithChildren
  '/_auth/internal/feature-flags/_overview/history': typeof AuthInternalFeatureFlagsOverviewHistoryRoute
  '/_auth/procurement/incoming-orders/_layout/calendar': typeof AuthProcurementIncomingOrdersLayoutCalendarRoute
  '/_auth/procurement/incoming-orders/_layout/list': typeof AuthProcurementIncomingOrdersLayoutListRoute
  '/_auth/procurement/incoming-orders/_layout/overview': typeof AuthProcurementIncomingOrdersLayoutOverviewRoute
  '/_auth/procurement/order-suggestions/_layout/replenishment-suggestions': typeof AuthProcurementOrderSuggestionsLayoutReplenishmentSuggestionsRoute
  '/_auth/procurement/purchase-orders/_layout/archived': typeof AuthProcurementPurchaseOrdersLayoutArchivedRoute
  '/_auth/procurement/purchase-orders/_layout/closed': typeof AuthProcurementPurchaseOrdersLayoutClosedRoute
  '/_auth/procurement/purchase-orders/_layout/draft': typeof AuthProcurementPurchaseOrdersLayoutDraftRoute
  '/_auth/procurement/purchase-orders/_layout/open': typeof AuthProcurementPurchaseOrdersLayoutOpenRoute
  '/_auth/procurement/purchase-orders/update/$purchaseOrderId': typeof AuthProcurementPurchaseOrdersUpdatePurchaseOrderIdRoute
  '/_auth/procurement/supply-plan/$purchasePlanId/_layout': typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutRouteWithChildren
  '/_auth/procurement/vendor-management/_layout/capacity': typeof AuthProcurementVendorManagementLayoutCapacityRoute
  '/_auth/procurement/vendor-management/_layout/vendors': typeof AuthProcurementVendorManagementLayoutVendorsRoute
  '/_auth/product/$productId/_layout/demand': typeof AuthProductProductIdLayoutDemandRoute
  '/_auth/product/$productId/_layout/finance': typeof AuthProductProductIdLayoutFinanceRoute
  '/_auth/product/$productId/_layout/forecast': typeof AuthProductProductIdLayoutForecastRoute
  '/_auth/product/$productId/_layout/forecast-analysis': typeof AuthProductProductIdLayoutForecastAnalysisRoute
  '/_auth/product/$productId/_layout/inventory': typeof AuthProductProductIdLayoutInventoryRoute
  '/_auth/product/$productId/_layout/overview': typeof AuthProductProductIdLayoutOverviewRoute
  '/_auth/product/$productId/_layout/performance': typeof AuthProductProductIdLayoutPerformanceRoute
  '/_auth/settings/_layout/_internal/alerts': typeof AuthSettingsLayoutInternalAlertsRoute
  '/_auth/settings/_layout/_internal/demo': typeof AuthSettingsLayoutInternalDemoRoute
  '/_auth/settings/_layout/_internal/hakio': typeof AuthSettingsLayoutInternalHakioRoute
  '/_auth/settings/_layout/_internal/match-configuration': typeof AuthSettingsLayoutInternalMatchConfigurationRoute
  '/_auth/settings/_layout/_internal/naming': typeof AuthSettingsLayoutInternalNamingRoute
  '/_auth/allocation/_layout/reports/': typeof AuthAllocationLayoutReportsIndexRoute
  '/_auth/allocation/_layout/settings/': typeof AuthAllocationLayoutSettingsIndexRoute
  '/_auth/ingestion-cockpit/_layout/data-quality/': typeof AuthIngestionCockpitLayoutDataQualityIndexRoute
  '/_auth/insights/inventory-overview/_layout/': typeof AuthInsightsInventoryOverviewLayoutIndexRoute
  '/_auth/internal/customer-management/_layout/': typeof AuthInternalCustomerManagementLayoutIndexRoute
  '/_auth/internal/customer-success/_layout/': typeof AuthInternalCustomerSuccessLayoutIndexRoute
  '/_auth/internal/docs/_layout/': typeof AuthInternalDocsLayoutIndexRoute
  '/_auth/internal/feature-flags/_overview/': typeof AuthInternalFeatureFlagsOverviewIndexRoute
  '/_auth/product/$productId/_layout/': typeof AuthProductProductIdLayoutIndexRoute
  '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout': typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutRouteWithChildren
  '/_auth/budgets/_layout/$fiscalYear/_layout/breakdown': typeof AuthBudgetsLayoutFiscalYearLayoutBreakdownRoute
  '/_auth/budgets/_layout/$fiscalYear/_layout/collections': typeof AuthBudgetsLayoutFiscalYearLayoutCollectionsRoute
  '/_auth/demand-planning/fashion/$collectionId/_layout/analysis': typeof AuthDemandPlanningFashionCollectionIdLayoutAnalysisRoute
  '/_auth/demand-planning/fashion/$collectionId/_layout/customers': typeof AuthDemandPlanningFashionCollectionIdLayoutCustomersRoute
  '/_auth/demand-planning/fashion/$collectionId/_layout/demand': typeof AuthDemandPlanningFashionCollectionIdLayoutDemandRoute
  '/_auth/demand-planning/fashion/$collectionId/_layout/performance': typeof AuthDemandPlanningFashionCollectionIdLayoutPerformanceRoute
  '/_auth/demand-planning/fashion/$collectionId/_layout/seasonality': typeof AuthDemandPlanningFashionCollectionIdLayoutSeasonalityRoute
  '/_auth/demand-planning/fashion/$collectionId/_layout/splits': typeof AuthDemandPlanningFashionCollectionIdLayoutSplitsRoute
  '/_auth/demand-planning/fashion/$collectionId/_layout/trim': typeof AuthDemandPlanningFashionCollectionIdLayoutTrimRoute
  '/_auth/demand-planning/noos/$collectionId/_layout/forecast-updates': typeof AuthDemandPlanningNoosCollectionIdLayoutForecastUpdatesRoute
  '/_auth/demand-planning/noos/$collectionId/_layout/new-variants': typeof AuthDemandPlanningNoosCollectionIdLayoutNewVariantsRoute
  '/_auth/demand/fashion/$collectionId/_layout/budget': typeof AuthDemandFashionCollectionIdLayoutBudgetRoute
  '/_auth/demand/fashion/$collectionId/_layout/demand': typeof AuthDemandFashionCollectionIdLayoutDemandRoute
  '/_auth/demand/fashion/$collectionId/_layout/performance': typeof AuthDemandFashionCollectionIdLayoutPerformanceRoute
  '/_auth/demand/fashion/$collectionId/_layout/variants': typeof AuthDemandFashionCollectionIdLayoutVariantsRoute
  '/_auth/demand/noos/$collectionId/_layout/budget': typeof AuthDemandNoosCollectionIdLayoutBudgetRoute
  '/_auth/demand/noos/$collectionId/_layout/demand': typeof AuthDemandNoosCollectionIdLayoutDemandRoute
  '/_auth/demand/noos/$collectionId/_layout/performance': typeof AuthDemandNoosCollectionIdLayoutPerformanceRoute
  '/_auth/demand/noos/$collectionId/_layout/variants': typeof AuthDemandNoosCollectionIdLayoutVariantsRoute
  '/_auth/internal/feature-flags/$flagKey/_layout/history': typeof AuthInternalFeatureFlagsFlagKeyLayoutHistoryRoute
  '/_auth/internal/feature-flags/$flagKey/_layout/users': typeof AuthInternalFeatureFlagsFlagKeyLayoutUsersRoute
  '/_auth/procurement/supply-plan/$purchasePlanId/_layout/capacity': typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutCapacityRoute
  '/_auth/procurement/supply-plan/$purchasePlanId/_layout/greige': typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutGreigeRoute
  '/_auth/procurement/supply-plan/$purchasePlanId/_layout/quantities': typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutQuantitiesRoute
  '/_auth/procurement/supply-plan/collection/$collectionId/_layout': typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutRouteWithChildren
  '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRouteWithChildren
  '/_auth/budgets/_layout/$fiscalYear/_layout/': typeof AuthBudgetsLayoutFiscalYearLayoutIndexRoute
  '/_auth/demand-planning/fashion/$collectionId/_layout/': typeof AuthDemandPlanningFashionCollectionIdLayoutIndexRoute
  '/_auth/demand-planning/noos/$collectionId/_layout/': typeof AuthDemandPlanningNoosCollectionIdLayoutIndexRoute
  '/_auth/demand/fashion/$collectionId/_layout/': typeof AuthDemandFashionCollectionIdLayoutIndexRoute
  '/_auth/demand/noos/$collectionId/_layout/': typeof AuthDemandNoosCollectionIdLayoutIndexRoute
  '/_auth/internal/feature-flags/$flagKey/_layout/': typeof AuthInternalFeatureFlagsFlagKeyLayoutIndexRoute
  '/_auth/procurement/supply-plan/$purchasePlanId/_layout/': typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutIndexRoute
  '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/allocation-planning': typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutAllocationPlanningRoute
  '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/markdown-planning': typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutMarkdownPlanningRoute
  '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/sales-prices': typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutSalesPricesRoute
  '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/target': typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutTargetRoute
  '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/target-report': typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutTargetReportRoute
  '/_auth/procurement/supply-plan/collection/$collectionId/_layout/capacity': typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutCapacityRoute
  '/_auth/procurement/supply-plan/collection/$collectionId/_layout/greige': typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutGreigeRoute
  '/_auth/procurement/supply-plan/collection/$collectionId/_layout/overview': typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutOverviewRoute
  '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/availability': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutAvailabilityRoute
  '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/capacity-planning': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutCapacityPlanningRoute
  '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/greige': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutGreigeRoute
  '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/overview': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutOverviewRoute
  '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/triggers': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutTriggersRoute
  '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/': typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutIndexRoute
  '/_auth/procurement/supply-plan/collection/$collectionId/_layout/': typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutIndexRoute
  '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutIndexRoute
  '/_auth/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/_layout': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutRouteWithChildren
  '/_auth/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/_layout/capacity': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutCapacityRoute
  '/_auth/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/_layout/quantities': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutQuantitiesRoute
  '/_auth/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/_layout/': typeof AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/logout'
    | '/home'
    | '/inbox'
    | '/internal'
    | '/reporting'
    | '/setup'
    | '/login/$orgName'
    | '/login/'
    | '/allocation'
    | '/budgets'
    | '/demand'
    | '/forecasting'
    | '/ingestion-cockpit'
    | '/insights/availability'
    | '/insights/customer-insights'
    | '/insights/forecast-calendar'
    | '/insights/studio'
    | '/internal/others'
    | '/internal/tv'
    | '/product-management'
    | '/settings'
    | '/settings/company'
    | '/settings/purchase-orders'
    | '/settings/returns'
    | '/setup/$'
    | '/allocation/'
    | '/collection-management/'
    | '/data-validation/'
    | '/demand-planning/'
    | '/forecasting/'
    | '/insights/'
    | '/market-strategy/'
    | '/procurement/'
    | '/product-management/'
    | '/prototype/'
    | '/settings/'
    | '/budgets/$fiscalYear'
    | '/allocation/replenishment'
    | '/allocation/reports'
    | '/allocation/settings'
    | '/budgets/timeline'
    | '/demand-planning/fashion'
    | '/demand-planning/noos'
    | '/demand/calendar'
    | '/demand/performance'
    | '/demand/sales-and-demand'
    | '/ingestion-cockpit/data-checks'
    | '/ingestion-cockpit/data-quality'
    | '/ingestion-cockpit/views'
    | '/insights/inventory-overview'
    | '/insights/studio/$reportId'
    | '/internal/customer-management'
    | '/internal/customer-success'
    | '/internal/design-system/graphs'
    | '/internal/development/charts'
    | '/internal/development/components'
    | '/internal/docs'
    | '/internal/feature-flags'
    | '/internal/forecasts/forecast-validation-check'
    | '/internal/forecasts/forecasting-reports'
    | '/procurement/incoming-orders'
    | '/procurement/order-suggestions'
    | '/procurement/purchase-orders'
    | '/procurement/purchase-orders/create'
    | '/procurement/vendor-management/$vendorId'
    | '/procurement/vendor-management'
    | '/product-management/active'
    | '/product-management/ghost-variants'
    | '/product-management/hidden'
    | '/product-management/inactive'
    | '/product-management/inbox'
    | '/product-management/linked-variants'
    | '/product-management/needs-attention'
    | '/product-management/phased-out'
    | '/product-management/phasing-out'
    | '/product-management/suggested-activations'
    | '/product/$productId'
    | '/prototype/allocation-planning/$'
    | '/settings/ai'
    | '/settings/channels'
    | '/settings/custom-data'
    | '/settings/demand'
    | '/settings/erp'
    | '/settings/general'
    | '/settings/procurement'
    | '/settings/rules'
    | '/settings/teams'
    | '/settings/users'
    | '/budgets/'
    | '/demand-planning/fashion/'
    | '/demand-planning/noos/'
    | '/demand/'
    | '/ingestion-cockpit/'
    | '/insights/studio/'
    | '/internal/design-system/'
    | '/internal/status/'
    | '/procurement/incoming-orders/'
    | '/procurement/order-suggestions/'
    | '/procurement/purchase-orders/'
    | '/procurement/supply-plan/'
    | '/procurement/vendor-management/'
    | '/prototype/seasons-collections/'
    | '/allocation/reports/products'
    | '/allocation/reports/stores'
    | '/allocation/settings/$subTab'
    | '/budgets/year/$year'
    | '/demand-planning/fashion/$collectionId'
    | '/demand-planning/fashion/tasks'
    | '/demand-planning/fashion/timeline'
    | '/demand-planning/noos/$collectionId'
    | '/demand-planning/noos/tasks'
    | '/demand-planning/noos/timeline'
    | '/demand/fashion/$collectionId'
    | '/demand/noos/$collectionId'
    | '/ingestion-cockpit/data-quality/$checkId'
    | '/insights/inventory-overview/calendar'
    | '/internal/customer-management/organizations'
    | '/internal/customer-management/users'
    | '/internal/customer-success/haki-usage'
    | '/internal/customer-success/impact'
    | '/internal/customer-success/user-activity'
    | '/internal/design-system/components/badges'
    | '/internal/design-system/components/baseline-source-card'
    | '/internal/design-system/components/button-group'
    | '/internal/design-system/components/buttons'
    | '/internal/design-system/components/checkboxes'
    | '/internal/design-system/components/code-block'
    | '/internal/design-system/components/command-bar'
    | '/internal/design-system/components/date-picker'
    | '/internal/design-system/components/empty-state'
    | '/internal/design-system/components/expandable-card'
    | '/internal/design-system/components/icon-toolbar'
    | '/internal/design-system/components/inline-alert'
    | '/internal/design-system/components/link-button'
    | '/internal/design-system/components/matrix'
    | '/internal/design-system/components/message-scroller'
    | '/internal/design-system/components/progress-bar'
    | '/internal/design-system/components/radios'
    | '/internal/design-system/components/section-card'
    | '/internal/design-system/components/select'
    | '/internal/design-system/components/stat-tile'
    | '/internal/design-system/components/switches'
    | '/internal/design-system/components/text-input'
    | '/internal/design-system/components/textarea'
    | '/internal/design-system/components/toast'
    | '/internal/design-system/components/trace'
    | '/internal/design-system/components/view-pill'
    | '/internal/design-system/legacy-components/$slug'
    | '/internal/design-system/pages/inspector'
    | '/internal/design-system/pages/pages'
    | '/internal/design-system/styles/color-tokens'
    | '/internal/design-system/styles/text-styles'
    | '/internal/docs/$slug'
    | '/internal/feature-flags/$flagKey'
    | '/internal/feature-flags/history'
    | '/procurement/incoming-orders/calendar'
    | '/procurement/incoming-orders/list'
    | '/procurement/incoming-orders/overview'
    | '/procurement/order-suggestions/replenishment-suggestions'
    | '/procurement/purchase-orders/archived'
    | '/procurement/purchase-orders/closed'
    | '/procurement/purchase-orders/draft'
    | '/procurement/purchase-orders/open'
    | '/procurement/purchase-orders/update/$purchaseOrderId'
    | '/procurement/supply-plan/$purchasePlanId'
    | '/procurement/vendor-management/capacity'
    | '/procurement/vendor-management/vendors'
    | '/product/$productId/demand'
    | '/product/$productId/finance'
    | '/product/$productId/forecast'
    | '/product/$productId/forecast-analysis'
    | '/product/$productId/inventory'
    | '/product/$productId/overview'
    | '/product/$productId/performance'
    | '/settings/alerts'
    | '/settings/demo'
    | '/settings/hakio'
    | '/settings/match-configuration'
    | '/settings/naming'
    | '/allocation/reports/'
    | '/allocation/settings/'
    | '/ingestion-cockpit/data-quality/'
    | '/insights/inventory-overview/'
    | '/internal/customer-management/'
    | '/internal/customer-success/'
    | '/internal/docs/'
    | '/internal/feature-flags/'
    | '/product/$productId/'
    | '/budgets/$fiscalYear/$budgetId'
    | '/budgets/$fiscalYear/breakdown'
    | '/budgets/$fiscalYear/collections'
    | '/demand-planning/fashion/$collectionId/analysis'
    | '/demand-planning/fashion/$collectionId/customers'
    | '/demand-planning/fashion/$collectionId/demand'
    | '/demand-planning/fashion/$collectionId/performance'
    | '/demand-planning/fashion/$collectionId/seasonality'
    | '/demand-planning/fashion/$collectionId/splits'
    | '/demand-planning/fashion/$collectionId/trim'
    | '/demand-planning/noos/$collectionId/forecast-updates'
    | '/demand-planning/noos/$collectionId/new-variants'
    | '/demand/fashion/$collectionId/budget'
    | '/demand/fashion/$collectionId/demand'
    | '/demand/fashion/$collectionId/performance'
    | '/demand/fashion/$collectionId/variants'
    | '/demand/noos/$collectionId/budget'
    | '/demand/noos/$collectionId/demand'
    | '/demand/noos/$collectionId/performance'
    | '/demand/noos/$collectionId/variants'
    | '/internal/feature-flags/$flagKey/history'
    | '/internal/feature-flags/$flagKey/users'
    | '/procurement/supply-plan/$purchasePlanId/capacity'
    | '/procurement/supply-plan/$purchasePlanId/greige'
    | '/procurement/supply-plan/$purchasePlanId/quantities'
    | '/procurement/supply-plan/collection/$collectionId'
    | '/procurement/supply-plan/noos/$supplyPlanId'
    | '/budgets/$fiscalYear/'
    | '/demand-planning/fashion/$collectionId/'
    | '/demand-planning/noos/$collectionId/'
    | '/demand/fashion/$collectionId/'
    | '/demand/noos/$collectionId/'
    | '/internal/feature-flags/$flagKey/'
    | '/procurement/supply-plan/$purchasePlanId/'
    | '/budgets/$fiscalYear/$budgetId/allocation-planning'
    | '/budgets/$fiscalYear/$budgetId/markdown-planning'
    | '/budgets/$fiscalYear/$budgetId/sales-prices'
    | '/budgets/$fiscalYear/$budgetId/target'
    | '/budgets/$fiscalYear/$budgetId/target-report'
    | '/procurement/supply-plan/collection/$collectionId/capacity'
    | '/procurement/supply-plan/collection/$collectionId/greige'
    | '/procurement/supply-plan/collection/$collectionId/overview'
    | '/procurement/supply-plan/noos/$supplyPlanId/availability'
    | '/procurement/supply-plan/noos/$supplyPlanId/capacity-planning'
    | '/procurement/supply-plan/noos/$supplyPlanId/greige'
    | '/procurement/supply-plan/noos/$supplyPlanId/overview'
    | '/procurement/supply-plan/noos/$supplyPlanId/triggers'
    | '/budgets/$fiscalYear/$budgetId/'
    | '/procurement/supply-plan/collection/$collectionId/'
    | '/procurement/supply-plan/noos/$supplyPlanId/'
    | '/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId'
    | '/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/capacity'
    | '/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/quantities'
    | '/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/logout'
    | '/home'
    | '/inbox'
    | '/internal'
    | '/reporting'
    | '/setup'
    | '/login/$orgName'
    | '/'
    | '/login'
    | '/allocation'
    | '/forecasting'
    | '/insights/availability'
    | '/insights/customer-insights'
    | '/insights/forecast-calendar'
    | '/internal/others'
    | '/internal/tv'
    | '/product-management'
    | '/settings'
    | '/settings/company'
    | '/settings/purchase-orders'
    | '/settings/returns'
    | '/setup/$'
    | '/collection-management'
    | '/data-validation'
    | '/demand-planning'
    | '/insights'
    | '/market-strategy'
    | '/procurement'
    | '/prototype'
    | '/budgets/$fiscalYear'
    | '/allocation/replenishment'
    | '/budgets/timeline'
    | '/demand-planning/fashion'
    | '/demand-planning/noos'
    | '/demand/calendar'
    | '/demand/performance'
    | '/demand/sales-and-demand'
    | '/ingestion-cockpit/data-checks'
    | '/ingestion-cockpit/views'
    | '/insights/studio/$reportId'
    | '/internal/design-system/graphs'
    | '/internal/development/charts'
    | '/internal/development/components'
    | '/internal/forecasts/forecast-validation-check'
    | '/internal/forecasts/forecasting-reports'
    | '/procurement/incoming-orders'
    | '/procurement/order-suggestions'
    | '/procurement/purchase-orders'
    | '/procurement/purchase-orders/create'
    | '/procurement/vendor-management/$vendorId'
    | '/procurement/vendor-management'
    | '/product-management/active'
    | '/product-management/ghost-variants'
    | '/product-management/hidden'
    | '/product-management/inactive'
    | '/product-management/inbox'
    | '/product-management/linked-variants'
    | '/product-management/needs-attention'
    | '/product-management/phased-out'
    | '/product-management/phasing-out'
    | '/product-management/suggested-activations'
    | '/prototype/allocation-planning/$'
    | '/settings/ai'
    | '/settings/channels'
    | '/settings/custom-data'
    | '/settings/demand'
    | '/settings/erp'
    | '/settings/general'
    | '/settings/procurement'
    | '/settings/rules'
    | '/settings/teams'
    | '/settings/users'
    | '/budgets'
    | '/demand'
    | '/ingestion-cockpit'
    | '/insights/studio'
    | '/internal/design-system'
    | '/internal/status'
    | '/procurement/supply-plan'
    | '/prototype/seasons-collections'
    | '/allocation/reports/products'
    | '/allocation/reports/stores'
    | '/allocation/settings/$subTab'
    | '/budgets/year/$year'
    | '/demand-planning/fashion/tasks'
    | '/demand-planning/fashion/timeline'
    | '/demand-planning/noos/tasks'
    | '/demand-planning/noos/timeline'
    | '/ingestion-cockpit/data-quality/$checkId'
    | '/insights/inventory-overview/calendar'
    | '/internal/customer-management/organizations'
    | '/internal/customer-management/users'
    | '/internal/customer-success/haki-usage'
    | '/internal/customer-success/impact'
    | '/internal/customer-success/user-activity'
    | '/internal/design-system/components/badges'
    | '/internal/design-system/components/baseline-source-card'
    | '/internal/design-system/components/button-group'
    | '/internal/design-system/components/buttons'
    | '/internal/design-system/components/checkboxes'
    | '/internal/design-system/components/code-block'
    | '/internal/design-system/components/command-bar'
    | '/internal/design-system/components/date-picker'
    | '/internal/design-system/components/empty-state'
    | '/internal/design-system/components/expandable-card'
    | '/internal/design-system/components/icon-toolbar'
    | '/internal/design-system/components/inline-alert'
    | '/internal/design-system/components/link-button'
    | '/internal/design-system/components/matrix'
    | '/internal/design-system/components/message-scroller'
    | '/internal/design-system/components/progress-bar'
    | '/internal/design-system/components/radios'
    | '/internal/design-system/components/section-card'
    | '/internal/design-system/components/select'
    | '/internal/design-system/components/stat-tile'
    | '/internal/design-system/components/switches'
    | '/internal/design-system/components/text-input'
    | '/internal/design-system/components/textarea'
    | '/internal/design-system/components/toast'
    | '/internal/design-system/components/trace'
    | '/internal/design-system/components/view-pill'
    | '/internal/design-system/legacy-components/$slug'
    | '/internal/design-system/pages/inspector'
    | '/internal/design-system/pages/pages'
    | '/internal/design-system/styles/color-tokens'
    | '/internal/design-system/styles/text-styles'
    | '/internal/docs/$slug'
    | '/internal/feature-flags/history'
    | '/procurement/incoming-orders/calendar'
    | '/procurement/incoming-orders/list'
    | '/procurement/incoming-orders/overview'
    | '/procurement/order-suggestions/replenishment-suggestions'
    | '/procurement/purchase-orders/archived'
    | '/procurement/purchase-orders/closed'
    | '/procurement/purchase-orders/draft'
    | '/procurement/purchase-orders/open'
    | '/procurement/purchase-orders/update/$purchaseOrderId'
    | '/procurement/vendor-management/capacity'
    | '/procurement/vendor-management/vendors'
    | '/product/$productId/demand'
    | '/product/$productId/finance'
    | '/product/$productId/forecast'
    | '/product/$productId/forecast-analysis'
    | '/product/$productId/inventory'
    | '/product/$productId/overview'
    | '/product/$productId/performance'
    | '/settings/alerts'
    | '/settings/demo'
    | '/settings/hakio'
    | '/settings/match-configuration'
    | '/settings/naming'
    | '/allocation/reports'
    | '/allocation/settings'
    | '/ingestion-cockpit/data-quality'
    | '/insights/inventory-overview'
    | '/internal/customer-management'
    | '/internal/customer-success'
    | '/internal/docs'
    | '/internal/feature-flags'
    | '/product/$productId'
    | '/budgets/$fiscalYear/breakdown'
    | '/budgets/$fiscalYear/collections'
    | '/demand-planning/fashion/$collectionId/analysis'
    | '/demand-planning/fashion/$collectionId/customers'
    | '/demand-planning/fashion/$collectionId/demand'
    | '/demand-planning/fashion/$collectionId/performance'
    | '/demand-planning/fashion/$collectionId/seasonality'
    | '/demand-planning/fashion/$collectionId/splits'
    | '/demand-planning/fashion/$collectionId/trim'
    | '/demand-planning/noos/$collectionId/forecast-updates'
    | '/demand-planning/noos/$collectionId/new-variants'
    | '/demand/fashion/$collectionId/budget'
    | '/demand/fashion/$collectionId/demand'
    | '/demand/fashion/$collectionId/performance'
    | '/demand/fashion/$collectionId/variants'
    | '/demand/noos/$collectionId/budget'
    | '/demand/noos/$collectionId/demand'
    | '/demand/noos/$collectionId/performance'
    | '/demand/noos/$collectionId/variants'
    | '/internal/feature-flags/$flagKey/history'
    | '/internal/feature-flags/$flagKey/users'
    | '/procurement/supply-plan/$purchasePlanId/capacity'
    | '/procurement/supply-plan/$purchasePlanId/greige'
    | '/procurement/supply-plan/$purchasePlanId/quantities'
    | '/demand-planning/fashion/$collectionId'
    | '/demand-planning/noos/$collectionId'
    | '/demand/fashion/$collectionId'
    | '/demand/noos/$collectionId'
    | '/internal/feature-flags/$flagKey'
    | '/procurement/supply-plan/$purchasePlanId'
    | '/budgets/$fiscalYear/$budgetId/allocation-planning'
    | '/budgets/$fiscalYear/$budgetId/markdown-planning'
    | '/budgets/$fiscalYear/$budgetId/sales-prices'
    | '/budgets/$fiscalYear/$budgetId/target'
    | '/budgets/$fiscalYear/$budgetId/target-report'
    | '/procurement/supply-plan/collection/$collectionId/capacity'
    | '/procurement/supply-plan/collection/$collectionId/greige'
    | '/procurement/supply-plan/collection/$collectionId/overview'
    | '/procurement/supply-plan/noos/$supplyPlanId/availability'
    | '/procurement/supply-plan/noos/$supplyPlanId/capacity-planning'
    | '/procurement/supply-plan/noos/$supplyPlanId/greige'
    | '/procurement/supply-plan/noos/$supplyPlanId/overview'
    | '/procurement/supply-plan/noos/$supplyPlanId/triggers'
    | '/budgets/$fiscalYear/$budgetId'
    | '/procurement/supply-plan/collection/$collectionId'
    | '/procurement/supply-plan/noos/$supplyPlanId'
    | '/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/capacity'
    | '/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/quantities'
    | '/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId'
  id:
    | '__root__'
    | '/_auth'
    | '/logout'
    | '/_auth/home'
    | '/_auth/inbox'
    | '/_auth/internal'
    | '/_auth/reporting'
    | '/_auth/setup'
    | '/login/$orgName'
    | '/_auth/'
    | '/login/'
    | '/_auth/allocation/_layout'
    | '/_auth/budgets/_layout'
    | '/_auth/demand/_layout'
    | '/_auth/forecasting/_layout'
    | '/_auth/ingestion-cockpit/_layout'
    | '/_auth/insights/availability'
    | '/_auth/insights/customer-insights'
    | '/_auth/insights/forecast-calendar'
    | '/_auth/insights/studio'
    | '/_auth/internal/others'
    | '/_auth/internal/tv'
    | '/_auth/product-management/_layout'
    | '/_auth/settings/_layout'
    | '/_auth/settings/company'
    | '/_auth/settings/purchase-orders'
    | '/_auth/settings/returns'
    | '/_auth/setup/$'
    | '/_auth/allocation/'
    | '/_auth/collection-management/'
    | '/_auth/data-validation/'
    | '/_auth/demand-planning/'
    | '/_auth/forecasting/'
    | '/_auth/insights/'
    | '/_auth/market-strategy/'
    | '/_auth/procurement/'
    | '/_auth/product-management/'
    | '/_auth/prototype/'
    | '/_auth/settings/'
    | '/_auth/budgets/_layout/$fiscalYear'
    | '/_auth/allocation/_layout/replenishment'
    | '/_auth/allocation/_layout/reports'
    | '/_auth/allocation/_layout/settings'
    | '/_auth/budgets/_layout/timeline'
    | '/_auth/demand-planning/fashion/_layout'
    | '/_auth/demand-planning/noos/_layout'
    | '/_auth/demand/_layout/calendar'
    | '/_auth/demand/_layout/performance'
    | '/_auth/demand/_layout/sales-and-demand'
    | '/_auth/ingestion-cockpit/_layout/data-checks'
    | '/_auth/ingestion-cockpit/_layout/data-quality'
    | '/_auth/ingestion-cockpit/_layout/views'
    | '/_auth/insights/inventory-overview/_layout'
    | '/_auth/insights/studio/$reportId'
    | '/_auth/internal/customer-management/_layout'
    | '/_auth/internal/customer-success/_layout'
    | '/_auth/internal/design-system/graphs'
    | '/_auth/internal/development/charts'
    | '/_auth/internal/development/components'
    | '/_auth/internal/docs/_layout'
    | '/_auth/internal/feature-flags/_overview'
    | '/_auth/internal/forecasts/forecast-validation-check'
    | '/_auth/internal/forecasts/forecasting-reports'
    | '/_auth/procurement/incoming-orders/_layout'
    | '/_auth/procurement/order-suggestions/_layout'
    | '/_auth/procurement/purchase-orders/_layout'
    | '/_auth/procurement/purchase-orders/create'
    | '/_auth/procurement/vendor-management/$vendorId'
    | '/_auth/procurement/vendor-management/_layout'
    | '/_auth/product-management/_layout/active'
    | '/_auth/product-management/_layout/ghost-variants'
    | '/_auth/product-management/_layout/hidden'
    | '/_auth/product-management/_layout/inactive'
    | '/_auth/product-management/_layout/inbox'
    | '/_auth/product-management/_layout/linked-variants'
    | '/_auth/product-management/_layout/needs-attention'
    | '/_auth/product-management/_layout/phased-out'
    | '/_auth/product-management/_layout/phasing-out'
    | '/_auth/product-management/_layout/suggested-activations'
    | '/_auth/product/$productId/_layout'
    | '/_auth/prototype/allocation-planning/$'
    | '/_auth/settings/_layout/_internal'
    | '/_auth/settings/_layout/ai'
    | '/_auth/settings/_layout/channels'
    | '/_auth/settings/_layout/custom-data'
    | '/_auth/settings/_layout/demand'
    | '/_auth/settings/_layout/erp'
    | '/_auth/settings/_layout/general'
    | '/_auth/settings/_layout/procurement'
    | '/_auth/settings/_layout/rules'
    | '/_auth/settings/_layout/teams'
    | '/_auth/settings/_layout/users'
    | '/_auth/budgets/_layout/'
    | '/_auth/demand-planning/fashion/'
    | '/_auth/demand-planning/noos/'
    | '/_auth/demand/_layout/'
    | '/_auth/ingestion-cockpit/_layout/'
    | '/_auth/insights/studio/'
    | '/_auth/internal/design-system/'
    | '/_auth/internal/status/'
    | '/_auth/procurement/incoming-orders/'
    | '/_auth/procurement/order-suggestions/'
    | '/_auth/procurement/purchase-orders/'
    | '/_auth/procurement/supply-plan/'
    | '/_auth/procurement/vendor-management/'
    | '/_auth/prototype/seasons-collections/'
    | '/_auth/allocation/_layout/reports/products'
    | '/_auth/allocation/_layout/reports/stores'
    | '/_auth/allocation/_layout/settings/$subTab'
    | '/_auth/budgets/_layout/$fiscalYear/_layout'
    | '/_auth/budgets/_layout/year/$year'
    | '/_auth/demand-planning/fashion/$collectionId/_layout'
    | '/_auth/demand-planning/fashion/_layout/tasks'
    | '/_auth/demand-planning/fashion/_layout/timeline'
    | '/_auth/demand-planning/noos/$collectionId/_layout'
    | '/_auth/demand-planning/noos/_layout/tasks'
    | '/_auth/demand-planning/noos/_layout/timeline'
    | '/_auth/demand/fashion/$collectionId/_layout'
    | '/_auth/demand/noos/$collectionId/_layout'
    | '/_auth/ingestion-cockpit/_layout/data-quality/$checkId'
    | '/_auth/insights/inventory-overview/_layout/calendar'
    | '/_auth/internal/customer-management/_layout/organizations'
    | '/_auth/internal/customer-management/_layout/users'
    | '/_auth/internal/customer-success/_layout/haki-usage'
    | '/_auth/internal/customer-success/_layout/impact'
    | '/_auth/internal/customer-success/_layout/user-activity'
    | '/_auth/internal/design-system/components/badges'
    | '/_auth/internal/design-system/components/baseline-source-card'
    | '/_auth/internal/design-system/components/button-group'
    | '/_auth/internal/design-system/components/buttons'
    | '/_auth/internal/design-system/components/checkboxes'
    | '/_auth/internal/design-system/components/code-block'
    | '/_auth/internal/design-system/components/command-bar'
    | '/_auth/internal/design-system/components/date-picker'
    | '/_auth/internal/design-system/components/empty-state'
    | '/_auth/internal/design-system/components/expandable-card'
    | '/_auth/internal/design-system/components/icon-toolbar'
    | '/_auth/internal/design-system/components/inline-alert'
    | '/_auth/internal/design-system/components/link-button'
    | '/_auth/internal/design-system/components/matrix'
    | '/_auth/internal/design-system/components/message-scroller'
    | '/_auth/internal/design-system/components/progress-bar'
    | '/_auth/internal/design-system/components/radios'
    | '/_auth/internal/design-system/components/section-card'
    | '/_auth/internal/design-system/components/select'
    | '/_auth/internal/design-system/components/stat-tile'
    | '/_auth/internal/design-system/components/switches'
    | '/_auth/internal/design-system/components/text-input'
    | '/_auth/internal/design-system/components/textarea'
    | '/_auth/internal/design-system/components/toast'
    | '/_auth/internal/design-system/components/trace'
    | '/_auth/internal/design-system/components/view-pill'
    | '/_auth/internal/design-system/legacy-components/$slug'
    | '/_auth/internal/design-system/pages/inspector'
    | '/_auth/internal/design-system/pages/pages'
    | '/_auth/internal/design-system/styles/color-tokens'
    | '/_auth/internal/design-system/styles/text-styles'
    | '/_auth/internal/docs/_layout/$slug'
    | '/_auth/internal/feature-flags/$flagKey/_layout'
    | '/_auth/internal/feature-flags/_overview/history'
    | '/_auth/procurement/incoming-orders/_layout/calendar'
    | '/_auth/procurement/incoming-orders/_layout/list'
    | '/_auth/procurement/incoming-orders/_layout/overview'
    | '/_auth/procurement/order-suggestions/_layout/replenishment-suggestions'
    | '/_auth/procurement/purchase-orders/_layout/archived'
    | '/_auth/procurement/purchase-orders/_layout/closed'
    | '/_auth/procurement/purchase-orders/_layout/draft'
    | '/_auth/procurement/purchase-orders/_layout/open'
    | '/_auth/procurement/purchase-orders/update/$purchaseOrderId'
    | '/_auth/procurement/supply-plan/$purchasePlanId/_layout'
    | '/_auth/procurement/vendor-management/_layout/capacity'
    | '/_auth/procurement/vendor-management/_layout/vendors'
    | '/_auth/product/$productId/_layout/demand'
    | '/_auth/product/$productId/_layout/finance'
    | '/_auth/product/$productId/_layout/forecast'
    | '/_auth/product/$productId/_layout/forecast-analysis'
    | '/_auth/product/$productId/_layout/inventory'
    | '/_auth/product/$productId/_layout/overview'
    | '/_auth/product/$productId/_layout/performance'
    | '/_auth/settings/_layout/_internal/alerts'
    | '/_auth/settings/_layout/_internal/demo'
    | '/_auth/settings/_layout/_internal/hakio'
    | '/_auth/settings/_layout/_internal/match-configuration'
    | '/_auth/settings/_layout/_internal/naming'
    | '/_auth/allocation/_layout/reports/'
    | '/_auth/allocation/_layout/settings/'
    | '/_auth/ingestion-cockpit/_layout/data-quality/'
    | '/_auth/insights/inventory-overview/_layout/'
    | '/_auth/internal/customer-management/_layout/'
    | '/_auth/internal/customer-success/_layout/'
    | '/_auth/internal/docs/_layout/'
    | '/_auth/internal/feature-flags/_overview/'
    | '/_auth/product/$productId/_layout/'
    | '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout'
    | '/_auth/budgets/_layout/$fiscalYear/_layout/breakdown'
    | '/_auth/budgets/_layout/$fiscalYear/_layout/collections'
    | '/_auth/demand-planning/fashion/$collectionId/_layout/analysis'
    | '/_auth/demand-planning/fashion/$collectionId/_layout/customers'
    | '/_auth/demand-planning/fashion/$collectionId/_layout/demand'
    | '/_auth/demand-planning/fashion/$collectionId/_layout/performance'
    | '/_auth/demand-planning/fashion/$collectionId/_layout/seasonality'
    | '/_auth/demand-planning/fashion/$collectionId/_layout/splits'
    | '/_auth/demand-planning/fashion/$collectionId/_layout/trim'
    | '/_auth/demand-planning/noos/$collectionId/_layout/forecast-updates'
    | '/_auth/demand-planning/noos/$collectionId/_layout/new-variants'
    | '/_auth/demand/fashion/$collectionId/_layout/budget'
    | '/_auth/demand/fashion/$collectionId/_layout/demand'
    | '/_auth/demand/fashion/$collectionId/_layout/performance'
    | '/_auth/demand/fashion/$collectionId/_layout/variants'
    | '/_auth/demand/noos/$collectionId/_layout/budget'
    | '/_auth/demand/noos/$collectionId/_layout/demand'
    | '/_auth/demand/noos/$collectionId/_layout/performance'
    | '/_auth/demand/noos/$collectionId/_layout/variants'
    | '/_auth/internal/feature-flags/$flagKey/_layout/history'
    | '/_auth/internal/feature-flags/$flagKey/_layout/users'
    | '/_auth/procurement/supply-plan/$purchasePlanId/_layout/capacity'
    | '/_auth/procurement/supply-plan/$purchasePlanId/_layout/greige'
    | '/_auth/procurement/supply-plan/$purchasePlanId/_layout/quantities'
    | '/_auth/procurement/supply-plan/collection/$collectionId/_layout'
    | '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout'
    | '/_auth/budgets/_layout/$fiscalYear/_layout/'
    | '/_auth/demand-planning/fashion/$collectionId/_layout/'
    | '/_auth/demand-planning/noos/$collectionId/_layout/'
    | '/_auth/demand/fashion/$collectionId/_layout/'
    | '/_auth/demand/noos/$collectionId/_layout/'
    | '/_auth/internal/feature-flags/$flagKey/_layout/'
    | '/_auth/procurement/supply-plan/$purchasePlanId/_layout/'
    | '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/allocation-planning'
    | '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/markdown-planning'
    | '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/sales-prices'
    | '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/target'
    | '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/target-report'
    | '/_auth/procurement/supply-plan/collection/$collectionId/_layout/capacity'
    | '/_auth/procurement/supply-plan/collection/$collectionId/_layout/greige'
    | '/_auth/procurement/supply-plan/collection/$collectionId/_layout/overview'
    | '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/availability'
    | '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/capacity-planning'
    | '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/greige'
    | '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/overview'
    | '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/triggers'
    | '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/'
    | '/_auth/procurement/supply-plan/collection/$collectionId/_layout/'
    | '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/'
    | '/_auth/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/_layout'
    | '/_auth/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/_layout/capacity'
    | '/_auth/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/_layout/quantities'
    | '/_auth/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/_layout/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  LogoutRoute: typeof LogoutRoute
  LoginOrgNameRoute: typeof LoginOrgNameRoute
  LoginIndexRoute: typeof LoginIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/home': {
      id: '/_auth/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthHomeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/inbox': {
      id: '/_auth/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AuthInboxRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/internal': {
      id: '/_auth/internal'
      path: '/internal'
      fullPath: '/internal'
      preLoaderRoute: typeof AuthInternalRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reporting': {
      id: '/_auth/reporting'
      path: '/reporting'
      fullPath: '/reporting'
      preLoaderRoute: typeof AuthReportingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/setup': {
      id: '/_auth/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof AuthSetupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/$orgName': {
      id: '/login/$orgName'
      path: '/login/$orgName'
      fullPath: '/login/$orgName'
      preLoaderRoute: typeof LoginOrgNameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/allocation/': {
      id: '/_auth/allocation/'
      path: '/allocation'
      fullPath: '/allocation/'
      preLoaderRoute: typeof AuthAllocationIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/allocation/_layout': {
      id: '/_auth/allocation/_layout'
      path: '/allocation'
      fullPath: '/allocation'
      preLoaderRoute: typeof AuthAllocationLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/budgets/_layout': {
      id: '/_auth/budgets/_layout'
      path: '/budgets'
      fullPath: '/budgets'
      preLoaderRoute: typeof AuthBudgetsLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/collection-management/': {
      id: '/_auth/collection-management/'
      path: '/collection-management'
      fullPath: '/collection-management/'
      preLoaderRoute: typeof AuthCollectionManagementIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/data-validation/': {
      id: '/_auth/data-validation/'
      path: '/data-validation'
      fullPath: '/data-validation/'
      preLoaderRoute: typeof AuthDataValidationIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/demand-planning/': {
      id: '/_auth/demand-planning/'
      path: '/demand-planning'
      fullPath: '/demand-planning/'
      preLoaderRoute: typeof AuthDemandPlanningIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/demand/_layout': {
      id: '/_auth/demand/_layout'
      path: '/demand'
      fullPath: '/demand'
      preLoaderRoute: typeof AuthDemandLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forecasting/': {
      id: '/_auth/forecasting/'
      path: '/forecasting'
      fullPath: '/forecasting/'
      preLoaderRoute: typeof AuthForecastingIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forecasting/_layout': {
      id: '/_auth/forecasting/_layout'
      path: '/forecasting'
      fullPath: '/forecasting'
      preLoaderRoute: typeof AuthForecastingLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/ingestion-cockpit/_layout': {
      id: '/_auth/ingestion-cockpit/_layout'
      path: '/ingestion-cockpit'
      fullPath: '/ingestion-cockpit'
      preLoaderRoute: typeof AuthIngestionCockpitLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/insights/': {
      id: '/_auth/insights/'
      path: '/insights'
      fullPath: '/insights/'
      preLoaderRoute: typeof AuthInsightsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/insights/availability': {
      id: '/_auth/insights/availability'
      path: '/insights/availability'
      fullPath: '/insights/availability'
      preLoaderRoute: typeof AuthInsightsAvailabilityRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/insights/customer-insights': {
      id: '/_auth/insights/customer-insights'
      path: '/insights/customer-insights'
      fullPath: '/insights/customer-insights'
      preLoaderRoute: typeof AuthInsightsCustomerInsightsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/insights/forecast-calendar': {
      id: '/_auth/insights/forecast-calendar'
      path: '/insights/forecast-calendar'
      fullPath: '/insights/forecast-calendar'
      preLoaderRoute: typeof AuthInsightsForecastCalendarRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/insights/studio': {
      id: '/_auth/insights/studio'
      path: '/insights/studio'
      fullPath: '/insights/studio'
      preLoaderRoute: typeof AuthInsightsStudioRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/internal/others': {
      id: '/_auth/internal/others'
      path: '/others'
      fullPath: '/internal/others'
      preLoaderRoute: typeof AuthInternalOthersRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/tv': {
      id: '/_auth/internal/tv'
      path: '/tv'
      fullPath: '/internal/tv'
      preLoaderRoute: typeof AuthInternalTvRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/market-strategy/': {
      id: '/_auth/market-strategy/'
      path: '/market-strategy'
      fullPath: '/market-strategy/'
      preLoaderRoute: typeof AuthMarketStrategyIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/procurement/': {
      id: '/_auth/procurement/'
      path: '/procurement'
      fullPath: '/procurement/'
      preLoaderRoute: typeof AuthProcurementIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product-management/': {
      id: '/_auth/product-management/'
      path: '/product-management'
      fullPath: '/product-management/'
      preLoaderRoute: typeof AuthProductManagementIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product-management/_layout': {
      id: '/_auth/product-management/_layout'
      path: '/product-management'
      fullPath: '/product-management'
      preLoaderRoute: typeof AuthProductManagementLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/prototype/': {
      id: '/_auth/prototype/'
      path: '/prototype'
      fullPath: '/prototype/'
      preLoaderRoute: typeof AuthPrototypeIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/': {
      id: '/_auth/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthSettingsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/_layout': {
      id: '/_auth/settings/_layout'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/company': {
      id: '/_auth/settings/company'
      path: '/settings/company'
      fullPath: '/settings/company'
      preLoaderRoute: typeof AuthSettingsCompanyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/purchase-orders': {
      id: '/_auth/settings/purchase-orders'
      path: '/settings/purchase-orders'
      fullPath: '/settings/purchase-orders'
      preLoaderRoute: typeof AuthSettingsPurchaseOrdersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/returns': {
      id: '/_auth/settings/returns'
      path: '/settings/returns'
      fullPath: '/settings/returns'
      preLoaderRoute: typeof AuthSettingsReturnsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/setup/$': {
      id: '/_auth/setup/$'
      path: '/$'
      fullPath: '/setup/$'
      preLoaderRoute: typeof AuthSetupSplatRouteImport
      parentRoute: typeof AuthSetupRoute
    }
    '/_auth/allocation/_layout/replenishment': {
      id: '/_auth/allocation/_layout/replenishment'
      path: '/replenishment'
      fullPath: '/allocation/replenishment'
      preLoaderRoute: typeof AuthAllocationLayoutReplenishmentRouteImport
      parentRoute: typeof AuthAllocationLayoutRoute
    }
    '/_auth/allocation/_layout/reports': {
      id: '/_auth/allocation/_layout/reports'
      path: '/reports'
      fullPath: '/allocation/reports'
      preLoaderRoute: typeof AuthAllocationLayoutReportsRouteImport
      parentRoute: typeof AuthAllocationLayoutRoute
    }
    '/_auth/allocation/_layout/settings': {
      id: '/_auth/allocation/_layout/settings'
      path: '/settings'
      fullPath: '/allocation/settings'
      preLoaderRoute: typeof AuthAllocationLayoutSettingsRouteImport
      parentRoute: typeof AuthAllocationLayoutRoute
    }
    '/_auth/budgets/_layout/': {
      id: '/_auth/budgets/_layout/'
      path: '/'
      fullPath: '/budgets/'
      preLoaderRoute: typeof AuthBudgetsLayoutIndexRouteImport
      parentRoute: typeof AuthBudgetsLayoutRoute
    }
    '/_auth/budgets/_layout/$fiscalYear': {
      id: '/_auth/budgets/_layout/$fiscalYear'
      path: '/$fiscalYear'
      fullPath: '/budgets/$fiscalYear'
      preLoaderRoute: typeof AuthBudgetsLayoutFiscalYearRouteRouteImport
      parentRoute: typeof AuthBudgetsLayoutRoute
    }
    '/_auth/budgets/_layout/timeline': {
      id: '/_auth/budgets/_layout/timeline'
      path: '/timeline'
      fullPath: '/budgets/timeline'
      preLoaderRoute: typeof AuthBudgetsLayoutTimelineRouteImport
      parentRoute: typeof AuthBudgetsLayoutRoute
    }
    '/_auth/demand-planning/fashion/': {
      id: '/_auth/demand-planning/fashion/'
      path: '/demand-planning/fashion'
      fullPath: '/demand-planning/fashion/'
      preLoaderRoute: typeof AuthDemandPlanningFashionIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/demand-planning/fashion/_layout': {
      id: '/_auth/demand-planning/fashion/_layout'
      path: '/demand-planning/fashion'
      fullPath: '/demand-planning/fashion'
      preLoaderRoute: typeof AuthDemandPlanningFashionLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/demand-planning/noos/': {
      id: '/_auth/demand-planning/noos/'
      path: '/demand-planning/noos'
      fullPath: '/demand-planning/noos/'
      preLoaderRoute: typeof AuthDemandPlanningNoosIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/demand-planning/noos/_layout': {
      id: '/_auth/demand-planning/noos/_layout'
      path: '/demand-planning/noos'
      fullPath: '/demand-planning/noos'
      preLoaderRoute: typeof AuthDemandPlanningNoosLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/demand/_layout/': {
      id: '/_auth/demand/_layout/'
      path: '/'
      fullPath: '/demand/'
      preLoaderRoute: typeof AuthDemandLayoutIndexRouteImport
      parentRoute: typeof AuthDemandLayoutRoute
    }
    '/_auth/demand/_layout/calendar': {
      id: '/_auth/demand/_layout/calendar'
      path: '/calendar'
      fullPath: '/demand/calendar'
      preLoaderRoute: typeof AuthDemandLayoutCalendarRouteImport
      parentRoute: typeof AuthDemandLayoutRoute
    }
    '/_auth/demand/_layout/performance': {
      id: '/_auth/demand/_layout/performance'
      path: '/performance'
      fullPath: '/demand/performance'
      preLoaderRoute: typeof AuthDemandLayoutPerformanceRouteImport
      parentRoute: typeof AuthDemandLayoutRoute
    }
    '/_auth/demand/_layout/sales-and-demand': {
      id: '/_auth/demand/_layout/sales-and-demand'
      path: '/sales-and-demand'
      fullPath: '/demand/sales-and-demand'
      preLoaderRoute: typeof AuthDemandLayoutSalesAndDemandRouteImport
      parentRoute: typeof AuthDemandLayoutRoute
    }
    '/_auth/ingestion-cockpit/_layout/': {
      id: '/_auth/ingestion-cockpit/_layout/'
      path: '/'
      fullPath: '/ingestion-cockpit/'
      preLoaderRoute: typeof AuthIngestionCockpitLayoutIndexRouteImport
      parentRoute: typeof AuthIngestionCockpitLayoutRoute
    }
    '/_auth/ingestion-cockpit/_layout/data-checks': {
      id: '/_auth/ingestion-cockpit/_layout/data-checks'
      path: '/data-checks'
      fullPath: '/ingestion-cockpit/data-checks'
      preLoaderRoute: typeof AuthIngestionCockpitLayoutDataChecksRouteImport
      parentRoute: typeof AuthIngestionCockpitLayoutRoute
    }
    '/_auth/ingestion-cockpit/_layout/data-quality': {
      id: '/_auth/ingestion-cockpit/_layout/data-quality'
      path: '/data-quality'
      fullPath: '/ingestion-cockpit/data-quality'
      preLoaderRoute: typeof AuthIngestionCockpitLayoutDataQualityRouteImport
      parentRoute: typeof AuthIngestionCockpitLayoutRoute
    }
    '/_auth/ingestion-cockpit/_layout/views': {
      id: '/_auth/ingestion-cockpit/_layout/views'
      path: '/views'
      fullPath: '/ingestion-cockpit/views'
      preLoaderRoute: typeof AuthIngestionCockpitLayoutViewsRouteImport
      parentRoute: typeof AuthIngestionCockpitLayoutRoute
    }
    '/_auth/insights/inventory-overview/_layout': {
      id: '/_auth/insights/inventory-overview/_layout'
      path: '/insights/inventory-overview'
      fullPath: '/insights/inventory-overview'
      preLoaderRoute: typeof AuthInsightsInventoryOverviewLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/insights/studio/': {
      id: '/_auth/insights/studio/'
      path: '/'
      fullPath: '/insights/studio/'
      preLoaderRoute: typeof AuthInsightsStudioIndexRouteImport
      parentRoute: typeof AuthInsightsStudioRoute
    }
    '/_auth/insights/studio/$reportId': {
      id: '/_auth/insights/studio/$reportId'
      path: '/$reportId'
      fullPath: '/insights/studio/$reportId'
      preLoaderRoute: typeof AuthInsightsStudioReportIdRouteImport
      parentRoute: typeof AuthInsightsStudioRoute
    }
    '/_auth/internal/customer-management/_layout': {
      id: '/_auth/internal/customer-management/_layout'
      path: '/customer-management'
      fullPath: '/internal/customer-management'
      preLoaderRoute: typeof AuthInternalCustomerManagementLayoutRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/customer-success/_layout': {
      id: '/_auth/internal/customer-success/_layout'
      path: '/customer-success'
      fullPath: '/internal/customer-success'
      preLoaderRoute: typeof AuthInternalCustomerSuccessLayoutRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/': {
      id: '/_auth/internal/design-system/'
      path: '/design-system'
      fullPath: '/internal/design-system/'
      preLoaderRoute: typeof AuthInternalDesignSystemIndexRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/graphs': {
      id: '/_auth/internal/design-system/graphs'
      path: '/design-system/graphs'
      fullPath: '/internal/design-system/graphs'
      preLoaderRoute: typeof AuthInternalDesignSystemGraphsRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/development/charts': {
      id: '/_auth/internal/development/charts'
      path: '/development/charts'
      fullPath: '/internal/development/charts'
      preLoaderRoute: typeof AuthInternalDevelopmentChartsRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/development/components': {
      id: '/_auth/internal/development/components'
      path: '/development/components'
      fullPath: '/internal/development/components'
      preLoaderRoute: typeof AuthInternalDevelopmentComponentsRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/docs/_layout': {
      id: '/_auth/internal/docs/_layout'
      path: '/docs'
      fullPath: '/internal/docs'
      preLoaderRoute: typeof AuthInternalDocsLayoutRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/feature-flags/_overview': {
      id: '/_auth/internal/feature-flags/_overview'
      path: '/feature-flags'
      fullPath: '/internal/feature-flags'
      preLoaderRoute: typeof AuthInternalFeatureFlagsOverviewRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/forecasts/forecast-validation-check': {
      id: '/_auth/internal/forecasts/forecast-validation-check'
      path: '/forecasts/forecast-validation-check'
      fullPath: '/internal/forecasts/forecast-validation-check'
      preLoaderRoute: typeof AuthInternalForecastsForecastValidationCheckRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/forecasts/forecasting-reports': {
      id: '/_auth/internal/forecasts/forecasting-reports'
      path: '/forecasts/forecasting-reports'
      fullPath: '/internal/forecasts/forecasting-reports'
      preLoaderRoute: typeof AuthInternalForecastsForecastingReportsRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/status/': {
      id: '/_auth/internal/status/'
      path: '/status'
      fullPath: '/internal/status/'
      preLoaderRoute: typeof AuthInternalStatusIndexRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/procurement/incoming-orders/': {
      id: '/_auth/procurement/incoming-orders/'
      path: '/procurement/incoming-orders'
      fullPath: '/procurement/incoming-orders/'
      preLoaderRoute: typeof AuthProcurementIncomingOrdersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/procurement/incoming-orders/_layout': {
      id: '/_auth/procurement/incoming-orders/_layout'
      path: '/procurement/incoming-orders'
      fullPath: '/procurement/incoming-orders'
      preLoaderRoute: typeof AuthProcurementIncomingOrdersLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/procurement/order-suggestions/': {
      id: '/_auth/procurement/order-suggestions/'
      path: '/procurement/order-suggestions'
      fullPath: '/procurement/order-suggestions/'
      preLoaderRoute: typeof AuthProcurementOrderSuggestionsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/procurement/order-suggestions/_layout': {
      id: '/_auth/procurement/order-suggestions/_layout'
      path: '/procurement/order-suggestions'
      fullPath: '/procurement/order-suggestions'
      preLoaderRoute: typeof AuthProcurementOrderSuggestionsLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/procurement/purchase-orders/': {
      id: '/_auth/procurement/purchase-orders/'
      path: '/procurement/purchase-orders'
      fullPath: '/procurement/purchase-orders/'
      preLoaderRoute: typeof AuthProcurementPurchaseOrdersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/procurement/purchase-orders/_layout': {
      id: '/_auth/procurement/purchase-orders/_layout'
      path: '/procurement/purchase-orders'
      fullPath: '/procurement/purchase-orders'
      preLoaderRoute: typeof AuthProcurementPurchaseOrdersLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/procurement/purchase-orders/create': {
      id: '/_auth/procurement/purchase-orders/create'
      path: '/procurement/purchase-orders/create'
      fullPath: '/procurement/purchase-orders/create'
      preLoaderRoute: typeof AuthProcurementPurchaseOrdersCreateRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/procurement/supply-plan/': {
      id: '/_auth/procurement/supply-plan/'
      path: '/procurement/supply-plan'
      fullPath: '/procurement/supply-plan/'
      preLoaderRoute: typeof AuthProcurementSupplyPlanIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/procurement/vendor-management/': {
      id: '/_auth/procurement/vendor-management/'
      path: '/procurement/vendor-management'
      fullPath: '/procurement/vendor-management/'
      preLoaderRoute: typeof AuthProcurementVendorManagementIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/procurement/vendor-management/$vendorId': {
      id: '/_auth/procurement/vendor-management/$vendorId'
      path: '/procurement/vendor-management/$vendorId'
      fullPath: '/procurement/vendor-management/$vendorId'
      preLoaderRoute: typeof AuthProcurementVendorManagementVendorIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/procurement/vendor-management/_layout': {
      id: '/_auth/procurement/vendor-management/_layout'
      path: '/procurement/vendor-management'
      fullPath: '/procurement/vendor-management'
      preLoaderRoute: typeof AuthProcurementVendorManagementLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product-management/_layout/active': {
      id: '/_auth/product-management/_layout/active'
      path: '/active'
      fullPath: '/product-management/active'
      preLoaderRoute: typeof AuthProductManagementLayoutActiveRouteImport
      parentRoute: typeof AuthProductManagementLayoutRoute
    }
    '/_auth/product-management/_layout/ghost-variants': {
      id: '/_auth/product-management/_layout/ghost-variants'
      path: '/ghost-variants'
      fullPath: '/product-management/ghost-variants'
      preLoaderRoute: typeof AuthProductManagementLayoutGhostVariantsRouteImport
      parentRoute: typeof AuthProductManagementLayoutRoute
    }
    '/_auth/product-management/_layout/hidden': {
      id: '/_auth/product-management/_layout/hidden'
      path: '/hidden'
      fullPath: '/product-management/hidden'
      preLoaderRoute: typeof AuthProductManagementLayoutHiddenRouteImport
      parentRoute: typeof AuthProductManagementLayoutRoute
    }
    '/_auth/product-management/_layout/inactive': {
      id: '/_auth/product-management/_layout/inactive'
      path: '/inactive'
      fullPath: '/product-management/inactive'
      preLoaderRoute: typeof AuthProductManagementLayoutInactiveRouteImport
      parentRoute: typeof AuthProductManagementLayoutRoute
    }
    '/_auth/product-management/_layout/inbox': {
      id: '/_auth/product-management/_layout/inbox'
      path: '/inbox'
      fullPath: '/product-management/inbox'
      preLoaderRoute: typeof AuthProductManagementLayoutInboxRouteImport
      parentRoute: typeof AuthProductManagementLayoutRoute
    }
    '/_auth/product-management/_layout/linked-variants': {
      id: '/_auth/product-management/_layout/linked-variants'
      path: '/linked-variants'
      fullPath: '/product-management/linked-variants'
      preLoaderRoute: typeof AuthProductManagementLayoutLinkedVariantsRouteImport
      parentRoute: typeof AuthProductManagementLayoutRoute
    }
    '/_auth/product-management/_layout/needs-attention': {
      id: '/_auth/product-management/_layout/needs-attention'
      path: '/needs-attention'
      fullPath: '/product-management/needs-attention'
      preLoaderRoute: typeof AuthProductManagementLayoutNeedsAttentionRouteImport
      parentRoute: typeof AuthProductManagementLayoutRoute
    }
    '/_auth/product-management/_layout/phased-out': {
      id: '/_auth/product-management/_layout/phased-out'
      path: '/phased-out'
      fullPath: '/product-management/phased-out'
      preLoaderRoute: typeof AuthProductManagementLayoutPhasedOutRouteImport
      parentRoute: typeof AuthProductManagementLayoutRoute
    }
    '/_auth/product-management/_layout/phasing-out': {
      id: '/_auth/product-management/_layout/phasing-out'
      path: '/phasing-out'
      fullPath: '/product-management/phasing-out'
      preLoaderRoute: typeof AuthProductManagementLayoutPhasingOutRouteImport
      parentRoute: typeof AuthProductManagementLayoutRoute
    }
    '/_auth/product-management/_layout/suggested-activations': {
      id: '/_auth/product-management/_layout/suggested-activations'
      path: '/suggested-activations'
      fullPath: '/product-management/suggested-activations'
      preLoaderRoute: typeof AuthProductManagementLayoutSuggestedActivationsRouteImport
      parentRoute: typeof AuthProductManagementLayoutRoute
    }
    '/_auth/product/$productId/_layout': {
      id: '/_auth/product/$productId/_layout'
      path: '/product/$productId'
      fullPath: '/product/$productId'
      preLoaderRoute: typeof AuthProductProductIdLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/prototype/allocation-planning/$': {
      id: '/_auth/prototype/allocation-planning/$'
      path: '/prototype/allocation-planning/$'
      fullPath: '/prototype/allocation-planning/$'
      preLoaderRoute: typeof AuthPrototypeAllocationPlanningSplatRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/prototype/seasons-collections/': {
      id: '/_auth/prototype/seasons-collections/'
      path: '/prototype/seasons-collections'
      fullPath: '/prototype/seasons-collections/'
      preLoaderRoute: typeof AuthPrototypeSeasonsCollectionsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/_layout/_internal': {
      id: '/_auth/settings/_layout/_internal'
      path: ''
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsLayoutInternalRouteImport
      parentRoute: typeof AuthSettingsLayoutRoute
    }
    '/_auth/settings/_layout/ai': {
      id: '/_auth/settings/_layout/ai'
      path: '/ai'
      fullPath: '/settings/ai'
      preLoaderRoute: typeof AuthSettingsLayoutAiRouteImport
      parentRoute: typeof AuthSettingsLayoutRoute
    }
    '/_auth/settings/_layout/channels': {
      id: '/_auth/settings/_layout/channels'
      path: '/channels'
      fullPath: '/settings/channels'
      preLoaderRoute: typeof AuthSettingsLayoutChannelsRouteImport
      parentRoute: typeof AuthSettingsLayoutRoute
    }
    '/_auth/settings/_layout/custom-data': {
      id: '/_auth/settings/_layout/custom-data'
      path: '/custom-data'
      fullPath: '/settings/custom-data'
      preLoaderRoute: typeof AuthSettingsLayoutCustomDataRouteImport
      parentRoute: typeof AuthSettingsLayoutRoute
    }
    '/_auth/settings/_layout/demand': {
      id: '/_auth/settings/_layout/demand'
      path: '/demand'
      fullPath: '/settings/demand'
      preLoaderRoute: typeof AuthSettingsLayoutDemandRouteImport
      parentRoute: typeof AuthSettingsLayoutRoute
    }
    '/_auth/settings/_layout/erp': {
      id: '/_auth/settings/_layout/erp'
      path: '/erp'
      fullPath: '/settings/erp'
      preLoaderRoute: typeof AuthSettingsLayoutErpRouteImport
      parentRoute: typeof AuthSettingsLayoutRoute
    }
    '/_auth/settings/_layout/general': {
      id: '/_auth/settings/_layout/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof AuthSettingsLayoutGeneralRouteImport
      parentRoute: typeof AuthSettingsLayoutRoute
    }
    '/_auth/settings/_layout/procurement': {
      id: '/_auth/settings/_layout/procurement'
      path: '/procurement'
      fullPath: '/settings/procurement'
      preLoaderRoute: typeof AuthSettingsLayoutProcurementRouteImport
      parentRoute: typeof AuthSettingsLayoutRoute
    }
    '/_auth/settings/_layout/rules': {
      id: '/_auth/settings/_layout/rules'
      path: '/rules'
      fullPath: '/settings/rules'
      preLoaderRoute: typeof AuthSettingsLayoutRulesRouteImport
      parentRoute: typeof AuthSettingsLayoutRoute
    }
    '/_auth/settings/_layout/teams': {
      id: '/_auth/settings/_layout/teams'
      path: '/teams'
      fullPath: '/settings/teams'
      preLoaderRoute: typeof AuthSettingsLayoutTeamsRouteImport
      parentRoute: typeof AuthSettingsLayoutRoute
    }
    '/_auth/settings/_layout/users': {
      id: '/_auth/settings/_layout/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AuthSettingsLayoutUsersRouteImport
      parentRoute: typeof AuthSettingsLayoutRoute
    }
    '/_auth/allocation/_layout/reports/': {
      id: '/_auth/allocation/_layout/reports/'
      path: '/'
      fullPath: '/allocation/reports/'
      preLoaderRoute: typeof AuthAllocationLayoutReportsIndexRouteImport
      parentRoute: typeof AuthAllocationLayoutReportsRoute
    }
    '/_auth/allocation/_layout/reports/products': {
      id: '/_auth/allocation/_layout/reports/products'
      path: '/products'
      fullPath: '/allocation/reports/products'
      preLoaderRoute: typeof AuthAllocationLayoutReportsProductsRouteImport
      parentRoute: typeof AuthAllocationLayoutReportsRoute
    }
    '/_auth/allocation/_layout/reports/stores': {
      id: '/_auth/allocation/_layout/reports/stores'
      path: '/stores'
      fullPath: '/allocation/reports/stores'
      preLoaderRoute: typeof AuthAllocationLayoutReportsStoresRouteImport
      parentRoute: typeof AuthAllocationLayoutReportsRoute
    }
    '/_auth/allocation/_layout/settings/': {
      id: '/_auth/allocation/_layout/settings/'
      path: '/'
      fullPath: '/allocation/settings/'
      preLoaderRoute: typeof AuthAllocationLayoutSettingsIndexRouteImport
      parentRoute: typeof AuthAllocationLayoutSettingsRoute
    }
    '/_auth/allocation/_layout/settings/$subTab': {
      id: '/_auth/allocation/_layout/settings/$subTab'
      path: '/$subTab'
      fullPath: '/allocation/settings/$subTab'
      preLoaderRoute: typeof AuthAllocationLayoutSettingsSubTabRouteImport
      parentRoute: typeof AuthAllocationLayoutSettingsRoute
    }
    '/_auth/budgets/_layout/$fiscalYear/_layout': {
      id: '/_auth/budgets/_layout/$fiscalYear/_layout'
      path: ''
      fullPath: '/budgets/$fiscalYear'
      preLoaderRoute: typeof AuthBudgetsLayoutFiscalYearLayoutRouteImport
      parentRoute: typeof AuthBudgetsLayoutFiscalYearRouteRoute
    }
    '/_auth/budgets/_layout/year/$year': {
      id: '/_auth/budgets/_layout/year/$year'
      path: '/year/$year'
      fullPath: '/budgets/year/$year'
      preLoaderRoute: typeof AuthBudgetsLayoutYearYearRouteImport
      parentRoute: typeof AuthBudgetsLayoutRoute
    }
    '/_auth/demand-planning/fashion/$collectionId/_layout': {
      id: '/_auth/demand-planning/fashion/$collectionId/_layout'
      path: '/demand-planning/fashion/$collectionId'
      fullPath: '/demand-planning/fashion/$collectionId'
      preLoaderRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/demand-planning/fashion/_layout/tasks': {
      id: '/_auth/demand-planning/fashion/_layout/tasks'
      path: '/tasks'
      fullPath: '/demand-planning/fashion/tasks'
      preLoaderRoute: typeof AuthDemandPlanningFashionLayoutTasksRouteImport
      parentRoute: typeof AuthDemandPlanningFashionLayoutRoute
    }
    '/_auth/demand-planning/fashion/_layout/timeline': {
      id: '/_auth/demand-planning/fashion/_layout/timeline'
      path: '/timeline'
      fullPath: '/demand-planning/fashion/timeline'
      preLoaderRoute: typeof AuthDemandPlanningFashionLayoutTimelineRouteImport
      parentRoute: typeof AuthDemandPlanningFashionLayoutRoute
    }
    '/_auth/demand-planning/noos/$collectionId/_layout': {
      id: '/_auth/demand-planning/noos/$collectionId/_layout'
      path: '/demand-planning/noos/$collectionId'
      fullPath: '/demand-planning/noos/$collectionId'
      preLoaderRoute: typeof AuthDemandPlanningNoosCollectionIdLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/demand-planning/noos/_layout/tasks': {
      id: '/_auth/demand-planning/noos/_layout/tasks'
      path: '/tasks'
      fullPath: '/demand-planning/noos/tasks'
      preLoaderRoute: typeof AuthDemandPlanningNoosLayoutTasksRouteImport
      parentRoute: typeof AuthDemandPlanningNoosLayoutRoute
    }
    '/_auth/demand-planning/noos/_layout/timeline': {
      id: '/_auth/demand-planning/noos/_layout/timeline'
      path: '/timeline'
      fullPath: '/demand-planning/noos/timeline'
      preLoaderRoute: typeof AuthDemandPlanningNoosLayoutTimelineRouteImport
      parentRoute: typeof AuthDemandPlanningNoosLayoutRoute
    }
    '/_auth/demand/fashion/$collectionId/_layout': {
      id: '/_auth/demand/fashion/$collectionId/_layout'
      path: '/demand/fashion/$collectionId'
      fullPath: '/demand/fashion/$collectionId'
      preLoaderRoute: typeof AuthDemandFashionCollectionIdLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/demand/noos/$collectionId/_layout': {
      id: '/_auth/demand/noos/$collectionId/_layout'
      path: '/demand/noos/$collectionId'
      fullPath: '/demand/noos/$collectionId'
      preLoaderRoute: typeof AuthDemandNoosCollectionIdLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/ingestion-cockpit/_layout/data-quality/': {
      id: '/_auth/ingestion-cockpit/_layout/data-quality/'
      path: '/'
      fullPath: '/ingestion-cockpit/data-quality/'
      preLoaderRoute: typeof AuthIngestionCockpitLayoutDataQualityIndexRouteImport
      parentRoute: typeof AuthIngestionCockpitLayoutDataQualityRoute
    }
    '/_auth/ingestion-cockpit/_layout/data-quality/$checkId': {
      id: '/_auth/ingestion-cockpit/_layout/data-quality/$checkId'
      path: '/$checkId'
      fullPath: '/ingestion-cockpit/data-quality/$checkId'
      preLoaderRoute: typeof AuthIngestionCockpitLayoutDataQualityCheckIdRouteImport
      parentRoute: typeof AuthIngestionCockpitLayoutDataQualityRoute
    }
    '/_auth/insights/inventory-overview/_layout/': {
      id: '/_auth/insights/inventory-overview/_layout/'
      path: '/'
      fullPath: '/insights/inventory-overview/'
      preLoaderRoute: typeof AuthInsightsInventoryOverviewLayoutIndexRouteImport
      parentRoute: typeof AuthInsightsInventoryOverviewLayoutRoute
    }
    '/_auth/insights/inventory-overview/_layout/calendar': {
      id: '/_auth/insights/inventory-overview/_layout/calendar'
      path: '/calendar'
      fullPath: '/insights/inventory-overview/calendar'
      preLoaderRoute: typeof AuthInsightsInventoryOverviewLayoutCalendarRouteImport
      parentRoute: typeof AuthInsightsInventoryOverviewLayoutRoute
    }
    '/_auth/internal/customer-management/_layout/': {
      id: '/_auth/internal/customer-management/_layout/'
      path: '/'
      fullPath: '/internal/customer-management/'
      preLoaderRoute: typeof AuthInternalCustomerManagementLayoutIndexRouteImport
      parentRoute: typeof AuthInternalCustomerManagementLayoutRoute
    }
    '/_auth/internal/customer-management/_layout/organizations': {
      id: '/_auth/internal/customer-management/_layout/organizations'
      path: '/organizations'
      fullPath: '/internal/customer-management/organizations'
      preLoaderRoute: typeof AuthInternalCustomerManagementLayoutOrganizationsRouteImport
      parentRoute: typeof AuthInternalCustomerManagementLayoutRoute
    }
    '/_auth/internal/customer-management/_layout/users': {
      id: '/_auth/internal/customer-management/_layout/users'
      path: '/users'
      fullPath: '/internal/customer-management/users'
      preLoaderRoute: typeof AuthInternalCustomerManagementLayoutUsersRouteImport
      parentRoute: typeof AuthInternalCustomerManagementLayoutRoute
    }
    '/_auth/internal/customer-success/_layout/': {
      id: '/_auth/internal/customer-success/_layout/'
      path: '/'
      fullPath: '/internal/customer-success/'
      preLoaderRoute: typeof AuthInternalCustomerSuccessLayoutIndexRouteImport
      parentRoute: typeof AuthInternalCustomerSuccessLayoutRoute
    }
    '/_auth/internal/customer-success/_layout/haki-usage': {
      id: '/_auth/internal/customer-success/_layout/haki-usage'
      path: '/haki-usage'
      fullPath: '/internal/customer-success/haki-usage'
      preLoaderRoute: typeof AuthInternalCustomerSuccessLayoutHakiUsageRouteImport
      parentRoute: typeof AuthInternalCustomerSuccessLayoutRoute
    }
    '/_auth/internal/customer-success/_layout/impact': {
      id: '/_auth/internal/customer-success/_layout/impact'
      path: '/impact'
      fullPath: '/internal/customer-success/impact'
      preLoaderRoute: typeof AuthInternalCustomerSuccessLayoutImpactRouteImport
      parentRoute: typeof AuthInternalCustomerSuccessLayoutRoute
    }
    '/_auth/internal/customer-success/_layout/user-activity': {
      id: '/_auth/internal/customer-success/_layout/user-activity'
      path: '/user-activity'
      fullPath: '/internal/customer-success/user-activity'
      preLoaderRoute: typeof AuthInternalCustomerSuccessLayoutUserActivityRouteImport
      parentRoute: typeof AuthInternalCustomerSuccessLayoutRoute
    }
    '/_auth/internal/design-system/components/badges': {
      id: '/_auth/internal/design-system/components/badges'
      path: '/design-system/components/badges'
      fullPath: '/internal/design-system/components/badges'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsBadgesRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/baseline-source-card': {
      id: '/_auth/internal/design-system/components/baseline-source-card'
      path: '/design-system/components/baseline-source-card'
      fullPath: '/internal/design-system/components/baseline-source-card'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsBaselineSourceCardRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/button-group': {
      id: '/_auth/internal/design-system/components/button-group'
      path: '/design-system/components/button-group'
      fullPath: '/internal/design-system/components/button-group'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsButtonGroupRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/buttons': {
      id: '/_auth/internal/design-system/components/buttons'
      path: '/design-system/components/buttons'
      fullPath: '/internal/design-system/components/buttons'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsButtonsRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/checkboxes': {
      id: '/_auth/internal/design-system/components/checkboxes'
      path: '/design-system/components/checkboxes'
      fullPath: '/internal/design-system/components/checkboxes'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsCheckboxesRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/code-block': {
      id: '/_auth/internal/design-system/components/code-block'
      path: '/design-system/components/code-block'
      fullPath: '/internal/design-system/components/code-block'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsCodeBlockRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/command-bar': {
      id: '/_auth/internal/design-system/components/command-bar'
      path: '/design-system/components/command-bar'
      fullPath: '/internal/design-system/components/command-bar'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsCommandBarRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/date-picker': {
      id: '/_auth/internal/design-system/components/date-picker'
      path: '/design-system/components/date-picker'
      fullPath: '/internal/design-system/components/date-picker'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsDatePickerRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/empty-state': {
      id: '/_auth/internal/design-system/components/empty-state'
      path: '/design-system/components/empty-state'
      fullPath: '/internal/design-system/components/empty-state'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsEmptyStateRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/expandable-card': {
      id: '/_auth/internal/design-system/components/expandable-card'
      path: '/design-system/components/expandable-card'
      fullPath: '/internal/design-system/components/expandable-card'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsExpandableCardRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/icon-toolbar': {
      id: '/_auth/internal/design-system/components/icon-toolbar'
      path: '/design-system/components/icon-toolbar'
      fullPath: '/internal/design-system/components/icon-toolbar'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsIconToolbarRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/inline-alert': {
      id: '/_auth/internal/design-system/components/inline-alert'
      path: '/design-system/components/inline-alert'
      fullPath: '/internal/design-system/components/inline-alert'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsInlineAlertRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/link-button': {
      id: '/_auth/internal/design-system/components/link-button'
      path: '/design-system/components/link-button'
      fullPath: '/internal/design-system/components/link-button'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsLinkButtonRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/matrix': {
      id: '/_auth/internal/design-system/components/matrix'
      path: '/design-system/components/matrix'
      fullPath: '/internal/design-system/components/matrix'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsMatrixRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/message-scroller': {
      id: '/_auth/internal/design-system/components/message-scroller'
      path: '/design-system/components/message-scroller'
      fullPath: '/internal/design-system/components/message-scroller'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsMessageScrollerRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/progress-bar': {
      id: '/_auth/internal/design-system/components/progress-bar'
      path: '/design-system/components/progress-bar'
      fullPath: '/internal/design-system/components/progress-bar'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsProgressBarRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/radios': {
      id: '/_auth/internal/design-system/components/radios'
      path: '/design-system/components/radios'
      fullPath: '/internal/design-system/components/radios'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsRadiosRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/section-card': {
      id: '/_auth/internal/design-system/components/section-card'
      path: '/design-system/components/section-card'
      fullPath: '/internal/design-system/components/section-card'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsSectionCardRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/select': {
      id: '/_auth/internal/design-system/components/select'
      path: '/design-system/components/select'
      fullPath: '/internal/design-system/components/select'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsSelectRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/stat-tile': {
      id: '/_auth/internal/design-system/components/stat-tile'
      path: '/design-system/components/stat-tile'
      fullPath: '/internal/design-system/components/stat-tile'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsStatTileRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/switches': {
      id: '/_auth/internal/design-system/components/switches'
      path: '/design-system/components/switches'
      fullPath: '/internal/design-system/components/switches'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsSwitchesRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/text-input': {
      id: '/_auth/internal/design-system/components/text-input'
      path: '/design-system/components/text-input'
      fullPath: '/internal/design-system/components/text-input'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsTextInputRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/textarea': {
      id: '/_auth/internal/design-system/components/textarea'
      path: '/design-system/components/textarea'
      fullPath: '/internal/design-system/components/textarea'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsTextareaRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/toast': {
      id: '/_auth/internal/design-system/components/toast'
      path: '/design-system/components/toast'
      fullPath: '/internal/design-system/components/toast'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsToastRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/trace': {
      id: '/_auth/internal/design-system/components/trace'
      path: '/design-system/components/trace'
      fullPath: '/internal/design-system/components/trace'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsTraceRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/components/view-pill': {
      id: '/_auth/internal/design-system/components/view-pill'
      path: '/design-system/components/view-pill'
      fullPath: '/internal/design-system/components/view-pill'
      preLoaderRoute: typeof AuthInternalDesignSystemComponentsViewPillRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/legacy-components/$slug': {
      id: '/_auth/internal/design-system/legacy-components/$slug'
      path: '/design-system/legacy-components/$slug'
      fullPath: '/internal/design-system/legacy-components/$slug'
      preLoaderRoute: typeof AuthInternalDesignSystemLegacyComponentsSlugRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/pages/inspector': {
      id: '/_auth/internal/design-system/pages/inspector'
      path: '/design-system/pages/inspector'
      fullPath: '/internal/design-system/pages/inspector'
      preLoaderRoute: typeof AuthInternalDesignSystemPagesInspectorRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/pages/pages': {
      id: '/_auth/internal/design-system/pages/pages'
      path: '/design-system/pages/pages'
      fullPath: '/internal/design-system/pages/pages'
      preLoaderRoute: typeof AuthInternalDesignSystemPagesPagesRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/styles/color-tokens': {
      id: '/_auth/internal/design-system/styles/color-tokens'
      path: '/design-system/styles/color-tokens'
      fullPath: '/internal/design-system/styles/color-tokens'
      preLoaderRoute: typeof AuthInternalDesignSystemStylesColorTokensRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/design-system/styles/text-styles': {
      id: '/_auth/internal/design-system/styles/text-styles'
      path: '/design-system/styles/text-styles'
      fullPath: '/internal/design-system/styles/text-styles'
      preLoaderRoute: typeof AuthInternalDesignSystemStylesTextStylesRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/docs/_layout/': {
      id: '/_auth/internal/docs/_layout/'
      path: '/'
      fullPath: '/internal/docs/'
      preLoaderRoute: typeof AuthInternalDocsLayoutIndexRouteImport
      parentRoute: typeof AuthInternalDocsLayoutRoute
    }
    '/_auth/internal/docs/_layout/$slug': {
      id: '/_auth/internal/docs/_layout/$slug'
      path: '/$slug'
      fullPath: '/internal/docs/$slug'
      preLoaderRoute: typeof AuthInternalDocsLayoutSlugRouteImport
      parentRoute: typeof AuthInternalDocsLayoutRoute
    }
    '/_auth/internal/feature-flags/$flagKey/_layout': {
      id: '/_auth/internal/feature-flags/$flagKey/_layout'
      path: '/feature-flags/$flagKey'
      fullPath: '/internal/feature-flags/$flagKey'
      preLoaderRoute: typeof AuthInternalFeatureFlagsFlagKeyLayoutRouteImport
      parentRoute: typeof AuthInternalRoute
    }
    '/_auth/internal/feature-flags/_overview/': {
      id: '/_auth/internal/feature-flags/_overview/'
      path: '/'
      fullPath: '/internal/feature-flags/'
      preLoaderRoute: typeof AuthInternalFeatureFlagsOverviewIndexRouteImport
      parentRoute: typeof AuthInternalFeatureFlagsOverviewRoute
    }
    '/_auth/internal/feature-flags/_overview/history': {
      id: '/_auth/internal/feature-flags/_overview/history'
      path: '/history'
      fullPath: '/internal/feature-flags/history'
      preLoaderRoute: typeof AuthInternalFeatureFlagsOverviewHistoryRouteImport
      parentRoute: typeof AuthInternalFeatureFlagsOverviewRoute
    }
    '/_auth/procurement/incoming-orders/_layout/calendar': {
      id: '/_auth/procurement/incoming-orders/_layout/calendar'
      path: '/calendar'
      fullPath: '/procurement/incoming-orders/calendar'
      preLoaderRoute: typeof AuthProcurementIncomingOrdersLayoutCalendarRouteImport
      parentRoute: typeof AuthProcurementIncomingOrdersLayoutRoute
    }
    '/_auth/procurement/incoming-orders/_layout/list': {
      id: '/_auth/procurement/incoming-orders/_layout/list'
      path: '/list'
      fullPath: '/procurement/incoming-orders/list'
      preLoaderRoute: typeof AuthProcurementIncomingOrdersLayoutListRouteImport
      parentRoute: typeof AuthProcurementIncomingOrdersLayoutRoute
    }
    '/_auth/procurement/incoming-orders/_layout/overview': {
      id: '/_auth/procurement/incoming-orders/_layout/overview'
      path: '/overview'
      fullPath: '/procurement/incoming-orders/overview'
      preLoaderRoute: typeof AuthProcurementIncomingOrdersLayoutOverviewRouteImport
      parentRoute: typeof AuthProcurementIncomingOrdersLayoutRoute
    }
    '/_auth/procurement/order-suggestions/_layout/replenishment-suggestions': {
      id: '/_auth/procurement/order-suggestions/_layout/replenishment-suggestions'
      path: '/replenishment-suggestions'
      fullPath: '/procurement/order-suggestions/replenishment-suggestions'
      preLoaderRoute: typeof AuthProcurementOrderSuggestionsLayoutReplenishmentSuggestionsRouteImport
      parentRoute: typeof AuthProcurementOrderSuggestionsLayoutRoute
    }
    '/_auth/procurement/purchase-orders/_layout/archived': {
      id: '/_auth/procurement/purchase-orders/_layout/archived'
      path: '/archived'
      fullPath: '/procurement/purchase-orders/archived'
      preLoaderRoute: typeof AuthProcurementPurchaseOrdersLayoutArchivedRouteImport
      parentRoute: typeof AuthProcurementPurchaseOrdersLayoutRoute
    }
    '/_auth/procurement/purchase-orders/_layout/closed': {
      id: '/_auth/procurement/purchase-orders/_layout/closed'
      path: '/closed'
      fullPath: '/procurement/purchase-orders/closed'
      preLoaderRoute: typeof AuthProcurementPurchaseOrdersLayoutClosedRouteImport
      parentRoute: typeof AuthProcurementPurchaseOrdersLayoutRoute
    }
    '/_auth/procurement/purchase-orders/_layout/draft': {
      id: '/_auth/procurement/purchase-orders/_layout/draft'
      path: '/draft'
      fullPath: '/procurement/purchase-orders/draft'
      preLoaderRoute: typeof AuthProcurementPurchaseOrdersLayoutDraftRouteImport
      parentRoute: typeof AuthProcurementPurchaseOrdersLayoutRoute
    }
    '/_auth/procurement/purchase-orders/_layout/open': {
      id: '/_auth/procurement/purchase-orders/_layout/open'
      path: '/open'
      fullPath: '/procurement/purchase-orders/open'
      preLoaderRoute: typeof AuthProcurementPurchaseOrdersLayoutOpenRouteImport
      parentRoute: typeof AuthProcurementPurchaseOrdersLayoutRoute
    }
    '/_auth/procurement/purchase-orders/update/$purchaseOrderId': {
      id: '/_auth/procurement/purchase-orders/update/$purchaseOrderId'
      path: '/procurement/purchase-orders/update/$purchaseOrderId'
      fullPath: '/procurement/purchase-orders/update/$purchaseOrderId'
      preLoaderRoute: typeof AuthProcurementPurchaseOrdersUpdatePurchaseOrderIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/procurement/supply-plan/$purchasePlanId/_layout': {
      id: '/_auth/procurement/supply-plan/$purchasePlanId/_layout'
      path: '/procurement/supply-plan/$purchasePlanId'
      fullPath: '/procurement/supply-plan/$purchasePlanId'
      preLoaderRoute: typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/procurement/vendor-management/_layout/capacity': {
      id: '/_auth/procurement/vendor-management/_layout/capacity'
      path: '/capacity'
      fullPath: '/procurement/vendor-management/capacity'
      preLoaderRoute: typeof AuthProcurementVendorManagementLayoutCapacityRouteImport
      parentRoute: typeof AuthProcurementVendorManagementLayoutRoute
    }
    '/_auth/procurement/vendor-management/_layout/vendors': {
      id: '/_auth/procurement/vendor-management/_layout/vendors'
      path: '/vendors'
      fullPath: '/procurement/vendor-management/vendors'
      preLoaderRoute: typeof AuthProcurementVendorManagementLayoutVendorsRouteImport
      parentRoute: typeof AuthProcurementVendorManagementLayoutRoute
    }
    '/_auth/product/$productId/_layout/': {
      id: '/_auth/product/$productId/_layout/'
      path: '/'
      fullPath: '/product/$productId/'
      preLoaderRoute: typeof AuthProductProductIdLayoutIndexRouteImport
      parentRoute: typeof AuthProductProductIdLayoutRoute
    }
    '/_auth/product/$productId/_layout/demand': {
      id: '/_auth/product/$productId/_layout/demand'
      path: '/demand'
      fullPath: '/product/$productId/demand'
      preLoaderRoute: typeof AuthProductProductIdLayoutDemandRouteImport
      parentRoute: typeof AuthProductProductIdLayoutRoute
    }
    '/_auth/product/$productId/_layout/finance': {
      id: '/_auth/product/$productId/_layout/finance'
      path: '/finance'
      fullPath: '/product/$productId/finance'
      preLoaderRoute: typeof AuthProductProductIdLayoutFinanceRouteImport
      parentRoute: typeof AuthProductProductIdLayoutRoute
    }
    '/_auth/product/$productId/_layout/forecast': {
      id: '/_auth/product/$productId/_layout/forecast'
      path: '/forecast'
      fullPath: '/product/$productId/forecast'
      preLoaderRoute: typeof AuthProductProductIdLayoutForecastRouteImport
      parentRoute: typeof AuthProductProductIdLayoutRoute
    }
    '/_auth/product/$productId/_layout/forecast-analysis': {
      id: '/_auth/product/$productId/_layout/forecast-analysis'
      path: '/forecast-analysis'
      fullPath: '/product/$productId/forecast-analysis'
      preLoaderRoute: typeof AuthProductProductIdLayoutForecastAnalysisRouteImport
      parentRoute: typeof AuthProductProductIdLayoutRoute
    }
    '/_auth/product/$productId/_layout/inventory': {
      id: '/_auth/product/$productId/_layout/inventory'
      path: '/inventory'
      fullPath: '/product/$productId/inventory'
      preLoaderRoute: typeof AuthProductProductIdLayoutInventoryRouteImport
      parentRoute: typeof AuthProductProductIdLayoutRoute
    }
    '/_auth/product/$productId/_layout/overview': {
      id: '/_auth/product/$productId/_layout/overview'
      path: '/overview'
      fullPath: '/product/$productId/overview'
      preLoaderRoute: typeof AuthProductProductIdLayoutOverviewRouteImport
      parentRoute: typeof AuthProductProductIdLayoutRoute
    }
    '/_auth/product/$productId/_layout/performance': {
      id: '/_auth/product/$productId/_layout/performance'
      path: '/performance'
      fullPath: '/product/$productId/performance'
      preLoaderRoute: typeof AuthProductProductIdLayoutPerformanceRouteImport
      parentRoute: typeof AuthProductProductIdLayoutRoute
    }
    '/_auth/settings/_layout/_internal/alerts': {
      id: '/_auth/settings/_layout/_internal/alerts'
      path: '/alerts'
      fullPath: '/settings/alerts'
      preLoaderRoute: typeof AuthSettingsLayoutInternalAlertsRouteImport
      parentRoute: typeof AuthSettingsLayoutInternalRoute
    }
    '/_auth/settings/_layout/_internal/demo': {
      id: '/_auth/settings/_layout/_internal/demo'
      path: '/demo'
      fullPath: '/settings/demo'
      preLoaderRoute: typeof AuthSettingsLayoutInternalDemoRouteImport
      parentRoute: typeof AuthSettingsLayoutInternalRoute
    }
    '/_auth/settings/_layout/_internal/hakio': {
      id: '/_auth/settings/_layout/_internal/hakio'
      path: '/hakio'
      fullPath: '/settings/hakio'
      preLoaderRoute: typeof AuthSettingsLayoutInternalHakioRouteImport
      parentRoute: typeof AuthSettingsLayoutInternalRoute
    }
    '/_auth/settings/_layout/_internal/match-configuration': {
      id: '/_auth/settings/_layout/_internal/match-configuration'
      path: '/match-configuration'
      fullPath: '/settings/match-configuration'
      preLoaderRoute: typeof AuthSettingsLayoutInternalMatchConfigurationRouteImport
      parentRoute: typeof AuthSettingsLayoutInternalRoute
    }
    '/_auth/settings/_layout/_internal/naming': {
      id: '/_auth/settings/_layout/_internal/naming'
      path: '/naming'
      fullPath: '/settings/naming'
      preLoaderRoute: typeof AuthSettingsLayoutInternalNamingRouteImport
      parentRoute: typeof AuthSettingsLayoutInternalRoute
    }
    '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout': {
      id: '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout'
      path: '/$budgetId'
      fullPath: '/budgets/$fiscalYear/$budgetId'
      preLoaderRoute: typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutRouteImport
      parentRoute: typeof AuthBudgetsLayoutFiscalYearRouteRoute
    }
    '/_auth/budgets/_layout/$fiscalYear/_layout/': {
      id: '/_auth/budgets/_layout/$fiscalYear/_layout/'
      path: '/'
      fullPath: '/budgets/$fiscalYear/'
      preLoaderRoute: typeof AuthBudgetsLayoutFiscalYearLayoutIndexRouteImport
      parentRoute: typeof AuthBudgetsLayoutFiscalYearLayoutRoute
    }
    '/_auth/budgets/_layout/$fiscalYear/_layout/breakdown': {
      id: '/_auth/budgets/_layout/$fiscalYear/_layout/breakdown'
      path: '/breakdown'
      fullPath: '/budgets/$fiscalYear/breakdown'
      preLoaderRoute: typeof AuthBudgetsLayoutFiscalYearLayoutBreakdownRouteImport
      parentRoute: typeof AuthBudgetsLayoutFiscalYearLayoutRoute
    }
    '/_auth/budgets/_layout/$fiscalYear/_layout/collections': {
      id: '/_auth/budgets/_layout/$fiscalYear/_layout/collections'
      path: '/collections'
      fullPath: '/budgets/$fiscalYear/collections'
      preLoaderRoute: typeof AuthBudgetsLayoutFiscalYearLayoutCollectionsRouteImport
      parentRoute: typeof AuthBudgetsLayoutFiscalYearLayoutRoute
    }
    '/_auth/demand-planning/fashion/$collectionId/_layout/': {
      id: '/_auth/demand-planning/fashion/$collectionId/_layout/'
      path: '/'
      fullPath: '/demand-planning/fashion/$collectionId/'
      preLoaderRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutIndexRouteImport
      parentRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutRoute
    }
    '/_auth/demand-planning/fashion/$collectionId/_layout/analysis': {
      id: '/_auth/demand-planning/fashion/$collectionId/_layout/analysis'
      path: '/analysis'
      fullPath: '/demand-planning/fashion/$collectionId/analysis'
      preLoaderRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutAnalysisRouteImport
      parentRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutRoute
    }
    '/_auth/demand-planning/fashion/$collectionId/_layout/customers': {
      id: '/_auth/demand-planning/fashion/$collectionId/_layout/customers'
      path: '/customers'
      fullPath: '/demand-planning/fashion/$collectionId/customers'
      preLoaderRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutCustomersRouteImport
      parentRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutRoute
    }
    '/_auth/demand-planning/fashion/$collectionId/_layout/demand': {
      id: '/_auth/demand-planning/fashion/$collectionId/_layout/demand'
      path: '/demand'
      fullPath: '/demand-planning/fashion/$collectionId/demand'
      preLoaderRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutDemandRouteImport
      parentRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutRoute
    }
    '/_auth/demand-planning/fashion/$collectionId/_layout/performance': {
      id: '/_auth/demand-planning/fashion/$collectionId/_layout/performance'
      path: '/performance'
      fullPath: '/demand-planning/fashion/$collectionId/performance'
      preLoaderRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutPerformanceRouteImport
      parentRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutRoute
    }
    '/_auth/demand-planning/fashion/$collectionId/_layout/seasonality': {
      id: '/_auth/demand-planning/fashion/$collectionId/_layout/seasonality'
      path: '/seasonality'
      fullPath: '/demand-planning/fashion/$collectionId/seasonality'
      preLoaderRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutSeasonalityRouteImport
      parentRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutRoute
    }
    '/_auth/demand-planning/fashion/$collectionId/_layout/splits': {
      id: '/_auth/demand-planning/fashion/$collectionId/_layout/splits'
      path: '/splits'
      fullPath: '/demand-planning/fashion/$collectionId/splits'
      preLoaderRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutSplitsRouteImport
      parentRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutRoute
    }
    '/_auth/demand-planning/fashion/$collectionId/_layout/trim': {
      id: '/_auth/demand-planning/fashion/$collectionId/_layout/trim'
      path: '/trim'
      fullPath: '/demand-planning/fashion/$collectionId/trim'
      preLoaderRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutTrimRouteImport
      parentRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutRoute
    }
    '/_auth/demand-planning/noos/$collectionId/_layout/': {
      id: '/_auth/demand-planning/noos/$collectionId/_layout/'
      path: '/'
      fullPath: '/demand-planning/noos/$collectionId/'
      preLoaderRoute: typeof AuthDemandPlanningNoosCollectionIdLayoutIndexRouteImport
      parentRoute: typeof AuthDemandPlanningNoosCollectionIdLayoutRoute
    }
    '/_auth/demand-planning/noos/$collectionId/_layout/forecast-updates': {
      id: '/_auth/demand-planning/noos/$collectionId/_layout/forecast-updates'
      path: '/forecast-updates'
      fullPath: '/demand-planning/noos/$collectionId/forecast-updates'
      preLoaderRoute: typeof AuthDemandPlanningNoosCollectionIdLayoutForecastUpdatesRouteImport
      parentRoute: typeof AuthDemandPlanningNoosCollectionIdLayoutRoute
    }
    '/_auth/demand-planning/noos/$collectionId/_layout/new-variants': {
      id: '/_auth/demand-planning/noos/$collectionId/_layout/new-variants'
      path: '/new-variants'
      fullPath: '/demand-planning/noos/$collectionId/new-variants'
      preLoaderRoute: typeof AuthDemandPlanningNoosCollectionIdLayoutNewVariantsRouteImport
      parentRoute: typeof AuthDemandPlanningNoosCollectionIdLayoutRoute
    }
    '/_auth/demand/fashion/$collectionId/_layout/': {
      id: '/_auth/demand/fashion/$collectionId/_layout/'
      path: '/'
      fullPath: '/demand/fashion/$collectionId/'
      preLoaderRoute: typeof AuthDemandFashionCollectionIdLayoutIndexRouteImport
      parentRoute: typeof AuthDemandFashionCollectionIdLayoutRoute
    }
    '/_auth/demand/fashion/$collectionId/_layout/budget': {
      id: '/_auth/demand/fashion/$collectionId/_layout/budget'
      path: '/budget'
      fullPath: '/demand/fashion/$collectionId/budget'
      preLoaderRoute: typeof AuthDemandFashionCollectionIdLayoutBudgetRouteImport
      parentRoute: typeof AuthDemandFashionCollectionIdLayoutRoute
    }
    '/_auth/demand/fashion/$collectionId/_layout/demand': {
      id: '/_auth/demand/fashion/$collectionId/_layout/demand'
      path: '/demand'
      fullPath: '/demand/fashion/$collectionId/demand'
      preLoaderRoute: typeof AuthDemandFashionCollectionIdLayoutDemandRouteImport
      parentRoute: typeof AuthDemandFashionCollectionIdLayoutRoute
    }
    '/_auth/demand/fashion/$collectionId/_layout/performance': {
      id: '/_auth/demand/fashion/$collectionId/_layout/performance'
      path: '/performance'
      fullPath: '/demand/fashion/$collectionId/performance'
      preLoaderRoute: typeof AuthDemandFashionCollectionIdLayoutPerformanceRouteImport
      parentRoute: typeof AuthDemandFashionCollectionIdLayoutRoute
    }
    '/_auth/demand/fashion/$collectionId/_layout/variants': {
      id: '/_auth/demand/fashion/$collectionId/_layout/variants'
      path: '/variants'
      fullPath: '/demand/fashion/$collectionId/variants'
      preLoaderRoute: typeof AuthDemandFashionCollectionIdLayoutVariantsRouteImport
      parentRoute: typeof AuthDemandFashionCollectionIdLayoutRoute
    }
    '/_auth/demand/noos/$collectionId/_layout/': {
      id: '/_auth/demand/noos/$collectionId/_layout/'
      path: '/'
      fullPath: '/demand/noos/$collectionId/'
      preLoaderRoute: typeof AuthDemandNoosCollectionIdLayoutIndexRouteImport
      parentRoute: typeof AuthDemandNoosCollectionIdLayoutRoute
    }
    '/_auth/demand/noos/$collectionId/_layout/budget': {
      id: '/_auth/demand/noos/$collectionId/_layout/budget'
      path: '/budget'
      fullPath: '/demand/noos/$collectionId/budget'
      preLoaderRoute: typeof AuthDemandNoosCollectionIdLayoutBudgetRouteImport
      parentRoute: typeof AuthDemandNoosCollectionIdLayoutRoute
    }
    '/_auth/demand/noos/$collectionId/_layout/demand': {
      id: '/_auth/demand/noos/$collectionId/_layout/demand'
      path: '/demand'
      fullPath: '/demand/noos/$collectionId/demand'
      preLoaderRoute: typeof AuthDemandNoosCollectionIdLayoutDemandRouteImport
      parentRoute: typeof AuthDemandNoosCollectionIdLayoutRoute
    }
    '/_auth/demand/noos/$collectionId/_layout/performance': {
      id: '/_auth/demand/noos/$collectionId/_layout/performance'
      path: '/performance'
      fullPath: '/demand/noos/$collectionId/performance'
      preLoaderRoute: typeof AuthDemandNoosCollectionIdLayoutPerformanceRouteImport
      parentRoute: typeof AuthDemandNoosCollectionIdLayoutRoute
    }
    '/_auth/demand/noos/$collectionId/_layout/variants': {
      id: '/_auth/demand/noos/$collectionId/_layout/variants'
      path: '/variants'
      fullPath: '/demand/noos/$collectionId/variants'
      preLoaderRoute: typeof AuthDemandNoosCollectionIdLayoutVariantsRouteImport
      parentRoute: typeof AuthDemandNoosCollectionIdLayoutRoute
    }
    '/_auth/internal/feature-flags/$flagKey/_layout/': {
      id: '/_auth/internal/feature-flags/$flagKey/_layout/'
      path: '/'
      fullPath: '/internal/feature-flags/$flagKey/'
      preLoaderRoute: typeof AuthInternalFeatureFlagsFlagKeyLayoutIndexRouteImport
      parentRoute: typeof AuthInternalFeatureFlagsFlagKeyLayoutRoute
    }
    '/_auth/internal/feature-flags/$flagKey/_layout/history': {
      id: '/_auth/internal/feature-flags/$flagKey/_layout/history'
      path: '/history'
      fullPath: '/internal/feature-flags/$flagKey/history'
      preLoaderRoute: typeof AuthInternalFeatureFlagsFlagKeyLayoutHistoryRouteImport
      parentRoute: typeof AuthInternalFeatureFlagsFlagKeyLayoutRoute
    }
    '/_auth/internal/feature-flags/$flagKey/_layout/users': {
      id: '/_auth/internal/feature-flags/$flagKey/_layout/users'
      path: '/users'
      fullPath: '/internal/feature-flags/$flagKey/users'
      preLoaderRoute: typeof AuthInternalFeatureFlagsFlagKeyLayoutUsersRouteImport
      parentRoute: typeof AuthInternalFeatureFlagsFlagKeyLayoutRoute
    }
    '/_auth/procurement/supply-plan/$purchasePlanId/_layout/': {
      id: '/_auth/procurement/supply-plan/$purchasePlanId/_layout/'
      path: '/'
      fullPath: '/procurement/supply-plan/$purchasePlanId/'
      preLoaderRoute: typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutIndexRouteImport
      parentRoute: typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutRoute
    }
    '/_auth/procurement/supply-plan/$purchasePlanId/_layout/capacity': {
      id: '/_auth/procurement/supply-plan/$purchasePlanId/_layout/capacity'
      path: '/capacity'
      fullPath: '/procurement/supply-plan/$purchasePlanId/capacity'
      preLoaderRoute: typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutCapacityRouteImport
      parentRoute: typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutRoute
    }
    '/_auth/procurement/supply-plan/$purchasePlanId/_layout/greige': {
      id: '/_auth/procurement/supply-plan/$purchasePlanId/_layout/greige'
      path: '/greige'
      fullPath: '/procurement/supply-plan/$purchasePlanId/greige'
      preLoaderRoute: typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutGreigeRouteImport
      parentRoute: typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutRoute
    }
    '/_auth/procurement/supply-plan/$purchasePlanId/_layout/quantities': {
      id: '/_auth/procurement/supply-plan/$purchasePlanId/_layout/quantities'
      path: '/quantities'
      fullPath: '/procurement/supply-plan/$purchasePlanId/quantities'
      preLoaderRoute: typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutQuantitiesRouteImport
      parentRoute: typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutRoute
    }
    '/_auth/procurement/supply-plan/collection/$collectionId/_layout': {
      id: '/_auth/procurement/supply-plan/collection/$collectionId/_layout'
      path: '/procurement/supply-plan/collection/$collectionId'
      fullPath: '/procurement/supply-plan/collection/$collectionId'
      preLoaderRoute: typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout': {
      id: '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout'
      path: '/procurement/supply-plan/noos/$supplyPlanId'
      fullPath: '/procurement/supply-plan/noos/$supplyPlanId'
      preLoaderRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/': {
      id: '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/'
      path: '/'
      fullPath: '/budgets/$fiscalYear/$budgetId/'
      preLoaderRoute: typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutIndexRouteImport
      parentRoute: typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutRoute
    }
    '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/allocation-planning': {
      id: '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/allocation-planning'
      path: '/allocation-planning'
      fullPath: '/budgets/$fiscalYear/$budgetId/allocation-planning'
      preLoaderRoute: typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutAllocationPlanningRouteImport
      parentRoute: typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutRoute
    }
    '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/markdown-planning': {
      id: '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/markdown-planning'
      path: '/markdown-planning'
      fullPath: '/budgets/$fiscalYear/$budgetId/markdown-planning'
      preLoaderRoute: typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutMarkdownPlanningRouteImport
      parentRoute: typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutRoute
    }
    '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/sales-prices': {
      id: '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/sales-prices'
      path: '/sales-prices'
      fullPath: '/budgets/$fiscalYear/$budgetId/sales-prices'
      preLoaderRoute: typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutSalesPricesRouteImport
      parentRoute: typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutRoute
    }
    '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/target': {
      id: '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/target'
      path: '/target'
      fullPath: '/budgets/$fiscalYear/$budgetId/target'
      preLoaderRoute: typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutTargetRouteImport
      parentRoute: typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutRoute
    }
    '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/target-report': {
      id: '/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/target-report'
      path: '/target-report'
      fullPath: '/budgets/$fiscalYear/$budgetId/target-report'
      preLoaderRoute: typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutTargetReportRouteImport
      parentRoute: typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutRoute
    }
    '/_auth/procurement/supply-plan/collection/$collectionId/_layout/': {
      id: '/_auth/procurement/supply-plan/collection/$collectionId/_layout/'
      path: '/'
      fullPath: '/procurement/supply-plan/collection/$collectionId/'
      preLoaderRoute: typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutIndexRouteImport
      parentRoute: typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutRoute
    }
    '/_auth/procurement/supply-plan/collection/$collectionId/_layout/capacity': {
      id: '/_auth/procurement/supply-plan/collection/$collectionId/_layout/capacity'
      path: '/capacity'
      fullPath: '/procurement/supply-plan/collection/$collectionId/capacity'
      preLoaderRoute: typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutCapacityRouteImport
      parentRoute: typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutRoute
    }
    '/_auth/procurement/supply-plan/collection/$collectionId/_layout/greige': {
      id: '/_auth/procurement/supply-plan/collection/$collectionId/_layout/greige'
      path: '/greige'
      fullPath: '/procurement/supply-plan/collection/$collectionId/greige'
      preLoaderRoute: typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutGreigeRouteImport
      parentRoute: typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutRoute
    }
    '/_auth/procurement/supply-plan/collection/$collectionId/_layout/overview': {
      id: '/_auth/procurement/supply-plan/collection/$collectionId/_layout/overview'
      path: '/overview'
      fullPath: '/procurement/supply-plan/collection/$collectionId/overview'
      preLoaderRoute: typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutOverviewRouteImport
      parentRoute: typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutRoute
    }
    '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/': {
      id: '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/'
      path: '/'
      fullPath: '/procurement/supply-plan/noos/$supplyPlanId/'
      preLoaderRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutIndexRouteImport
      parentRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRoute
    }
    '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/availability': {
      id: '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/availability'
      path: '/availability'
      fullPath: '/procurement/supply-plan/noos/$supplyPlanId/availability'
      preLoaderRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutAvailabilityRouteImport
      parentRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRoute
    }
    '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/capacity-planning': {
      id: '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/capacity-planning'
      path: '/capacity-planning'
      fullPath: '/procurement/supply-plan/noos/$supplyPlanId/capacity-planning'
      preLoaderRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutCapacityPlanningRouteImport
      parentRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRoute
    }
    '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/greige': {
      id: '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/greige'
      path: '/greige'
      fullPath: '/procurement/supply-plan/noos/$supplyPlanId/greige'
      preLoaderRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutGreigeRouteImport
      parentRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRoute
    }
    '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/overview': {
      id: '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/overview'
      path: '/overview'
      fullPath: '/procurement/supply-plan/noos/$supplyPlanId/overview'
      preLoaderRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutOverviewRouteImport
      parentRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRoute
    }
    '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/triggers': {
      id: '/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/triggers'
      path: '/triggers'
      fullPath: '/procurement/supply-plan/noos/$supplyPlanId/triggers'
      preLoaderRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutTriggersRouteImport
      parentRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRoute
    }
    '/_auth/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/_layout': {
      id: '/_auth/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/_layout'
      path: '/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId'
      fullPath: '/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId'
      preLoaderRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/_layout/': {
      id: '/_auth/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/_layout/'
      path: '/'
      fullPath: '/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/'
      preLoaderRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutIndexRouteImport
      parentRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutRoute
    }
    '/_auth/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/_layout/capacity': {
      id: '/_auth/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/_layout/capacity'
      path: '/capacity'
      fullPath: '/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/capacity'
      preLoaderRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutCapacityRouteImport
      parentRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutRoute
    }
    '/_auth/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/_layout/quantities': {
      id: '/_auth/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/_layout/quantities'
      path: '/quantities'
      fullPath: '/procurement/supply-plan/noos/$supplyPlanId/buys/$buyId/quantities'
      preLoaderRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutQuantitiesRouteImport
      parentRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutRoute
    }
  }
}

interface AuthInternalCustomerManagementLayoutRouteChildren {
  AuthInternalCustomerManagementLayoutOrganizationsRoute: typeof AuthInternalCustomerManagementLayoutOrganizationsRoute
  AuthInternalCustomerManagementLayoutUsersRoute: typeof AuthInternalCustomerManagementLayoutUsersRoute
  AuthInternalCustomerManagementLayoutIndexRoute: typeof AuthInternalCustomerManagementLayoutIndexRoute
}

const AuthInternalCustomerManagementLayoutRouteChildren: AuthInternalCustomerManagementLayoutRouteChildren =
  {
    AuthInternalCustomerManagementLayoutOrganizationsRoute:
      AuthInternalCustomerManagementLayoutOrganizationsRoute,
    AuthInternalCustomerManagementLayoutUsersRoute:
      AuthInternalCustomerManagementLayoutUsersRoute,
    AuthInternalCustomerManagementLayoutIndexRoute:
      AuthInternalCustomerManagementLayoutIndexRoute,
  }

const AuthInternalCustomerManagementLayoutRouteWithChildren =
  AuthInternalCustomerManagementLayoutRoute._addFileChildren(
    AuthInternalCustomerManagementLayoutRouteChildren,
  )

interface AuthInternalCustomerSuccessLayoutRouteChildren {
  AuthInternalCustomerSuccessLayoutHakiUsageRoute: typeof AuthInternalCustomerSuccessLayoutHakiUsageRoute
  AuthInternalCustomerSuccessLayoutImpactRoute: typeof AuthInternalCustomerSuccessLayoutImpactRoute
  AuthInternalCustomerSuccessLayoutUserActivityRoute: typeof AuthInternalCustomerSuccessLayoutUserActivityRoute
  AuthInternalCustomerSuccessLayoutIndexRoute: typeof AuthInternalCustomerSuccessLayoutIndexRoute
}

const AuthInternalCustomerSuccessLayoutRouteChildren: AuthInternalCustomerSuccessLayoutRouteChildren =
  {
    AuthInternalCustomerSuccessLayoutHakiUsageRoute:
      AuthInternalCustomerSuccessLayoutHakiUsageRoute,
    AuthInternalCustomerSuccessLayoutImpactRoute:
      AuthInternalCustomerSuccessLayoutImpactRoute,
    AuthInternalCustomerSuccessLayoutUserActivityRoute:
      AuthInternalCustomerSuccessLayoutUserActivityRoute,
    AuthInternalCustomerSuccessLayoutIndexRoute:
      AuthInternalCustomerSuccessLayoutIndexRoute,
  }

const AuthInternalCustomerSuccessLayoutRouteWithChildren =
  AuthInternalCustomerSuccessLayoutRoute._addFileChildren(
    AuthInternalCustomerSuccessLayoutRouteChildren,
  )

interface AuthInternalDocsLayoutRouteChildren {
  AuthInternalDocsLayoutSlugRoute: typeof AuthInternalDocsLayoutSlugRoute
  AuthInternalDocsLayoutIndexRoute: typeof AuthInternalDocsLayoutIndexRoute
}

const AuthInternalDocsLayoutRouteChildren: AuthInternalDocsLayoutRouteChildren =
  {
    AuthInternalDocsLayoutSlugRoute: AuthInternalDocsLayoutSlugRoute,
    AuthInternalDocsLayoutIndexRoute: AuthInternalDocsLayoutIndexRoute,
  }

const AuthInternalDocsLayoutRouteWithChildren =
  AuthInternalDocsLayoutRoute._addFileChildren(
    AuthInternalDocsLayoutRouteChildren,
  )

interface AuthInternalFeatureFlagsOverviewRouteChildren {
  AuthInternalFeatureFlagsOverviewHistoryRoute: typeof AuthInternalFeatureFlagsOverviewHistoryRoute
  AuthInternalFeatureFlagsOverviewIndexRoute: typeof AuthInternalFeatureFlagsOverviewIndexRoute
}

const AuthInternalFeatureFlagsOverviewRouteChildren: AuthInternalFeatureFlagsOverviewRouteChildren =
  {
    AuthInternalFeatureFlagsOverviewHistoryRoute:
      AuthInternalFeatureFlagsOverviewHistoryRoute,
    AuthInternalFeatureFlagsOverviewIndexRoute:
      AuthInternalFeatureFlagsOverviewIndexRoute,
  }

const AuthInternalFeatureFlagsOverviewRouteWithChildren =
  AuthInternalFeatureFlagsOverviewRoute._addFileChildren(
    AuthInternalFeatureFlagsOverviewRouteChildren,
  )

interface AuthInternalFeatureFlagsFlagKeyLayoutRouteChildren {
  AuthInternalFeatureFlagsFlagKeyLayoutHistoryRoute: typeof AuthInternalFeatureFlagsFlagKeyLayoutHistoryRoute
  AuthInternalFeatureFlagsFlagKeyLayoutUsersRoute: typeof AuthInternalFeatureFlagsFlagKeyLayoutUsersRoute
  AuthInternalFeatureFlagsFlagKeyLayoutIndexRoute: typeof AuthInternalFeatureFlagsFlagKeyLayoutIndexRoute
}

const AuthInternalFeatureFlagsFlagKeyLayoutRouteChildren: AuthInternalFeatureFlagsFlagKeyLayoutRouteChildren =
  {
    AuthInternalFeatureFlagsFlagKeyLayoutHistoryRoute:
      AuthInternalFeatureFlagsFlagKeyLayoutHistoryRoute,
    AuthInternalFeatureFlagsFlagKeyLayoutUsersRoute:
      AuthInternalFeatureFlagsFlagKeyLayoutUsersRoute,
    AuthInternalFeatureFlagsFlagKeyLayoutIndexRoute:
      AuthInternalFeatureFlagsFlagKeyLayoutIndexRoute,
  }

const AuthInternalFeatureFlagsFlagKeyLayoutRouteWithChildren =
  AuthInternalFeatureFlagsFlagKeyLayoutRoute._addFileChildren(
    AuthInternalFeatureFlagsFlagKeyLayoutRouteChildren,
  )

interface AuthInternalRouteChildren {
  AuthInternalOthersRoute: typeof AuthInternalOthersRoute
  AuthInternalTvRoute: typeof AuthInternalTvRoute
  AuthInternalCustomerManagementLayoutRoute: typeof AuthInternalCustomerManagementLayoutRouteWithChildren
  AuthInternalCustomerSuccessLayoutRoute: typeof AuthInternalCustomerSuccessLayoutRouteWithChildren
  AuthInternalDesignSystemGraphsRoute: typeof AuthInternalDesignSystemGraphsRoute
  AuthInternalDevelopmentChartsRoute: typeof AuthInternalDevelopmentChartsRoute
  AuthInternalDevelopmentComponentsRoute: typeof AuthInternalDevelopmentComponentsRoute
  AuthInternalDocsLayoutRoute: typeof AuthInternalDocsLayoutRouteWithChildren
  AuthInternalFeatureFlagsOverviewRoute: typeof AuthInternalFeatureFlagsOverviewRouteWithChildren
  AuthInternalForecastsForecastValidationCheckRoute: typeof AuthInternalForecastsForecastValidationCheckRoute
  AuthInternalForecastsForecastingReportsRoute: typeof AuthInternalForecastsForecastingReportsRoute
  AuthInternalDesignSystemIndexRoute: typeof AuthInternalDesignSystemIndexRoute
  AuthInternalStatusIndexRoute: typeof AuthInternalStatusIndexRoute
  AuthInternalDesignSystemComponentsBadgesRoute: typeof AuthInternalDesignSystemComponentsBadgesRoute
  AuthInternalDesignSystemComponentsBaselineSourceCardRoute: typeof AuthInternalDesignSystemComponentsBaselineSourceCardRoute
  AuthInternalDesignSystemComponentsButtonGroupRoute: typeof AuthInternalDesignSystemComponentsButtonGroupRoute
  AuthInternalDesignSystemComponentsButtonsRoute: typeof AuthInternalDesignSystemComponentsButtonsRoute
  AuthInternalDesignSystemComponentsCheckboxesRoute: typeof AuthInternalDesignSystemComponentsCheckboxesRoute
  AuthInternalDesignSystemComponentsCodeBlockRoute: typeof AuthInternalDesignSystemComponentsCodeBlockRoute
  AuthInternalDesignSystemComponentsCommandBarRoute: typeof AuthInternalDesignSystemComponentsCommandBarRoute
  AuthInternalDesignSystemComponentsDatePickerRoute: typeof AuthInternalDesignSystemComponentsDatePickerRoute
  AuthInternalDesignSystemComponentsEmptyStateRoute: typeof AuthInternalDesignSystemComponentsEmptyStateRoute
  AuthInternalDesignSystemComponentsExpandableCardRoute: typeof AuthInternalDesignSystemComponentsExpandableCardRoute
  AuthInternalDesignSystemComponentsIconToolbarRoute: typeof AuthInternalDesignSystemComponentsIconToolbarRoute
  AuthInternalDesignSystemComponentsInlineAlertRoute: typeof AuthInternalDesignSystemComponentsInlineAlertRoute
  AuthInternalDesignSystemComponentsLinkButtonRoute: typeof AuthInternalDesignSystemComponentsLinkButtonRoute
  AuthInternalDesignSystemComponentsMatrixRoute: typeof AuthInternalDesignSystemComponentsMatrixRoute
  AuthInternalDesignSystemComponentsMessageScrollerRoute: typeof AuthInternalDesignSystemComponentsMessageScrollerRoute
  AuthInternalDesignSystemComponentsProgressBarRoute: typeof AuthInternalDesignSystemComponentsProgressBarRoute
  AuthInternalDesignSystemComponentsRadiosRoute: typeof AuthInternalDesignSystemComponentsRadiosRoute
  AuthInternalDesignSystemComponentsSectionCardRoute: typeof AuthInternalDesignSystemComponentsSectionCardRoute
  AuthInternalDesignSystemComponentsSelectRoute: typeof AuthInternalDesignSystemComponentsSelectRoute
  AuthInternalDesignSystemComponentsStatTileRoute: typeof AuthInternalDesignSystemComponentsStatTileRoute
  AuthInternalDesignSystemComponentsSwitchesRoute: typeof AuthInternalDesignSystemComponentsSwitchesRoute
  AuthInternalDesignSystemComponentsTextInputRoute: typeof AuthInternalDesignSystemComponentsTextInputRoute
  AuthInternalDesignSystemComponentsTextareaRoute: typeof AuthInternalDesignSystemComponentsTextareaRoute
  AuthInternalDesignSystemComponentsToastRoute: typeof AuthInternalDesignSystemComponentsToastRoute
  AuthInternalDesignSystemComponentsTraceRoute: typeof AuthInternalDesignSystemComponentsTraceRoute
  AuthInternalDesignSystemComponentsViewPillRoute: typeof AuthInternalDesignSystemComponentsViewPillRoute
  AuthInternalDesignSystemLegacyComponentsSlugRoute: typeof AuthInternalDesignSystemLegacyComponentsSlugRoute
  AuthInternalDesignSystemPagesInspectorRoute: typeof AuthInternalDesignSystemPagesInspectorRoute
  AuthInternalDesignSystemPagesPagesRoute: typeof AuthInternalDesignSystemPagesPagesRoute
  AuthInternalDesignSystemStylesColorTokensRoute: typeof AuthInternalDesignSystemStylesColorTokensRoute
  AuthInternalDesignSystemStylesTextStylesRoute: typeof AuthInternalDesignSystemStylesTextStylesRoute
  AuthInternalFeatureFlagsFlagKeyLayoutRoute: typeof AuthInternalFeatureFlagsFlagKeyLayoutRouteWithChildren
}

const AuthInternalRouteChildren: AuthInternalRouteChildren = {
  AuthInternalOthersRoute: AuthInternalOthersRoute,
  AuthInternalTvRoute: AuthInternalTvRoute,
  AuthInternalCustomerManagementLayoutRoute:
    AuthInternalCustomerManagementLayoutRouteWithChildren,
  AuthInternalCustomerSuccessLayoutRoute:
    AuthInternalCustomerSuccessLayoutRouteWithChildren,
  AuthInternalDesignSystemGraphsRoute: AuthInternalDesignSystemGraphsRoute,
  AuthInternalDevelopmentChartsRoute: AuthInternalDevelopmentChartsRoute,
  AuthInternalDevelopmentComponentsRoute:
    AuthInternalDevelopmentComponentsRoute,
  AuthInternalDocsLayoutRoute: AuthInternalDocsLayoutRouteWithChildren,
  AuthInternalFeatureFlagsOverviewRoute:
    AuthInternalFeatureFlagsOverviewRouteWithChildren,
  AuthInternalForecastsForecastValidationCheckRoute:
    AuthInternalForecastsForecastValidationCheckRoute,
  AuthInternalForecastsForecastingReportsRoute:
    AuthInternalForecastsForecastingReportsRoute,
  AuthInternalDesignSystemIndexRoute: AuthInternalDesignSystemIndexRoute,
  AuthInternalStatusIndexRoute: AuthInternalStatusIndexRoute,
  AuthInternalDesignSystemComponentsBadgesRoute:
    AuthInternalDesignSystemComponentsBadgesRoute,
  AuthInternalDesignSystemComponentsBaselineSourceCardRoute:
    AuthInternalDesignSystemComponentsBaselineSourceCardRoute,
  AuthInternalDesignSystemComponentsButtonGroupRoute:
    AuthInternalDesignSystemComponentsButtonGroupRoute,
  AuthInternalDesignSystemComponentsButtonsRoute:
    AuthInternalDesignSystemComponentsButtonsRoute,
  AuthInternalDesignSystemComponentsCheckboxesRoute:
    AuthInternalDesignSystemComponentsCheckboxesRoute,
  AuthInternalDesignSystemComponentsCodeBlockRoute:
    AuthInternalDesignSystemComponentsCodeBlockRoute,
  AuthInternalDesignSystemComponentsCommandBarRoute:
    AuthInternalDesignSystemComponentsCommandBarRoute,
  AuthInternalDesignSystemComponentsDatePickerRoute:
    AuthInternalDesignSystemComponentsDatePickerRoute,
  AuthInternalDesignSystemComponentsEmptyStateRoute:
    AuthInternalDesignSystemComponentsEmptyStateRoute,
  AuthInternalDesignSystemComponentsExpandableCardRoute:
    AuthInternalDesignSystemComponentsExpandableCardRoute,
  AuthInternalDesignSystemComponentsIconToolbarRoute:
    AuthInternalDesignSystemComponentsIconToolbarRoute,
  AuthInternalDesignSystemComponentsInlineAlertRoute:
    AuthInternalDesignSystemComponentsInlineAlertRoute,
  AuthInternalDesignSystemComponentsLinkButtonRoute:
    AuthInternalDesignSystemComponentsLinkButtonRoute,
  AuthInternalDesignSystemComponentsMatrixRoute:
    AuthInternalDesignSystemComponentsMatrixRoute,
  AuthInternalDesignSystemComponentsMessageScrollerRoute:
    AuthInternalDesignSystemComponentsMessageScrollerRoute,
  AuthInternalDesignSystemComponentsProgressBarRoute:
    AuthInternalDesignSystemComponentsProgressBarRoute,
  AuthInternalDesignSystemComponentsRadiosRoute:
    AuthInternalDesignSystemComponentsRadiosRoute,
  AuthInternalDesignSystemComponentsSectionCardRoute:
    AuthInternalDesignSystemComponentsSectionCardRoute,
  AuthInternalDesignSystemComponentsSelectRoute:
    AuthInternalDesignSystemComponentsSelectRoute,
  AuthInternalDesignSystemComponentsStatTileRoute:
    AuthInternalDesignSystemComponentsStatTileRoute,
  AuthInternalDesignSystemComponentsSwitchesRoute:
    AuthInternalDesignSystemComponentsSwitchesRoute,
  AuthInternalDesignSystemComponentsTextInputRoute:
    AuthInternalDesignSystemComponentsTextInputRoute,
  AuthInternalDesignSystemComponentsTextareaRoute:
    AuthInternalDesignSystemComponentsTextareaRoute,
  AuthInternalDesignSystemComponentsToastRoute:
    AuthInternalDesignSystemComponentsToastRoute,
  AuthInternalDesignSystemComponentsTraceRoute:
    AuthInternalDesignSystemComponentsTraceRoute,
  AuthInternalDesignSystemComponentsViewPillRoute:
    AuthInternalDesignSystemComponentsViewPillRoute,
  AuthInternalDesignSystemLegacyComponentsSlugRoute:
    AuthInternalDesignSystemLegacyComponentsSlugRoute,
  AuthInternalDesignSystemPagesInspectorRoute:
    AuthInternalDesignSystemPagesInspectorRoute,
  AuthInternalDesignSystemPagesPagesRoute:
    AuthInternalDesignSystemPagesPagesRoute,
  AuthInternalDesignSystemStylesColorTokensRoute:
    AuthInternalDesignSystemStylesColorTokensRoute,
  AuthInternalDesignSystemStylesTextStylesRoute:
    AuthInternalDesignSystemStylesTextStylesRoute,
  AuthInternalFeatureFlagsFlagKeyLayoutRoute:
    AuthInternalFeatureFlagsFlagKeyLayoutRouteWithChildren,
}

const AuthInternalRouteWithChildren = AuthInternalRoute._addFileChildren(
  AuthInternalRouteChildren,
)

interface AuthSetupRouteChildren {
  AuthSetupSplatRoute: typeof AuthSetupSplatRoute
}

const AuthSetupRouteChildren: AuthSetupRouteChildren = {
  AuthSetupSplatRoute: AuthSetupSplatRoute,
}

const AuthSetupRouteWithChildren = AuthSetupRoute._addFileChildren(
  AuthSetupRouteChildren,
)

interface AuthAllocationLayoutReportsRouteChildren {
  AuthAllocationLayoutReportsProductsRoute: typeof AuthAllocationLayoutReportsProductsRoute
  AuthAllocationLayoutReportsStoresRoute: typeof AuthAllocationLayoutReportsStoresRoute
  AuthAllocationLayoutReportsIndexRoute: typeof AuthAllocationLayoutReportsIndexRoute
}

const AuthAllocationLayoutReportsRouteChildren: AuthAllocationLayoutReportsRouteChildren =
  {
    AuthAllocationLayoutReportsProductsRoute:
      AuthAllocationLayoutReportsProductsRoute,
    AuthAllocationLayoutReportsStoresRoute:
      AuthAllocationLayoutReportsStoresRoute,
    AuthAllocationLayoutReportsIndexRoute:
      AuthAllocationLayoutReportsIndexRoute,
  }

const AuthAllocationLayoutReportsRouteWithChildren =
  AuthAllocationLayoutReportsRoute._addFileChildren(
    AuthAllocationLayoutReportsRouteChildren,
  )

interface AuthAllocationLayoutSettingsRouteChildren {
  AuthAllocationLayoutSettingsSubTabRoute: typeof AuthAllocationLayoutSettingsSubTabRoute
  AuthAllocationLayoutSettingsIndexRoute: typeof AuthAllocationLayoutSettingsIndexRoute
}

const AuthAllocationLayoutSettingsRouteChildren: AuthAllocationLayoutSettingsRouteChildren =
  {
    AuthAllocationLayoutSettingsSubTabRoute:
      AuthAllocationLayoutSettingsSubTabRoute,
    AuthAllocationLayoutSettingsIndexRoute:
      AuthAllocationLayoutSettingsIndexRoute,
  }

const AuthAllocationLayoutSettingsRouteWithChildren =
  AuthAllocationLayoutSettingsRoute._addFileChildren(
    AuthAllocationLayoutSettingsRouteChildren,
  )

interface AuthAllocationLayoutRouteChildren {
  AuthAllocationLayoutReplenishmentRoute: typeof AuthAllocationLayoutReplenishmentRoute
  AuthAllocationLayoutReportsRoute: typeof AuthAllocationLayoutReportsRouteWithChildren
  AuthAllocationLayoutSettingsRoute: typeof AuthAllocationLayoutSettingsRouteWithChildren
}

const AuthAllocationLayoutRouteChildren: AuthAllocationLayoutRouteChildren = {
  AuthAllocationLayoutReplenishmentRoute:
    AuthAllocationLayoutReplenishmentRoute,
  AuthAllocationLayoutReportsRoute:
    AuthAllocationLayoutReportsRouteWithChildren,
  AuthAllocationLayoutSettingsRoute:
    AuthAllocationLayoutSettingsRouteWithChildren,
}

const AuthAllocationLayoutRouteWithChildren =
  AuthAllocationLayoutRoute._addFileChildren(AuthAllocationLayoutRouteChildren)

interface AuthBudgetsLayoutFiscalYearLayoutRouteChildren {
  AuthBudgetsLayoutFiscalYearLayoutBreakdownRoute: typeof AuthBudgetsLayoutFiscalYearLayoutBreakdownRoute
  AuthBudgetsLayoutFiscalYearLayoutCollectionsRoute: typeof AuthBudgetsLayoutFiscalYearLayoutCollectionsRoute
  AuthBudgetsLayoutFiscalYearLayoutIndexRoute: typeof AuthBudgetsLayoutFiscalYearLayoutIndexRoute
}

const AuthBudgetsLayoutFiscalYearLayoutRouteChildren: AuthBudgetsLayoutFiscalYearLayoutRouteChildren =
  {
    AuthBudgetsLayoutFiscalYearLayoutBreakdownRoute:
      AuthBudgetsLayoutFiscalYearLayoutBreakdownRoute,
    AuthBudgetsLayoutFiscalYearLayoutCollectionsRoute:
      AuthBudgetsLayoutFiscalYearLayoutCollectionsRoute,
    AuthBudgetsLayoutFiscalYearLayoutIndexRoute:
      AuthBudgetsLayoutFiscalYearLayoutIndexRoute,
  }

const AuthBudgetsLayoutFiscalYearLayoutRouteWithChildren =
  AuthBudgetsLayoutFiscalYearLayoutRoute._addFileChildren(
    AuthBudgetsLayoutFiscalYearLayoutRouteChildren,
  )

interface AuthBudgetsLayoutFiscalYearBudgetIdLayoutRouteChildren {
  AuthBudgetsLayoutFiscalYearBudgetIdLayoutAllocationPlanningRoute: typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutAllocationPlanningRoute
  AuthBudgetsLayoutFiscalYearBudgetIdLayoutMarkdownPlanningRoute: typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutMarkdownPlanningRoute
  AuthBudgetsLayoutFiscalYearBudgetIdLayoutSalesPricesRoute: typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutSalesPricesRoute
  AuthBudgetsLayoutFiscalYearBudgetIdLayoutTargetRoute: typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutTargetRoute
  AuthBudgetsLayoutFiscalYearBudgetIdLayoutTargetReportRoute: typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutTargetReportRoute
  AuthBudgetsLayoutFiscalYearBudgetIdLayoutIndexRoute: typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutIndexRoute
}

const AuthBudgetsLayoutFiscalYearBudgetIdLayoutRouteChildren: AuthBudgetsLayoutFiscalYearBudgetIdLayoutRouteChildren =
  {
    AuthBudgetsLayoutFiscalYearBudgetIdLayoutAllocationPlanningRoute:
      AuthBudgetsLayoutFiscalYearBudgetIdLayoutAllocationPlanningRoute,
    AuthBudgetsLayoutFiscalYearBudgetIdLayoutMarkdownPlanningRoute:
      AuthBudgetsLayoutFiscalYearBudgetIdLayoutMarkdownPlanningRoute,
    AuthBudgetsLayoutFiscalYearBudgetIdLayoutSalesPricesRoute:
      AuthBudgetsLayoutFiscalYearBudgetIdLayoutSalesPricesRoute,
    AuthBudgetsLayoutFiscalYearBudgetIdLayoutTargetRoute:
      AuthBudgetsLayoutFiscalYearBudgetIdLayoutTargetRoute,
    AuthBudgetsLayoutFiscalYearBudgetIdLayoutTargetReportRoute:
      AuthBudgetsLayoutFiscalYearBudgetIdLayoutTargetReportRoute,
    AuthBudgetsLayoutFiscalYearBudgetIdLayoutIndexRoute:
      AuthBudgetsLayoutFiscalYearBudgetIdLayoutIndexRoute,
  }

const AuthBudgetsLayoutFiscalYearBudgetIdLayoutRouteWithChildren =
  AuthBudgetsLayoutFiscalYearBudgetIdLayoutRoute._addFileChildren(
    AuthBudgetsLayoutFiscalYearBudgetIdLayoutRouteChildren,
  )

interface AuthBudgetsLayoutFiscalYearRouteRouteChildren {
  AuthBudgetsLayoutFiscalYearLayoutRoute: typeof AuthBudgetsLayoutFiscalYearLayoutRouteWithChildren
  AuthBudgetsLayoutFiscalYearBudgetIdLayoutRoute: typeof AuthBudgetsLayoutFiscalYearBudgetIdLayoutRouteWithChildren
}

const AuthBudgetsLayoutFiscalYearRouteRouteChildren: AuthBudgetsLayoutFiscalYearRouteRouteChildren =
  {
    AuthBudgetsLayoutFiscalYearLayoutRoute:
      AuthBudgetsLayoutFiscalYearLayoutRouteWithChildren,
    AuthBudgetsLayoutFiscalYearBudgetIdLayoutRoute:
      AuthBudgetsLayoutFiscalYearBudgetIdLayoutRouteWithChildren,
  }

const AuthBudgetsLayoutFiscalYearRouteRouteWithChildren =
  AuthBudgetsLayoutFiscalYearRouteRoute._addFileChildren(
    AuthBudgetsLayoutFiscalYearRouteRouteChildren,
  )

interface AuthBudgetsLayoutRouteChildren {
  AuthBudgetsLayoutFiscalYearRouteRoute: typeof AuthBudgetsLayoutFiscalYearRouteRouteWithChildren
  AuthBudgetsLayoutTimelineRoute: typeof AuthBudgetsLayoutTimelineRoute
  AuthBudgetsLayoutIndexRoute: typeof AuthBudgetsLayoutIndexRoute
  AuthBudgetsLayoutYearYearRoute: typeof AuthBudgetsLayoutYearYearRoute
}

const AuthBudgetsLayoutRouteChildren: AuthBudgetsLayoutRouteChildren = {
  AuthBudgetsLayoutFiscalYearRouteRoute:
    AuthBudgetsLayoutFiscalYearRouteRouteWithChildren,
  AuthBudgetsLayoutTimelineRoute: AuthBudgetsLayoutTimelineRoute,
  AuthBudgetsLayoutIndexRoute: AuthBudgetsLayoutIndexRoute,
  AuthBudgetsLayoutYearYearRoute: AuthBudgetsLayoutYearYearRoute,
}

const AuthBudgetsLayoutRouteWithChildren =
  AuthBudgetsLayoutRoute._addFileChildren(AuthBudgetsLayoutRouteChildren)

interface AuthDemandLayoutRouteChildren {
  AuthDemandLayoutCalendarRoute: typeof AuthDemandLayoutCalendarRoute
  AuthDemandLayoutPerformanceRoute: typeof AuthDemandLayoutPerformanceRoute
  AuthDemandLayoutSalesAndDemandRoute: typeof AuthDemandLayoutSalesAndDemandRoute
  AuthDemandLayoutIndexRoute: typeof AuthDemandLayoutIndexRoute
}

const AuthDemandLayoutRouteChildren: AuthDemandLayoutRouteChildren = {
  AuthDemandLayoutCalendarRoute: AuthDemandLayoutCalendarRoute,
  AuthDemandLayoutPerformanceRoute: AuthDemandLayoutPerformanceRoute,
  AuthDemandLayoutSalesAndDemandRoute: AuthDemandLayoutSalesAndDemandRoute,
  AuthDemandLayoutIndexRoute: AuthDemandLayoutIndexRoute,
}

const AuthDemandLayoutRouteWithChildren =
  AuthDemandLayoutRoute._addFileChildren(AuthDemandLayoutRouteChildren)

interface AuthIngestionCockpitLayoutDataQualityRouteChildren {
  AuthIngestionCockpitLayoutDataQualityCheckIdRoute: typeof AuthIngestionCockpitLayoutDataQualityCheckIdRoute
  AuthIngestionCockpitLayoutDataQualityIndexRoute: typeof AuthIngestionCockpitLayoutDataQualityIndexRoute
}

const AuthIngestionCockpitLayoutDataQualityRouteChildren: AuthIngestionCockpitLayoutDataQualityRouteChildren =
  {
    AuthIngestionCockpitLayoutDataQualityCheckIdRoute:
      AuthIngestionCockpitLayoutDataQualityCheckIdRoute,
    AuthIngestionCockpitLayoutDataQualityIndexRoute:
      AuthIngestionCockpitLayoutDataQualityIndexRoute,
  }

const AuthIngestionCockpitLayoutDataQualityRouteWithChildren =
  AuthIngestionCockpitLayoutDataQualityRoute._addFileChildren(
    AuthIngestionCockpitLayoutDataQualityRouteChildren,
  )

interface AuthIngestionCockpitLayoutRouteChildren {
  AuthIngestionCockpitLayoutDataChecksRoute: typeof AuthIngestionCockpitLayoutDataChecksRoute
  AuthIngestionCockpitLayoutDataQualityRoute: typeof AuthIngestionCockpitLayoutDataQualityRouteWithChildren
  AuthIngestionCockpitLayoutViewsRoute: typeof AuthIngestionCockpitLayoutViewsRoute
  AuthIngestionCockpitLayoutIndexRoute: typeof AuthIngestionCockpitLayoutIndexRoute
}

const AuthIngestionCockpitLayoutRouteChildren: AuthIngestionCockpitLayoutRouteChildren =
  {
    AuthIngestionCockpitLayoutDataChecksRoute:
      AuthIngestionCockpitLayoutDataChecksRoute,
    AuthIngestionCockpitLayoutDataQualityRoute:
      AuthIngestionCockpitLayoutDataQualityRouteWithChildren,
    AuthIngestionCockpitLayoutViewsRoute: AuthIngestionCockpitLayoutViewsRoute,
    AuthIngestionCockpitLayoutIndexRoute: AuthIngestionCockpitLayoutIndexRoute,
  }

const AuthIngestionCockpitLayoutRouteWithChildren =
  AuthIngestionCockpitLayoutRoute._addFileChildren(
    AuthIngestionCockpitLayoutRouteChildren,
  )

interface AuthInsightsStudioRouteChildren {
  AuthInsightsStudioReportIdRoute: typeof AuthInsightsStudioReportIdRoute
  AuthInsightsStudioIndexRoute: typeof AuthInsightsStudioIndexRoute
}

const AuthInsightsStudioRouteChildren: AuthInsightsStudioRouteChildren = {
  AuthInsightsStudioReportIdRoute: AuthInsightsStudioReportIdRoute,
  AuthInsightsStudioIndexRoute: AuthInsightsStudioIndexRoute,
}

const AuthInsightsStudioRouteWithChildren =
  AuthInsightsStudioRoute._addFileChildren(AuthInsightsStudioRouteChildren)

interface AuthProductManagementLayoutRouteChildren {
  AuthProductManagementLayoutActiveRoute: typeof AuthProductManagementLayoutActiveRoute
  AuthProductManagementLayoutGhostVariantsRoute: typeof AuthProductManagementLayoutGhostVariantsRoute
  AuthProductManagementLayoutHiddenRoute: typeof AuthProductManagementLayoutHiddenRoute
  AuthProductManagementLayoutInactiveRoute: typeof AuthProductManagementLayoutInactiveRoute
  AuthProductManagementLayoutInboxRoute: typeof AuthProductManagementLayoutInboxRoute
  AuthProductManagementLayoutLinkedVariantsRoute: typeof AuthProductManagementLayoutLinkedVariantsRoute
  AuthProductManagementLayoutNeedsAttentionRoute: typeof AuthProductManagementLayoutNeedsAttentionRoute
  AuthProductManagementLayoutPhasedOutRoute: typeof AuthProductManagementLayoutPhasedOutRoute
  AuthProductManagementLayoutPhasingOutRoute: typeof AuthProductManagementLayoutPhasingOutRoute
  AuthProductManagementLayoutSuggestedActivationsRoute: typeof AuthProductManagementLayoutSuggestedActivationsRoute
}

const AuthProductManagementLayoutRouteChildren: AuthProductManagementLayoutRouteChildren =
  {
    AuthProductManagementLayoutActiveRoute:
      AuthProductManagementLayoutActiveRoute,
    AuthProductManagementLayoutGhostVariantsRoute:
      AuthProductManagementLayoutGhostVariantsRoute,
    AuthProductManagementLayoutHiddenRoute:
      AuthProductManagementLayoutHiddenRoute,
    AuthProductManagementLayoutInactiveRoute:
      AuthProductManagementLayoutInactiveRoute,
    AuthProductManagementLayoutInboxRoute:
      AuthProductManagementLayoutInboxRoute,
    AuthProductManagementLayoutLinkedVariantsRoute:
      AuthProductManagementLayoutLinkedVariantsRoute,
    AuthProductManagementLayoutNeedsAttentionRoute:
      AuthProductManagementLayoutNeedsAttentionRoute,
    AuthProductManagementLayoutPhasedOutRoute:
      AuthProductManagementLayoutPhasedOutRoute,
    AuthProductManagementLayoutPhasingOutRoute:
      AuthProductManagementLayoutPhasingOutRoute,
    AuthProductManagementLayoutSuggestedActivationsRoute:
      AuthProductManagementLayoutSuggestedActivationsRoute,
  }

const AuthProductManagementLayoutRouteWithChildren =
  AuthProductManagementLayoutRoute._addFileChildren(
    AuthProductManagementLayoutRouteChildren,
  )

interface AuthSettingsLayoutInternalRouteChildren {
  AuthSettingsLayoutInternalAlertsRoute: typeof AuthSettingsLayoutInternalAlertsRoute
  AuthSettingsLayoutInternalDemoRoute: typeof AuthSettingsLayoutInternalDemoRoute
  AuthSettingsLayoutInternalHakioRoute: typeof AuthSettingsLayoutInternalHakioRoute
  AuthSettingsLayoutInternalMatchConfigurationRoute: typeof AuthSettingsLayoutInternalMatchConfigurationRoute
  AuthSettingsLayoutInternalNamingRoute: typeof AuthSettingsLayoutInternalNamingRoute
}

const AuthSettingsLayoutInternalRouteChildren: AuthSettingsLayoutInternalRouteChildren =
  {
    AuthSettingsLayoutInternalAlertsRoute:
      AuthSettingsLayoutInternalAlertsRoute,
    AuthSettingsLayoutInternalDemoRoute: AuthSettingsLayoutInternalDemoRoute,
    AuthSettingsLayoutInternalHakioRoute: AuthSettingsLayoutInternalHakioRoute,
    AuthSettingsLayoutInternalMatchConfigurationRoute:
      AuthSettingsLayoutInternalMatchConfigurationRoute,
    AuthSettingsLayoutInternalNamingRoute:
      AuthSettingsLayoutInternalNamingRoute,
  }

const AuthSettingsLayoutInternalRouteWithChildren =
  AuthSettingsLayoutInternalRoute._addFileChildren(
    AuthSettingsLayoutInternalRouteChildren,
  )

interface AuthSettingsLayoutRouteChildren {
  AuthSettingsLayoutInternalRoute: typeof AuthSettingsLayoutInternalRouteWithChildren
  AuthSettingsLayoutAiRoute: typeof AuthSettingsLayoutAiRoute
  AuthSettingsLayoutChannelsRoute: typeof AuthSettingsLayoutChannelsRoute
  AuthSettingsLayoutCustomDataRoute: typeof AuthSettingsLayoutCustomDataRoute
  AuthSettingsLayoutDemandRoute: typeof AuthSettingsLayoutDemandRoute
  AuthSettingsLayoutErpRoute: typeof AuthSettingsLayoutErpRoute
  AuthSettingsLayoutGeneralRoute: typeof AuthSettingsLayoutGeneralRoute
  AuthSettingsLayoutProcurementRoute: typeof AuthSettingsLayoutProcurementRoute
  AuthSettingsLayoutRulesRoute: typeof AuthSettingsLayoutRulesRoute
  AuthSettingsLayoutTeamsRoute: typeof AuthSettingsLayoutTeamsRoute
  AuthSettingsLayoutUsersRoute: typeof AuthSettingsLayoutUsersRoute
}

const AuthSettingsLayoutRouteChildren: AuthSettingsLayoutRouteChildren = {
  AuthSettingsLayoutInternalRoute: AuthSettingsLayoutInternalRouteWithChildren,
  AuthSettingsLayoutAiRoute: AuthSettingsLayoutAiRoute,
  AuthSettingsLayoutChannelsRoute: AuthSettingsLayoutChannelsRoute,
  AuthSettingsLayoutCustomDataRoute: AuthSettingsLayoutCustomDataRoute,
  AuthSettingsLayoutDemandRoute: AuthSettingsLayoutDemandRoute,
  AuthSettingsLayoutErpRoute: AuthSettingsLayoutErpRoute,
  AuthSettingsLayoutGeneralRoute: AuthSettingsLayoutGeneralRoute,
  AuthSettingsLayoutProcurementRoute: AuthSettingsLayoutProcurementRoute,
  AuthSettingsLayoutRulesRoute: AuthSettingsLayoutRulesRoute,
  AuthSettingsLayoutTeamsRoute: AuthSettingsLayoutTeamsRoute,
  AuthSettingsLayoutUsersRoute: AuthSettingsLayoutUsersRoute,
}

const AuthSettingsLayoutRouteWithChildren =
  AuthSettingsLayoutRoute._addFileChildren(AuthSettingsLayoutRouteChildren)

interface AuthDemandPlanningFashionLayoutRouteChildren {
  AuthDemandPlanningFashionLayoutTasksRoute: typeof AuthDemandPlanningFashionLayoutTasksRoute
  AuthDemandPlanningFashionLayoutTimelineRoute: typeof AuthDemandPlanningFashionLayoutTimelineRoute
}

const AuthDemandPlanningFashionLayoutRouteChildren: AuthDemandPlanningFashionLayoutRouteChildren =
  {
    AuthDemandPlanningFashionLayoutTasksRoute:
      AuthDemandPlanningFashionLayoutTasksRoute,
    AuthDemandPlanningFashionLayoutTimelineRoute:
      AuthDemandPlanningFashionLayoutTimelineRoute,
  }

const AuthDemandPlanningFashionLayoutRouteWithChildren =
  AuthDemandPlanningFashionLayoutRoute._addFileChildren(
    AuthDemandPlanningFashionLayoutRouteChildren,
  )

interface AuthDemandPlanningNoosLayoutRouteChildren {
  AuthDemandPlanningNoosLayoutTasksRoute: typeof AuthDemandPlanningNoosLayoutTasksRoute
  AuthDemandPlanningNoosLayoutTimelineRoute: typeof AuthDemandPlanningNoosLayoutTimelineRoute
}

const AuthDemandPlanningNoosLayoutRouteChildren: AuthDemandPlanningNoosLayoutRouteChildren =
  {
    AuthDemandPlanningNoosLayoutTasksRoute:
      AuthDemandPlanningNoosLayoutTasksRoute,
    AuthDemandPlanningNoosLayoutTimelineRoute:
      AuthDemandPlanningNoosLayoutTimelineRoute,
  }

const AuthDemandPlanningNoosLayoutRouteWithChildren =
  AuthDemandPlanningNoosLayoutRoute._addFileChildren(
    AuthDemandPlanningNoosLayoutRouteChildren,
  )

interface AuthInsightsInventoryOverviewLayoutRouteChildren {
  AuthInsightsInventoryOverviewLayoutCalendarRoute: typeof AuthInsightsInventoryOverviewLayoutCalendarRoute
  AuthInsightsInventoryOverviewLayoutIndexRoute: typeof AuthInsightsInventoryOverviewLayoutIndexRoute
}

const AuthInsightsInventoryOverviewLayoutRouteChildren: AuthInsightsInventoryOverviewLayoutRouteChildren =
  {
    AuthInsightsInventoryOverviewLayoutCalendarRoute:
      AuthInsightsInventoryOverviewLayoutCalendarRoute,
    AuthInsightsInventoryOverviewLayoutIndexRoute:
      AuthInsightsInventoryOverviewLayoutIndexRoute,
  }

const AuthInsightsInventoryOverviewLayoutRouteWithChildren =
  AuthInsightsInventoryOverviewLayoutRoute._addFileChildren(
    AuthInsightsInventoryOverviewLayoutRouteChildren,
  )

interface AuthProcurementIncomingOrdersLayoutRouteChildren {
  AuthProcurementIncomingOrdersLayoutCalendarRoute: typeof AuthProcurementIncomingOrdersLayoutCalendarRoute
  AuthProcurementIncomingOrdersLayoutListRoute: typeof AuthProcurementIncomingOrdersLayoutListRoute
  AuthProcurementIncomingOrdersLayoutOverviewRoute: typeof AuthProcurementIncomingOrdersLayoutOverviewRoute
}

const AuthProcurementIncomingOrdersLayoutRouteChildren: AuthProcurementIncomingOrdersLayoutRouteChildren =
  {
    AuthProcurementIncomingOrdersLayoutCalendarRoute:
      AuthProcurementIncomingOrdersLayoutCalendarRoute,
    AuthProcurementIncomingOrdersLayoutListRoute:
      AuthProcurementIncomingOrdersLayoutListRoute,
    AuthProcurementIncomingOrdersLayoutOverviewRoute:
      AuthProcurementIncomingOrdersLayoutOverviewRoute,
  }

const AuthProcurementIncomingOrdersLayoutRouteWithChildren =
  AuthProcurementIncomingOrdersLayoutRoute._addFileChildren(
    AuthProcurementIncomingOrdersLayoutRouteChildren,
  )

interface AuthProcurementOrderSuggestionsLayoutRouteChildren {
  AuthProcurementOrderSuggestionsLayoutReplenishmentSuggestionsRoute: typeof AuthProcurementOrderSuggestionsLayoutReplenishmentSuggestionsRoute
}

const AuthProcurementOrderSuggestionsLayoutRouteChildren: AuthProcurementOrderSuggestionsLayoutRouteChildren =
  {
    AuthProcurementOrderSuggestionsLayoutReplenishmentSuggestionsRoute:
      AuthProcurementOrderSuggestionsLayoutReplenishmentSuggestionsRoute,
  }

const AuthProcurementOrderSuggestionsLayoutRouteWithChildren =
  AuthProcurementOrderSuggestionsLayoutRoute._addFileChildren(
    AuthProcurementOrderSuggestionsLayoutRouteChildren,
  )

interface AuthProcurementPurchaseOrdersLayoutRouteChildren {
  AuthProcurementPurchaseOrdersLayoutArchivedRoute: typeof AuthProcurementPurchaseOrdersLayoutArchivedRoute
  AuthProcurementPurchaseOrdersLayoutClosedRoute: typeof AuthProcurementPurchaseOrdersLayoutClosedRoute
  AuthProcurementPurchaseOrdersLayoutDraftRoute: typeof AuthProcurementPurchaseOrdersLayoutDraftRoute
  AuthProcurementPurchaseOrdersLayoutOpenRoute: typeof AuthProcurementPurchaseOrdersLayoutOpenRoute
}

const AuthProcurementPurchaseOrdersLayoutRouteChildren: AuthProcurementPurchaseOrdersLayoutRouteChildren =
  {
    AuthProcurementPurchaseOrdersLayoutArchivedRoute:
      AuthProcurementPurchaseOrdersLayoutArchivedRoute,
    AuthProcurementPurchaseOrdersLayoutClosedRoute:
      AuthProcurementPurchaseOrdersLayoutClosedRoute,
    AuthProcurementPurchaseOrdersLayoutDraftRoute:
      AuthProcurementPurchaseOrdersLayoutDraftRoute,
    AuthProcurementPurchaseOrdersLayoutOpenRoute:
      AuthProcurementPurchaseOrdersLayoutOpenRoute,
  }

const AuthProcurementPurchaseOrdersLayoutRouteWithChildren =
  AuthProcurementPurchaseOrdersLayoutRoute._addFileChildren(
    AuthProcurementPurchaseOrdersLayoutRouteChildren,
  )

interface AuthProcurementVendorManagementLayoutRouteChildren {
  AuthProcurementVendorManagementLayoutCapacityRoute: typeof AuthProcurementVendorManagementLayoutCapacityRoute
  AuthProcurementVendorManagementLayoutVendorsRoute: typeof AuthProcurementVendorManagementLayoutVendorsRoute
}

const AuthProcurementVendorManagementLayoutRouteChildren: AuthProcurementVendorManagementLayoutRouteChildren =
  {
    AuthProcurementVendorManagementLayoutCapacityRoute:
      AuthProcurementVendorManagementLayoutCapacityRoute,
    AuthProcurementVendorManagementLayoutVendorsRoute:
      AuthProcurementVendorManagementLayoutVendorsRoute,
  }

const AuthProcurementVendorManagementLayoutRouteWithChildren =
  AuthProcurementVendorManagementLayoutRoute._addFileChildren(
    AuthProcurementVendorManagementLayoutRouteChildren,
  )

interface AuthProductProductIdLayoutRouteChildren {
  AuthProductProductIdLayoutDemandRoute: typeof AuthProductProductIdLayoutDemandRoute
  AuthProductProductIdLayoutFinanceRoute: typeof AuthProductProductIdLayoutFinanceRoute
  AuthProductProductIdLayoutForecastRoute: typeof AuthProductProductIdLayoutForecastRoute
  AuthProductProductIdLayoutForecastAnalysisRoute: typeof AuthProductProductIdLayoutForecastAnalysisRoute
  AuthProductProductIdLayoutInventoryRoute: typeof AuthProductProductIdLayoutInventoryRoute
  AuthProductProductIdLayoutOverviewRoute: typeof AuthProductProductIdLayoutOverviewRoute
  AuthProductProductIdLayoutPerformanceRoute: typeof AuthProductProductIdLayoutPerformanceRoute
  AuthProductProductIdLayoutIndexRoute: typeof AuthProductProductIdLayoutIndexRoute
}

const AuthProductProductIdLayoutRouteChildren: AuthProductProductIdLayoutRouteChildren =
  {
    AuthProductProductIdLayoutDemandRoute:
      AuthProductProductIdLayoutDemandRoute,
    AuthProductProductIdLayoutFinanceRoute:
      AuthProductProductIdLayoutFinanceRoute,
    AuthProductProductIdLayoutForecastRoute:
      AuthProductProductIdLayoutForecastRoute,
    AuthProductProductIdLayoutForecastAnalysisRoute:
      AuthProductProductIdLayoutForecastAnalysisRoute,
    AuthProductProductIdLayoutInventoryRoute:
      AuthProductProductIdLayoutInventoryRoute,
    AuthProductProductIdLayoutOverviewRoute:
      AuthProductProductIdLayoutOverviewRoute,
    AuthProductProductIdLayoutPerformanceRoute:
      AuthProductProductIdLayoutPerformanceRoute,
    AuthProductProductIdLayoutIndexRoute: AuthProductProductIdLayoutIndexRoute,
  }

const AuthProductProductIdLayoutRouteWithChildren =
  AuthProductProductIdLayoutRoute._addFileChildren(
    AuthProductProductIdLayoutRouteChildren,
  )

interface AuthDemandPlanningFashionCollectionIdLayoutRouteChildren {
  AuthDemandPlanningFashionCollectionIdLayoutAnalysisRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutAnalysisRoute
  AuthDemandPlanningFashionCollectionIdLayoutCustomersRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutCustomersRoute
  AuthDemandPlanningFashionCollectionIdLayoutDemandRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutDemandRoute
  AuthDemandPlanningFashionCollectionIdLayoutPerformanceRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutPerformanceRoute
  AuthDemandPlanningFashionCollectionIdLayoutSeasonalityRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutSeasonalityRoute
  AuthDemandPlanningFashionCollectionIdLayoutSplitsRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutSplitsRoute
  AuthDemandPlanningFashionCollectionIdLayoutTrimRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutTrimRoute
  AuthDemandPlanningFashionCollectionIdLayoutIndexRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutIndexRoute
}

const AuthDemandPlanningFashionCollectionIdLayoutRouteChildren: AuthDemandPlanningFashionCollectionIdLayoutRouteChildren =
  {
    AuthDemandPlanningFashionCollectionIdLayoutAnalysisRoute:
      AuthDemandPlanningFashionCollectionIdLayoutAnalysisRoute,
    AuthDemandPlanningFashionCollectionIdLayoutCustomersRoute:
      AuthDemandPlanningFashionCollectionIdLayoutCustomersRoute,
    AuthDemandPlanningFashionCollectionIdLayoutDemandRoute:
      AuthDemandPlanningFashionCollectionIdLayoutDemandRoute,
    AuthDemandPlanningFashionCollectionIdLayoutPerformanceRoute:
      AuthDemandPlanningFashionCollectionIdLayoutPerformanceRoute,
    AuthDemandPlanningFashionCollectionIdLayoutSeasonalityRoute:
      AuthDemandPlanningFashionCollectionIdLayoutSeasonalityRoute,
    AuthDemandPlanningFashionCollectionIdLayoutSplitsRoute:
      AuthDemandPlanningFashionCollectionIdLayoutSplitsRoute,
    AuthDemandPlanningFashionCollectionIdLayoutTrimRoute:
      AuthDemandPlanningFashionCollectionIdLayoutTrimRoute,
    AuthDemandPlanningFashionCollectionIdLayoutIndexRoute:
      AuthDemandPlanningFashionCollectionIdLayoutIndexRoute,
  }

const AuthDemandPlanningFashionCollectionIdLayoutRouteWithChildren =
  AuthDemandPlanningFashionCollectionIdLayoutRoute._addFileChildren(
    AuthDemandPlanningFashionCollectionIdLayoutRouteChildren,
  )

interface AuthDemandPlanningNoosCollectionIdLayoutRouteChildren {
  AuthDemandPlanningNoosCollectionIdLayoutForecastUpdatesRoute: typeof AuthDemandPlanningNoosCollectionIdLayoutForecastUpdatesRoute
  AuthDemandPlanningNoosCollectionIdLayoutNewVariantsRoute: typeof AuthDemandPlanningNoosCollectionIdLayoutNewVariantsRoute
  AuthDemandPlanningNoosCollectionIdLayoutIndexRoute: typeof AuthDemandPlanningNoosCollectionIdLayoutIndexRoute
}

const AuthDemandPlanningNoosCollectionIdLayoutRouteChildren: AuthDemandPlanningNoosCollectionIdLayoutRouteChildren =
  {
    AuthDemandPlanningNoosCollectionIdLayoutForecastUpdatesRoute:
      AuthDemandPlanningNoosCollectionIdLayoutForecastUpdatesRoute,
    AuthDemandPlanningNoosCollectionIdLayoutNewVariantsRoute:
      AuthDemandPlanningNoosCollectionIdLayoutNewVariantsRoute,
    AuthDemandPlanningNoosCollectionIdLayoutIndexRoute:
      AuthDemandPlanningNoosCollectionIdLayoutIndexRoute,
  }

const AuthDemandPlanningNoosCollectionIdLayoutRouteWithChildren =
  AuthDemandPlanningNoosCollectionIdLayoutRoute._addFileChildren(
    AuthDemandPlanningNoosCollectionIdLayoutRouteChildren,
  )

interface AuthDemandFashionCollectionIdLayoutRouteChildren {
  AuthDemandFashionCollectionIdLayoutBudgetRoute: typeof AuthDemandFashionCollectionIdLayoutBudgetRoute
  AuthDemandFashionCollectionIdLayoutDemandRoute: typeof AuthDemandFashionCollectionIdLayoutDemandRoute
  AuthDemandFashionCollectionIdLayoutPerformanceRoute: typeof AuthDemandFashionCollectionIdLayoutPerformanceRoute
  AuthDemandFashionCollectionIdLayoutVariantsRoute: typeof AuthDemandFashionCollectionIdLayoutVariantsRoute
  AuthDemandFashionCollectionIdLayoutIndexRoute: typeof AuthDemandFashionCollectionIdLayoutIndexRoute
}

const AuthDemandFashionCollectionIdLayoutRouteChildren: AuthDemandFashionCollectionIdLayoutRouteChildren =
  {
    AuthDemandFashionCollectionIdLayoutBudgetRoute:
      AuthDemandFashionCollectionIdLayoutBudgetRoute,
    AuthDemandFashionCollectionIdLayoutDemandRoute:
      AuthDemandFashionCollectionIdLayoutDemandRoute,
    AuthDemandFashionCollectionIdLayoutPerformanceRoute:
      AuthDemandFashionCollectionIdLayoutPerformanceRoute,
    AuthDemandFashionCollectionIdLayoutVariantsRoute:
      AuthDemandFashionCollectionIdLayoutVariantsRoute,
    AuthDemandFashionCollectionIdLayoutIndexRoute:
      AuthDemandFashionCollectionIdLayoutIndexRoute,
  }

const AuthDemandFashionCollectionIdLayoutRouteWithChildren =
  AuthDemandFashionCollectionIdLayoutRoute._addFileChildren(
    AuthDemandFashionCollectionIdLayoutRouteChildren,
  )

interface AuthDemandNoosCollectionIdLayoutRouteChildren {
  AuthDemandNoosCollectionIdLayoutBudgetRoute: typeof AuthDemandNoosCollectionIdLayoutBudgetRoute
  AuthDemandNoosCollectionIdLayoutDemandRoute: typeof AuthDemandNoosCollectionIdLayoutDemandRoute
  AuthDemandNoosCollectionIdLayoutPerformanceRoute: typeof AuthDemandNoosCollectionIdLayoutPerformanceRoute
  AuthDemandNoosCollectionIdLayoutVariantsRoute: typeof AuthDemandNoosCollectionIdLayoutVariantsRoute
  AuthDemandNoosCollectionIdLayoutIndexRoute: typeof AuthDemandNoosCollectionIdLayoutIndexRoute
}

const AuthDemandNoosCollectionIdLayoutRouteChildren: AuthDemandNoosCollectionIdLayoutRouteChildren =
  {
    AuthDemandNoosCollectionIdLayoutBudgetRoute:
      AuthDemandNoosCollectionIdLayoutBudgetRoute,
    AuthDemandNoosCollectionIdLayoutDemandRoute:
      AuthDemandNoosCollectionIdLayoutDemandRoute,
    AuthDemandNoosCollectionIdLayoutPerformanceRoute:
      AuthDemandNoosCollectionIdLayoutPerformanceRoute,
    AuthDemandNoosCollectionIdLayoutVariantsRoute:
      AuthDemandNoosCollectionIdLayoutVariantsRoute,
    AuthDemandNoosCollectionIdLayoutIndexRoute:
      AuthDemandNoosCollectionIdLayoutIndexRoute,
  }

const AuthDemandNoosCollectionIdLayoutRouteWithChildren =
  AuthDemandNoosCollectionIdLayoutRoute._addFileChildren(
    AuthDemandNoosCollectionIdLayoutRouteChildren,
  )

interface AuthProcurementSupplyPlanPurchasePlanIdLayoutRouteChildren {
  AuthProcurementSupplyPlanPurchasePlanIdLayoutCapacityRoute: typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutCapacityRoute
  AuthProcurementSupplyPlanPurchasePlanIdLayoutGreigeRoute: typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutGreigeRoute
  AuthProcurementSupplyPlanPurchasePlanIdLayoutQuantitiesRoute: typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutQuantitiesRoute
  AuthProcurementSupplyPlanPurchasePlanIdLayoutIndexRoute: typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutIndexRoute
}

const AuthProcurementSupplyPlanPurchasePlanIdLayoutRouteChildren: AuthProcurementSupplyPlanPurchasePlanIdLayoutRouteChildren =
  {
    AuthProcurementSupplyPlanPurchasePlanIdLayoutCapacityRoute:
      AuthProcurementSupplyPlanPurchasePlanIdLayoutCapacityRoute,
    AuthProcurementSupplyPlanPurchasePlanIdLayoutGreigeRoute:
      AuthProcurementSupplyPlanPurchasePlanIdLayoutGreigeRoute,
    AuthProcurementSupplyPlanPurchasePlanIdLayoutQuantitiesRoute:
      AuthProcurementSupplyPlanPurchasePlanIdLayoutQuantitiesRoute,
    AuthProcurementSupplyPlanPurchasePlanIdLayoutIndexRoute:
      AuthProcurementSupplyPlanPurchasePlanIdLayoutIndexRoute,
  }

const AuthProcurementSupplyPlanPurchasePlanIdLayoutRouteWithChildren =
  AuthProcurementSupplyPlanPurchasePlanIdLayoutRoute._addFileChildren(
    AuthProcurementSupplyPlanPurchasePlanIdLayoutRouteChildren,
  )

interface AuthProcurementSupplyPlanCollectionCollectionIdLayoutRouteChildren {
  AuthProcurementSupplyPlanCollectionCollectionIdLayoutCapacityRoute: typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutCapacityRoute
  AuthProcurementSupplyPlanCollectionCollectionIdLayoutGreigeRoute: typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutGreigeRoute
  AuthProcurementSupplyPlanCollectionCollectionIdLayoutOverviewRoute: typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutOverviewRoute
  AuthProcurementSupplyPlanCollectionCollectionIdLayoutIndexRoute: typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutIndexRoute
}

const AuthProcurementSupplyPlanCollectionCollectionIdLayoutRouteChildren: AuthProcurementSupplyPlanCollectionCollectionIdLayoutRouteChildren =
  {
    AuthProcurementSupplyPlanCollectionCollectionIdLayoutCapacityRoute:
      AuthProcurementSupplyPlanCollectionCollectionIdLayoutCapacityRoute,
    AuthProcurementSupplyPlanCollectionCollectionIdLayoutGreigeRoute:
      AuthProcurementSupplyPlanCollectionCollectionIdLayoutGreigeRoute,
    AuthProcurementSupplyPlanCollectionCollectionIdLayoutOverviewRoute:
      AuthProcurementSupplyPlanCollectionCollectionIdLayoutOverviewRoute,
    AuthProcurementSupplyPlanCollectionCollectionIdLayoutIndexRoute:
      AuthProcurementSupplyPlanCollectionCollectionIdLayoutIndexRoute,
  }

const AuthProcurementSupplyPlanCollectionCollectionIdLayoutRouteWithChildren =
  AuthProcurementSupplyPlanCollectionCollectionIdLayoutRoute._addFileChildren(
    AuthProcurementSupplyPlanCollectionCollectionIdLayoutRouteChildren,
  )

interface AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRouteChildren {
  AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutAvailabilityRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutAvailabilityRoute
  AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutCapacityPlanningRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutCapacityPlanningRoute
  AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutGreigeRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutGreigeRoute
  AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutOverviewRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutOverviewRoute
  AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutTriggersRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutTriggersRoute
  AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutIndexRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutIndexRoute
}

const AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRouteChildren: AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRouteChildren =
  {
    AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutAvailabilityRoute:
      AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutAvailabilityRoute,
    AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutCapacityPlanningRoute:
      AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutCapacityPlanningRoute,
    AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutGreigeRoute:
      AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutGreigeRoute,
    AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutOverviewRoute:
      AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutOverviewRoute,
    AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutTriggersRoute:
      AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutTriggersRoute,
    AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutIndexRoute:
      AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutIndexRoute,
  }

const AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRouteWithChildren =
  AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRoute._addFileChildren(
    AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRouteChildren,
  )

interface AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutRouteChildren {
  AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutCapacityRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutCapacityRoute
  AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutQuantitiesRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutQuantitiesRoute
  AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutIndexRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutIndexRoute
}

const AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutRouteChildren: AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutRouteChildren =
  {
    AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutCapacityRoute:
      AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutCapacityRoute,
    AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutQuantitiesRoute:
      AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutQuantitiesRoute,
    AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutIndexRoute:
      AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutIndexRoute,
  }

const AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutRouteWithChildren =
  AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutRoute._addFileChildren(
    AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutRouteChildren,
  )

interface AuthRouteChildren {
  AuthHomeRoute: typeof AuthHomeRoute
  AuthInboxRoute: typeof AuthInboxRoute
  AuthInternalRoute: typeof AuthInternalRouteWithChildren
  AuthReportingRoute: typeof AuthReportingRoute
  AuthSetupRoute: typeof AuthSetupRouteWithChildren
  AuthIndexRoute: typeof AuthIndexRoute
  AuthAllocationLayoutRoute: typeof AuthAllocationLayoutRouteWithChildren
  AuthBudgetsLayoutRoute: typeof AuthBudgetsLayoutRouteWithChildren
  AuthDemandLayoutRoute: typeof AuthDemandLayoutRouteWithChildren
  AuthForecastingLayoutRoute: typeof AuthForecastingLayoutRoute
  AuthIngestionCockpitLayoutRoute: typeof AuthIngestionCockpitLayoutRouteWithChildren
  AuthInsightsAvailabilityRoute: typeof AuthInsightsAvailabilityRoute
  AuthInsightsCustomerInsightsRoute: typeof AuthInsightsCustomerInsightsRoute
  AuthInsightsForecastCalendarRoute: typeof AuthInsightsForecastCalendarRoute
  AuthInsightsStudioRoute: typeof AuthInsightsStudioRouteWithChildren
  AuthProductManagementLayoutRoute: typeof AuthProductManagementLayoutRouteWithChildren
  AuthSettingsLayoutRoute: typeof AuthSettingsLayoutRouteWithChildren
  AuthSettingsCompanyRoute: typeof AuthSettingsCompanyRoute
  AuthSettingsPurchaseOrdersRoute: typeof AuthSettingsPurchaseOrdersRoute
  AuthSettingsReturnsRoute: typeof AuthSettingsReturnsRoute
  AuthAllocationIndexRoute: typeof AuthAllocationIndexRoute
  AuthCollectionManagementIndexRoute: typeof AuthCollectionManagementIndexRoute
  AuthDataValidationIndexRoute: typeof AuthDataValidationIndexRoute
  AuthDemandPlanningIndexRoute: typeof AuthDemandPlanningIndexRoute
  AuthForecastingIndexRoute: typeof AuthForecastingIndexRoute
  AuthInsightsIndexRoute: typeof AuthInsightsIndexRoute
  AuthMarketStrategyIndexRoute: typeof AuthMarketStrategyIndexRoute
  AuthProcurementIndexRoute: typeof AuthProcurementIndexRoute
  AuthProductManagementIndexRoute: typeof AuthProductManagementIndexRoute
  AuthPrototypeIndexRoute: typeof AuthPrototypeIndexRoute
  AuthSettingsIndexRoute: typeof AuthSettingsIndexRoute
  AuthDemandPlanningFashionLayoutRoute: typeof AuthDemandPlanningFashionLayoutRouteWithChildren
  AuthDemandPlanningNoosLayoutRoute: typeof AuthDemandPlanningNoosLayoutRouteWithChildren
  AuthInsightsInventoryOverviewLayoutRoute: typeof AuthInsightsInventoryOverviewLayoutRouteWithChildren
  AuthProcurementIncomingOrdersLayoutRoute: typeof AuthProcurementIncomingOrdersLayoutRouteWithChildren
  AuthProcurementOrderSuggestionsLayoutRoute: typeof AuthProcurementOrderSuggestionsLayoutRouteWithChildren
  AuthProcurementPurchaseOrdersLayoutRoute: typeof AuthProcurementPurchaseOrdersLayoutRouteWithChildren
  AuthProcurementPurchaseOrdersCreateRoute: typeof AuthProcurementPurchaseOrdersCreateRoute
  AuthProcurementVendorManagementVendorIdRoute: typeof AuthProcurementVendorManagementVendorIdRoute
  AuthProcurementVendorManagementLayoutRoute: typeof AuthProcurementVendorManagementLayoutRouteWithChildren
  AuthProductProductIdLayoutRoute: typeof AuthProductProductIdLayoutRouteWithChildren
  AuthPrototypeAllocationPlanningSplatRoute: typeof AuthPrototypeAllocationPlanningSplatRoute
  AuthDemandPlanningFashionIndexRoute: typeof AuthDemandPlanningFashionIndexRoute
  AuthDemandPlanningNoosIndexRoute: typeof AuthDemandPlanningNoosIndexRoute
  AuthProcurementIncomingOrdersIndexRoute: typeof AuthProcurementIncomingOrdersIndexRoute
  AuthProcurementOrderSuggestionsIndexRoute: typeof AuthProcurementOrderSuggestionsIndexRoute
  AuthProcurementPurchaseOrdersIndexRoute: typeof AuthProcurementPurchaseOrdersIndexRoute
  AuthProcurementSupplyPlanIndexRoute: typeof AuthProcurementSupplyPlanIndexRoute
  AuthProcurementVendorManagementIndexRoute: typeof AuthProcurementVendorManagementIndexRoute
  AuthPrototypeSeasonsCollectionsIndexRoute: typeof AuthPrototypeSeasonsCollectionsIndexRoute
  AuthDemandPlanningFashionCollectionIdLayoutRoute: typeof AuthDemandPlanningFashionCollectionIdLayoutRouteWithChildren
  AuthDemandPlanningNoosCollectionIdLayoutRoute: typeof AuthDemandPlanningNoosCollectionIdLayoutRouteWithChildren
  AuthDemandFashionCollectionIdLayoutRoute: typeof AuthDemandFashionCollectionIdLayoutRouteWithChildren
  AuthDemandNoosCollectionIdLayoutRoute: typeof AuthDemandNoosCollectionIdLayoutRouteWithChildren
  AuthProcurementPurchaseOrdersUpdatePurchaseOrderIdRoute: typeof AuthProcurementPurchaseOrdersUpdatePurchaseOrderIdRoute
  AuthProcurementSupplyPlanPurchasePlanIdLayoutRoute: typeof AuthProcurementSupplyPlanPurchasePlanIdLayoutRouteWithChildren
  AuthProcurementSupplyPlanCollectionCollectionIdLayoutRoute: typeof AuthProcurementSupplyPlanCollectionCollectionIdLayoutRouteWithChildren
  AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRouteWithChildren
  AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutRoute: typeof AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthHomeRoute: AuthHomeRoute,
  AuthInboxRoute: AuthInboxRoute,
  AuthInternalRoute: AuthInternalRouteWithChildren,
  AuthReportingRoute: AuthReportingRoute,
  AuthSetupRoute: AuthSetupRouteWithChildren,
  AuthIndexRoute: AuthIndexRoute,
  AuthAllocationLayoutRoute: AuthAllocationLayoutRouteWithChildren,
  AuthBudgetsLayoutRoute: AuthBudgetsLayoutRouteWithChildren,
  AuthDemandLayoutRoute: AuthDemandLayoutRouteWithChildren,
  AuthForecastingLayoutRoute: AuthForecastingLayoutRoute,
  AuthIngestionCockpitLayoutRoute: AuthIngestionCockpitLayoutRouteWithChildren,
  AuthInsightsAvailabilityRoute: AuthInsightsAvailabilityRoute,
  AuthInsightsCustomerInsightsRoute: AuthInsightsCustomerInsightsRoute,
  AuthInsightsForecastCalendarRoute: AuthInsightsForecastCalendarRoute,
  AuthInsightsStudioRoute: AuthInsightsStudioRouteWithChildren,
  AuthProductManagementLayoutRoute:
    AuthProductManagementLayoutRouteWithChildren,
  AuthSettingsLayoutRoute: AuthSettingsLayoutRouteWithChildren,
  AuthSettingsCompanyRoute: AuthSettingsCompanyRoute,
  AuthSettingsPurchaseOrdersRoute: AuthSettingsPurchaseOrdersRoute,
  AuthSettingsReturnsRoute: AuthSettingsReturnsRoute,
  AuthAllocationIndexRoute: AuthAllocationIndexRoute,
  AuthCollectionManagementIndexRoute: AuthCollectionManagementIndexRoute,
  AuthDataValidationIndexRoute: AuthDataValidationIndexRoute,
  AuthDemandPlanningIndexRoute: AuthDemandPlanningIndexRoute,
  AuthForecastingIndexRoute: AuthForecastingIndexRoute,
  AuthInsightsIndexRoute: AuthInsightsIndexRoute,
  AuthMarketStrategyIndexRoute: AuthMarketStrategyIndexRoute,
  AuthProcurementIndexRoute: AuthProcurementIndexRoute,
  AuthProductManagementIndexRoute: AuthProductManagementIndexRoute,
  AuthPrototypeIndexRoute: AuthPrototypeIndexRoute,
  AuthSettingsIndexRoute: AuthSettingsIndexRoute,
  AuthDemandPlanningFashionLayoutRoute:
    AuthDemandPlanningFashionLayoutRouteWithChildren,
  AuthDemandPlanningNoosLayoutRoute:
    AuthDemandPlanningNoosLayoutRouteWithChildren,
  AuthInsightsInventoryOverviewLayoutRoute:
    AuthInsightsInventoryOverviewLayoutRouteWithChildren,
  AuthProcurementIncomingOrdersLayoutRoute:
    AuthProcurementIncomingOrdersLayoutRouteWithChildren,
  AuthProcurementOrderSuggestionsLayoutRoute:
    AuthProcurementOrderSuggestionsLayoutRouteWithChildren,
  AuthProcurementPurchaseOrdersLayoutRoute:
    AuthProcurementPurchaseOrdersLayoutRouteWithChildren,
  AuthProcurementPurchaseOrdersCreateRoute:
    AuthProcurementPurchaseOrdersCreateRoute,
  AuthProcurementVendorManagementVendorIdRoute:
    AuthProcurementVendorManagementVendorIdRoute,
  AuthProcurementVendorManagementLayoutRoute:
    AuthProcurementVendorManagementLayoutRouteWithChildren,
  AuthProductProductIdLayoutRoute: AuthProductProductIdLayoutRouteWithChildren,
  AuthPrototypeAllocationPlanningSplatRoute:
    AuthPrototypeAllocationPlanningSplatRoute,
  AuthDemandPlanningFashionIndexRoute: AuthDemandPlanningFashionIndexRoute,
  AuthDemandPlanningNoosIndexRoute: AuthDemandPlanningNoosIndexRoute,
  AuthProcurementIncomingOrdersIndexRoute:
    AuthProcurementIncomingOrdersIndexRoute,
  AuthProcurementOrderSuggestionsIndexRoute:
    AuthProcurementOrderSuggestionsIndexRoute,
  AuthProcurementPurchaseOrdersIndexRoute:
    AuthProcurementPurchaseOrdersIndexRoute,
  AuthProcurementSupplyPlanIndexRoute: AuthProcurementSupplyPlanIndexRoute,
  AuthProcurementVendorManagementIndexRoute:
    AuthProcurementVendorManagementIndexRoute,
  AuthPrototypeSeasonsCollectionsIndexRoute:
    AuthPrototypeSeasonsCollectionsIndexRoute,
  AuthDemandPlanningFashionCollectionIdLayoutRoute:
    AuthDemandPlanningFashionCollectionIdLayoutRouteWithChildren,
  AuthDemandPlanningNoosCollectionIdLayoutRoute:
    AuthDemandPlanningNoosCollectionIdLayoutRouteWithChildren,
  AuthDemandFashionCollectionIdLayoutRoute:
    AuthDemandFashionCollectionIdLayoutRouteWithChildren,
  AuthDemandNoosCollectionIdLayoutRoute:
    AuthDemandNoosCollectionIdLayoutRouteWithChildren,
  AuthProcurementPurchaseOrdersUpdatePurchaseOrderIdRoute:
    AuthProcurementPurchaseOrdersUpdatePurchaseOrderIdRoute,
  AuthProcurementSupplyPlanPurchasePlanIdLayoutRoute:
    AuthProcurementSupplyPlanPurchasePlanIdLayoutRouteWithChildren,
  AuthProcurementSupplyPlanCollectionCollectionIdLayoutRoute:
    AuthProcurementSupplyPlanCollectionCollectionIdLayoutRouteWithChildren,
  AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRoute:
    AuthProcurementSupplyPlanNoosSupplyPlanIdLayoutRouteWithChildren,
  AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutRoute:
    AuthProcurementSupplyPlanNoosSupplyPlanIdBuysBuyIdLayoutRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  LogoutRoute: LogoutRoute,
  LoginOrgNameRoute: LoginOrgNameRoute,
  LoginIndexRoute: LoginIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
